import axios from "axios";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { BASE_URL, TEST_URL } from "./axios";
import { AddwithWhiteCircle, ArrowBullet, Attachment, CloseEye, DeleteDustbin, DocumentIcon, DropdownArrow, DropdownArrowOption, Eye } from "../../utils/ReusableSVGs";
import { getFileNameFromLink, handleErrorToast, uploadFileInChunks } from "../../utils/ReusableFunctions";
import { useEffect } from "react";
import Select from "react-select";
import { DocumentSection, RenderDateInputField, RenderInputField, RenderInputTextareaField, RenderSelectField } from "../../utils/ReusableInputFormats";
import { toTitleCase } from "../../utils/TextFormattings";
import React from "react";
import axiosInstance from "../../config/axiosInstance";
import { useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import { formattedDateLong } from "../../utils/DateFormattings"



// const AddLetterLinked = ({
//     getProjects,
//     projectList,
//     projectId,
//     contractor,
//     contractorlist,
//     lettertype,
//     letterfor,
//     title,
// }) => {
//     const [oldestYear, setOldestYear] = useState("");
//     const [previousprogressdata, setPreviousProgressData] = useState([]);
//     const [show, setShow] = useState(false);
//     const [errors, setErrors] = useState({});
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     const [inputState, setInputState] = useState({});
//     const [fileNames, setFileNames] = useState([]);
//     const [trackRecordList, setTrackRecordList] = useState([]);
//     const [buffer, setBuffering] = useState(true);
//     const [siteDepartmentList, setSiteDepartmentList] = useState([]);
//     const [contractorlists, setContractorLists] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [uploadProgress, setUploadProgress] = useState(0); // For upload progress
//     const [eotinputState, seteotInputState] = useState({});
//     const [cosinputState, setcosInputState] = useState({});
//     const [eotList, setEotList] = useState([]);
//     const [mileStoneinputState, setmileStoneInputState] = useState({});
//     const [progressInputState, setprogressInputState] = useState({});
//     const [mileStoneList, setmileStoneList] = useState([]);
//     const [progressList, setprogressList] = useState([]);
//     const [mileStoneID, setmileStoneId] = useState("null");
//     const [progressID, setprogressID] = useState("null");
//     const [cosList, setCosList] = useState([]);
//     const [eotID, setEotId] = useState("null");
//     const [cosID, setCosId] = useState("null");
//     const [contractorData, setContractorData] = useState({});
//     const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format




//     const months = [
//         { text: "January", value: 1 },
//         { text: "February", value: 2 },
//         { text: "March", value: 3 },
//         { text: "April", value: 4 },
//         { text: "May", value: 5 },
//         { text: "June", value: 6 },
//         { text: "July", value: 7 },
//         { text: "August", value: 8 },
//         { text: "September", value: 9 },
//         { text: "October", value: 10 },
//         { text: "November", value: 11 },
//         { text: "December", value: 12 },
//     ];

//     const handleShow = () => {
//         setShow(true);
//         getSiteDepartment();
//     };

//     const handleClose = () => {
//         setFileNames("");
//         setErrors("");
//         setShow(false);
//         setFormData({
//             project: projectId ? projectId : "null",
//             letter_num: "",
//             reply_by: "",
//             subject: "",
//             letter_date: "null",
//             status: "pending",
//             workperformedby_contractor: letterfor ? letterfor : "null",
//             lettertype: lettertype ? lettertype : "null",
//             letterExchange: "null",
//             associated_letters: [],
//             associated_letters_status: "pending",
//             letterdepartment: "",
//             letter_from: "null",
//             letter_to: "",
//             documents: [{ document_name: "", document_file: "" }],
//             contractor: contractor ? contractor : "",
//             remarks: '',
//             select: '',
//         })

//         setEOTFormData({
//             project: formData.project ? formData.project : "null",
//             eot_code: "",
//             workperformedby_contractor: formData.workperformedby_contractor ? formData.workperformedby_contractor : "",
//             approved_days: "",
//             approved_date: "",
//             close_letter: "",
//             letter: "",
//             contractor: "",
//             process_initiate_date: "",
//             eot_status: "pending",
//             days: "",
//         });

//         setCOSFormData({
//             project: formData.project ? formData.project : "null",
//             cos_code: "",
//             approval_date: "",
//             contractor: "",
//             process_initiate_date: "",
//             cos_status: "pending",
//             amount: "",
//             workperformedby_contractor: formData.workperformedby_contractor ? formData.workperformedby_contractor : "",
//             letter: "",
//             approved_amount: "",
//             close_letter: "",
//             cos_type: "",
//             negativeamount: "",
//         })

//         setmileStoneFormData({
//             name: "",
//             milestone_date: "",
//             milestone_as_per_reschedule: "",
//             milestone_as_per_actual: "",
//             day: "",
//             rescedule_gap_days: "",
//             actual_gap_days: "",
//             workperformedby_contractor: "contractor",
//             project: formData.project ? formData.project : "null",
//             reschedule_letter: "",
//             contractor: "",
//             actual_letter: "",
//         });

//         setProgressErrors("");
//     };

//     const [formData, setFormData] = useState({
//         project: projectId ? projectId : "null",
//         letter_num: "",
//         reply_by: "",
//         subject: "",
//         letter_date: "null",
//         status: "pending",
//         workperformedby_contractor: letterfor ? letterfor : "null",
//         lettertype: lettertype ? lettertype : "null",
//         letterExchange: "null",
//         associated_letters: [],
//         associated_letters_status: "pending",
//         letterdepartment: "",
//         letter_from: "null",
//         letter_to: "",
//         documents: [{ document_name: "", document_file: "" }],
//         contractor: contractor ? contractor : "",
//         remarks: '',
//         select: '',
//     });

//     // const filteredData = eotList.filter(i => i.id === eotID);
//     const [filteredData, setFilteredData] = useState([]);
//     const [cosFilteredData, setcosFilteredData] = useState([]);
//     const [mileStoneFilteredData, setmileStoneFilteredData] = useState([]);
//     const [progressfilterData, setprogressfilterData] = useState([]);


//     console.log("EOTcoDE")
//     console.log(filteredData[0]?.eot_code);
//     console.log(filteredData)

//     useEffect(() => {
//         setFormData((prev) => ({
//             ...prev,
//             project: projectId
//         }))
//     }, [projectId]);


//     useEffect(() => {
//         setFormData((prev) => ({
//             ...prev,
//             workperformedby_contractor: letterfor
//         }))
//     }, [letterfor]);



//     const [eotFormData, setEOTFormData] = useState({
//         project: formData.project ? formData.project : "null",
//         eot_code: "",
//         workperformedby_contractor: "",
//         approved_days: "",
//         approved_date: "",
//         close_letter: "",
//         letter: "",
//         contractor: "",
//         process_initiate_date: "",
//         eot_status: "pending",
//         days: "",
//     });

//     const [cosFormData, setCOSFormData] = useState({
//         project: formData.project ? formData.project : "null",
//         cos_code: "",
//         approval_date: "",
//         contractor: "",
//         process_initiate_date: "",
//         cos_status: "pending",
//         amount: "",
//         workperformedby_contractor: "",
//         letter: "",
//         approved_amount: "",
//         close_letter: "",
//         cos_type: "",
//         negativeamount: "",
//     })
//     const [mileStoneFormData, setmileStoneFormData] = useState({
//         name: "",
//         milestone_date: "",
//         milestone_as_per_reschedule: "",
//         milestone_as_per_actual: "",
//         day: "",
//         rescedule_gap_days: "",
//         actual_gap_days: "",
//         workperformedby_contractor: "",
//         project: formData.project ? formData.project : "null",
//         reschedule_letter: "",
//         contractor: "",
//         actual_letter: "",
//         mile_stone_type: "null",
//     })

//     const [progressData, setProgressData] = useState({
//         project: formData.project ? formData.project : "null",
//         submitted_financial_progress: "0",
//         submitted_physical_progress: "0",
//         month: "",
//         year: "",
//         submitted_letter: "",
//         contractor,
//         financial_progress: "0",
//         approved_letter: "",
//         physical_progress: "0",
//         date: "null"
//     })


//     const calculateActualDays = (commencementDate, letterDate) => {
//         if (!commencementDate || !letterDate) return null;
//         const startDate = new Date(commencementDate);
//         const endDate = new Date(letterDate);
//         const timeDifference = endDate - startDate;
//         const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
//         return daysDifference;
//     };

//     useEffect(() => {

//         setEotId("null");
//         seteotInputState({});
//         setFormData((prevFormData) => ({
//             ...prevFormData,
//             letter_date: "null",

//         }));
//         setErrors("");
//         setEOTFormData({
//             project: formData.project || "",
//             eot_code: "",
//             workperformedby_contractor: "",
//             approved_days: "",
//             approved_date: "",
//             close_letter: "",
//             letter: "",
//             contractor: "",
//             process_initiate_date: "",
//             eot_status: "pending",
//             days: "",
//         });


//         setCosId("null");
//         setcosInputState({});

//         setCOSFormData({
//             project: formData.project || "",
//             cos_code: "",
//             approval_date: "",
//             contractor: "",
//             process_initiate_date: "",
//             cos_status: "pending",
//             amount: "",
//             workperformedby_contractor: "",
//             letter: "",
//             approved_amount: "",
//             close_letter: "",
//             cos_type: "",
//             negativeamount: "",
//         })

//         setmileStoneId("null");
//         setmileStoneInputState({});
//         setmileStoneFormData({
//             name: "",
//             milestone_date: "",
//             milestone_as_per_reschedule: "",
//             milestone_as_per_actual: "",
//             day: "",
//             rescedule_gap_days: "",
//             actual_gap_days: "",
//             workperformedby_contractor: "",
//             project: formData.project || "",
//             reschedule_letter: "",
//             contractor: "",
//             actual_letter: "",

//         });
//         setprogressID("null");
//         setprogressInputState({})
//         setProgressData({
//             project: formData.project || "",
//             submitted_financial_progress: "0",
//             submitted_physical_progress: "0",
//             month: "",
//             year: "",
//             submitted_letter: "",
//             contractor,
//             financial_progress: "0",
//             approved_letter: "",
//             physical_progress: "0",
//         })



//     }, [formData.workperformedby_contractor, formData.contractor, formData.project, formData.select, formData.lettertype]);

//     useEffect(() => {

//         setEOTFormData({
//             approved_days: "",
//             eot_status: "",
//         });
//         setCOSFormData({
//             approved_amount: "",
//             cos_status: "",
//         });
//         setProgressData((prev) => ({
//             ...prev,
//             month: "",
//             year: "",
//         }))
//         setmileStoneFormData({
//             mile_stone_type: "null",
//         });
//         setFormData((prev) => ({
//             ...prev,
//             letter_date: "null",
//         }));
//     }, [eotID, cosID, mileStoneID, progressID]);


//     useEffect(() => {
//         setFormData((prev) => ({
//             ...prev,
//             lettertype: "null",
//         }))

//     }, [formData.workperformedby_contractor])

//     useEffect(() => {
//         if ((Array.isArray(contractorlist) && contractorlist.length < 0) ||
//             (Array.isArray(contractorlists) && contractorlists.length < 0)) {
//             setFormData((prevFormData) => ({
//                 ...prevFormData,
//                 workperformedby_contractor: "consultant",
//                 contractor: contractor ? contractor : "",
//             }))
//         }
//         else {
//             setFormData((prevFormData) => ({
//                 ...prevFormData,
//                 workperformedby_contractor: letterfor ? letterfor : "null",
//                 contractor: contractor ? contractor : "",
//             }))
//         }
//     }, [formData.project]);



//     useEffect(() => {
//         if (eotID !== "null") {
//             const data = eotList.filter((i) => i.id === eotID);
//             setFilteredData(data);
//         }
//         else if (cosID !== "null") {
//             const data = cosList.filter((i) => i.id === cosID);
//             setcosFilteredData(data);
//         }
//         else if (mileStoneID !== "null") {
//             const data = mileStoneList.filter((i) => i.id === mileStoneID);
//             setmileStoneFilteredData(data);
//         }
//         else if (progressID !== "null") {
//             const data = progressList.filter((i) => i.id === progressID);
//             setprogressfilterData(data);
//         }
//         else {
//             setFilteredData([]);
//             setcosFilteredData([]);
//             setmileStoneFilteredData([]);
//             setprogressfilterData([]);
//         }
//     }, [eotID, eotList, cosID, cosList, mileStoneID, mileStoneList, progressID, progressList]);

//     console.log("filteredData", filteredData);
//     console.log("cosFilteredData", cosFilteredData);


//     useEffect(() => {
//         const days = calculateActualDays(contractorData.commencement_date, formData.letter_date);
//         if (eotID !== "null") {
//             if (filteredData.length > 0) {
//                 const data = filteredData[0];
//                 setEOTFormData((prev) => ({
//                     ...prev,
//                     project: formData.project,
//                     workperformedby_contractor: formData.workperformedby_contractor,
//                     contractor: formData.contractor,
//                     approved_date: formData.letter_date,
//                     process_initiate_date: data?.process_initiate_date,
//                     eot_code: data?.eot_code,
//                     letter: data?.letter,
//                     days: data?.days,
//                     close_letter: data.close_letter ? data?.close_letter : formData?.letter,
//                 }));
//             }
//         }
//         if (cosID !== "null") {
//             if (cosFilteredData.length > 0) {
//                 const data = cosFilteredData[0];
//                 setCOSFormData((prev) => ({
//                     ...prev,
//                     project: formData.project,
//                     workperformedby_contractor: formData.workperformedby_contractor,
//                     contractor: formData.contractor,
//                     approval_date: formData.letter_date,
//                     amount: data?.amount,
//                     process_initiate_date: data?.process_initiate_date,
//                     cos_code: data?.cos_code,
//                     letter: data?.letter,
//                     cos_type: data?.cos_type,
//                     negativeamount: data?.negativeamount,
//                     close_letter: data?.close_letter ? data?.close_letter : formData?.letter,
//                 }));
//             }
//         }
//         if (progressID !== "null") {
//             if (progressfilterData.length > 0) {
//                 const data = progressfilterData[0];
//                 setProgressData((prev) => ({
//                     ...prev,
//                     project: formData.project,
//                     submitted_physical_progress: data?.submitted_physical_progress,
//                     submitted_financial_progress: data?.submitted_financial_progress,
//                     month: data?.month,
//                     year: data?.year,
//                     submitted_letter: data?.submitted_letter,
//                     approved_letter: formData?.letter,
//                     contractor: formData.contractor,
//                     date: formData.date


//                 }));
//             }
//         }
//         if (mileStoneID !== "null" && mileStoneFormData.mile_stone_type === "actual") {
//             if (mileStoneFilteredData.length > 0) {
//                 const data = mileStoneFilteredData[0];
//                 setmileStoneFormData((prev) => ({
//                     ...prev,
//                     project: formData.project,
//                     workperformedby_contractor: formData.workperformedby_contractor,
//                     contractor: formData.contractor,
//                     milestone_as_per_actual: formData.letter_date,
//                     milestone_as_per_reschedule: null,
//                     rescedule_gap_days: "",
//                     actual_gap_days: days,
//                     milestone_date: data?.milestone_date,
//                     name: data?.name,
//                     day: data?.day,
//                     // close_letter: formData?.letter,
//                 }));
//             }
//         }
//         if (mileStoneID !== "null" && mileStoneFormData.mile_stone_type === "reschedule") {
//             if (mileStoneFilteredData.length > 0) {
//                 const data = mileStoneFilteredData[0];
//                 setmileStoneFormData((prev) => ({
//                     ...prev,
//                     project: formData.project,
//                     workperformedby_contractor: formData.workperformedby_contractor,
//                     contractor: formData.contractor,
//                     milestone_as_per_reschedule: formData.letter_date,
//                     milestone_date: data?.milestone_date,
//                     rescedule_gap_days: days,
//                     day: data?.day,
//                     milestone_as_per_actual: null,
//                     actual_gap_days: "",
//                     // close_letter: formData?.letter,
//                 }));
//             }
//         }
//         if (cosFormData.cos_status === "rejected") {
//             setCOSFormData((prev) => ({
//                 ...prev,
//                 approved_amount: "",
//             }))
//         }
//         if (formData.lettertype === "Eot" && eotID === "null") {
//             setEOTFormData((prev) => ({
//                 ...prev,
//                 contractor: formData.contractor,
//                 project: formData.project,
//                 workperformedby_contractor: formData.workperformedby_contractor,
//                 process_initiate_date: formData.letter_date,
//                 approved_date: null,
//                 eot_code: "",
//                 letter: "",
//                 days: "",
//             }));
//         }
//         if (formData.lettertype === 'cos' && cosID === "null") {
//             setCOSFormData((prev) => ({
//                 ...prev,
//                 contractor: formData.contractor,
//                 project: formData.project,
//                 workperformedby_contractor: formData.workperformedby_contractor,
//                 process_initiate_date: formData.letter_date,
//                 approval_date: null,
//                 cos_code: "",
//                 letter: "",
//                 amount: "",
//                 negativeamount: "",
//                 cos_type: "",
//             }))
//         }
//         if (formData.lettertype === 'SiteProgress' && progressID === "null") {
//             setProgressData((prev) => ({
//                 ...prev,
//                 contractor: formData.contractor,
//                 project: formData.project,
//                 submitted_letter: "",
//                 financial_progress: "",
//                 physical_progress: "",
//                 month: "",
//                 year: "",
//                 submitted_physical_progress: "",
//                 submitted_financial_progress: "",
//             }))
//         }
//     }, [formData.project, formData.workperformedby_contractor, formData.contractor, formData.letter_date, formData.select, formData.lettertype, eotID, eotFormData.eot_status, cosID, cosFormData.cos_status, mileStoneID, mileStoneFormData.mile_stone_type, contractorData.commencement_date, progressID]);

//     useEffect(() => {
//         if (cosFormData.cos_type === "positivecos") {

//             setCOSFormData((prev) => ({
//                 ...prev,
//                 negativeamount: "",
//             }));
//         }
//         if (cosFormData.cos_type === "negativecos") {

//             setCOSFormData((prev) => ({
//                 ...prev,
//                 amount: "",
//             }));
//         }
//         else {
//             setCOSFormData((prev) => ({
//                 ...prev,
//                 amount: "",
//                 negativeamount: "",
//             }));
//         }
//     }, [cosFormData.cos_type])

//     useEffect(() => {
//         setFormData((prev) => ({
//             ...prev,
//             letter_date: "null",
//         }));

//         setmileStoneFormData((prev) => ({
//             ...prev,
//             actual_gap_days: "",
//             rescedule_gap_days: "",
//         }))
//     }, [mileStoneFormData.mile_stone_type])

//     useEffect(() => {
//         setFormData((prevData) => ({
//             ...prevData,
//             select: "",
//         }));
//     }, [formData.lettertype]);






//     const validateForm = () => {
//         const requiredFields = [
//             'letter_num',
//             'project',
//             'subject',
//             'letter_date',
//             'status',
//             'lettertype',
//             'workperformedby_contractor',
//             'letterExchange',
//             'letter_to',
//             // 'letterdepartment',
//             // 'letter_from',
//         ];
//         const newErrors = requiredFields.reduce((acc, field) => {
//             if (
//                 !formData[field] ||
//                 formData[field] === "null" ||
//                 (Array.isArray(formData[field]) && formData[field].length === 0)
//             ) {
//                 acc[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
//                     } is required!`;
//             }
//             return acc;
//         }, {});
//         if (formData.workperformedby_contractor === "contractor" && !formData.contractor) {
//             newErrors["contractor"] = "Contractor Name is required!";
//         }
//         if ((formData.lettertype === "Eot" || formData.lettertype === "cos" || formData.lettertype === "Milestone" || formData.lettertype === "SiteProgress") && (!formData.select || formData.select.trim() === "")) {
//             newErrors["select"] = `Select ${formData.lettertype} is required`;
//         }
//         if (formData.select === "new") {
//             if (formData.lettertype === "Eot" && (!eotFormData.eot_code || eotFormData.eot_code.trim() === "")) {
//                 newErrors["eot_code"] = `eot_code is required`;
//             }
//             if (formData.lettertype === "Eot" && (!eotFormData.days || eotFormData.days.trim() === "")) {
//                 newErrors["days"] = `Initiate days are required`;
//             }
//             if (formData.lettertype === "cos" && (!cosFormData.cos_code || cosFormData.cos_code.trim() === "")) {
//                 newErrors["cos_code"] = `cos_code is required`;
//             }
//             if (formData.lettertype === "cos" && (!cosFormData.cos_type || cosFormData.cos_type.trim() === "")) {
//                 newErrors["cos_type"] = `COS Type is required`;
//             }
//             if ((formData.lettertype === "cos" && cosFormData.cos_type === "negativecos") && (!cosFormData.negativeamount || cosFormData.negativeamount.trim() === "")) {
//                 newErrors["negativeamount"] = `Negative Amount is required`;
//             }
//             if ((formData.lettertype === "cos" && cosFormData.cos_type === "negativecos") && (!cosFormData.amount || cosFormData.amount.trim() === "")) {
//                 newErrors["amount"] = `Positive Amount is required`;
//             }
//             if (formData.lettertype === "SiteProgress" && (!progressData.month || progressData.month.trim() === "")) {
//                 newErrors["month"] = `Month is required`;
//             }
//             if (formData.lettertype === "SiteProgress" && (!progressData.year || progressData.year.trim() === "")) {
//                 newErrors["year"] = `Year is required`;
//             }
//             // if (formData.lettertype === "SiteProgress" && (!progressData.submitted_financial_progress || progressData.submitted_financial_progress.trim() === "")) {
//             //   newErrors["submitted_financial_progress"] = `Submitted financial Progress is required`;
//             // }
//             // if (formData.lettertype === "SiteProgress" && (!progressData.submitted_physical_progress || progressData.submitted_physical_progress.trim() === "")) {
//             //   newErrors["submitted_physical_progress"] = `Submitted Physcial Progress is required`;
//             // }
//         }

//         if (formData.select === "existing") {
//             if (formData.lettertype === "Eot" && (eotID === "null")) {
//                 newErrors["eotID"] = `Existing Eot is required`;
//             }
//             if (formData.lettertype === "Eot" && eotID !== "null" && (!eotFormData.eot_status || eotFormData.eot_status.trim() === "")) {
//                 newErrors["eot_status"] = `Eot Status is required`;
//             }
//             if (formData.lettertype === "Eot" && eotID !== "null" && eotFormData.eot_status === "Approved" && (!eotFormData.approved_days || eotFormData.approved_days.trim() === "")) {
//                 newErrors["approved_days"] = `Approved Days is required`;
//             }
//             if (formData.lettertype === "Eot" && eotID !== "null" && (!formData.associated_letters || formData.associated_letters.length === 0)) {
//                 newErrors["associated_letters"] = `Associated Letter  is required`;
//             }
//             if (formData.lettertype === "cos" && (cosID === "null")) {
//                 newErrors["cosID"] = `Existing COS is required`;
//             }
//             if (formData.lettertype === "cos" && cosID !== "null" && (!cosFormData.cos_status || cosFormData.cos_status.trim() === "")) {
//                 newErrors["cos_status"] = `COS Status is required`;
//             }
//             if (formData.lettertype === "cos" && cosID !== "null" && cosFormData.cos_status === "Approved" && (!cosFormData.approved_amount || cosFormData.approved_amount.trim() === "")) {
//                 newErrors["approved_amount"] = `Approved Amount is required`;
//             }
//             if (formData.lettertype === "cos" && cosID !== "null" && (!formData.associated_letters || formData.associated_letters.length === 0)) {
//                 newErrors["associated_letters"] = `Associated Letter  is required`;
//             }
//             if (formData.lettertype === "Milestone" && (mileStoneID === "null")) {
//                 newErrors["mileStoneID"] = `Existing Milestone is required`;
//             }
//             if (formData.lettertype === "Milestone" && mileStoneID !== "null" && (!mileStoneFormData.mile_stone_type || mileStoneFormData.mile_stone_type.trim() === "null")) {
//                 newErrors["mile_stone_type"] = `MileStone Type is required`;
//             }
//             if (formData.lettertype === "SiteProgress" && (progressID === "null")) {
//                 newErrors["progressID"] = `Existing Site Progress is required`;
//             }
//             // if (formData.lettertype === "SiteProgress" && progressID !== "null" && (!progressData.physical_progress || progressData.physical_progress.trim() === "0")) {
//             //   newErrors["physical_progress"] = `Physical Progress is required`;
//             // }
//             // if (formData.lettertype === "SiteProgress" && progressID !== "null" && (!progressData.financial_progress || progressData.financial_progress.trim() === "0")) {
//             //   newErrors["financial_progress"] = `Financial Progress is required`;
//             // }


//         }


//         if (
//             formData.associated_letters &&
//             formData.associated_letters.length > 0 &&
//             !formData.associated_letters_status
//         ) {
//             newErrors["associated_letters_status"] =
//                 "Status for associated letters is required!";
//         }

//         // Validate documents array
//         formData.documents.forEach((doc, index) => {
//             if (!doc.document_name || doc.document_name.trim() === "") {
//                 newErrors[`document_name_${index}`] = `Document Name is required for document ${index + 1}`;
//             }
//             if (!doc.document_file) {
//                 newErrors[`document_file_${index}`] = `Document File is required for document ${index + 1}`;
//             }
//         });

//         setErrors(newErrors);
//         setIsSubmitted(true);
//         return Object.keys(newErrors).length === 0;
//     };

//     console.log("errors");
//     console.log(errors);

//     const getContractorData = async () => {
//         try {
//             const res = await axios.get(`${BASE_URL}/project_details/contractor/${formData.contractor}/`);
//             setContractorData(res.data)
//         } catch (error) {
//             console.error(error);

//         }
//     }

//     useEffect(() => {
//         if (formData.contractor) {
//             getContractorData();
//         }
//     }, [formData.contractor])

//     const handleInputChange = (e) => {
//         const { name, value, type, options } = e.target;

//         let newValue;
//         if (type === "select-multiple") {
//             newValue = Array.from(options)
//                 .filter((option) => option.selected)
//                 .map((option) => option.value);
//         } else {
//             newValue = value;
//         }

//         // Update the input state for validation feedback
//         setInputState((prevState) => ({
//             ...prevState,
//             [name]:
//                 newValue && (Array.isArray(newValue) ? newValue.length > 0 : newValue)
//                     ? "success"
//                     : "",
//         }));

//         // Update form data with additional logic for resetting the contractor field
//         setFormData((prevFormData) => {
//             const updatedFormData = {
//                 ...prevFormData,
//                 [name]: newValue,

//                 // Handle the letter_from logic if reply_by and letterExchange conditions are met
//                 ...(name === "reply_by" &&
//                     prevFormData.letterExchange === "send" && {
//                     letter_from: value,
//                 }),

//                 // Reset contractor if workperformedby_contractor is set to consultant
//                 ...(name === "workperformedby_contractor" &&
//                     value === "consultant" && {
//                     contractor: "",
//                 }),
//             };

//             return updatedFormData;
//         });
//     };

//     const handleEotInputChange = (e) => {
//         const { name, value } = e.target;
//         seteotInputState({
//             ...eotinputState,
//             [name]: value.trim() ? "green" : "",
//         });
//         setEOTFormData({
//             ...eotFormData,
//             [name]: value,
//         });
//     };
//     const handleCOSInputChange = (e) => {
//         const { name, value } = e.target;
//         setcosInputState({
//             ...cosinputState,
//             [name]: value.trim() ? "green" : "",
//         });
//         setCOSFormData({
//             ...cosFormData,
//             [name]: value,
//         });
//     };
//     const handleMilestoneChange = (e) => {
//         const { name, value } = e.target;
//         setmileStoneInputState({
//             ...mileStoneinputState,
//             [name]: value.trim() ? "green" : "",
//         });
//         setmileStoneFormData({
//             ...mileStoneFormData,
//             [name]: value,
//         });
//     };

//     const [progresserrors, setProgressErrors] = useState({
//         submitted_physical_progress: "",
//         submitted_financial_progress: "",
//     });

//     const handleProgressData = (e) => {
//         const { name, value } = e.target;
//         let errorMessage = "";

//         if (name === "submitted_physical_progress") {
//             if (Number(value) < previousprogressdata.physical_progress || Number(value) > 100) {
//                 errorMessage = `Value must be between ${previousprogressdata.physical_progress}% - 100%`;
//             }
//         }
//         if (name === "physical_progress") {
//             if (Number(value) < previousprogressdata.physical_progress || Number(value) > 100) {
//                 errorMessage = `Value must be between ${previousprogressdata.physical_progress}% - 100%`;
//             }
//         }

//         if (name === "financial_progress") {
//             if (Number(value) < previousprogressdata.financial_progress || Number(value) > 100) {
//                 errorMessage = `Value must be between ${previousprogressdata.financial_progress}% - 100%`;
//             }
//         }
//         if (name === "submitted_financial_progress") {
//             if (Number(value) < previousprogressdata.financial_progress || Number(value) > 100) {
//                 errorMessage = `Value must be between ${previousprogressdata.financial_progress}% - 100%`;
//             }
//         }
//         setprogressInputState({
//             ...progressInputState,
//             [name]: value.trim() ? "green" : "",
//         });

//         setProgressData({
//             ...progressData,
//             [name]: value,
//         });

//         setProgressErrors((prevErrors) => ({
//             ...prevErrors,
//             [name]: errorMessage,
//         }));
//     };




//     const handleDocInputChange = (index, e) => {
//         const { name, value, files } = e.target;

//         setFormData((prevFormData) => {
//             const newDocuments = [...prevFormData.documents];
//             newDocuments[index] = {
//                 ...newDocuments[index],
//                 [name]: files ? files[0] : value,
//             };
//             if (files) {
//                 setFileNames((prevFileNames) => {
//                     const newFileNames = [...prevFileNames];
//                     newFileNames[index] = files[0]?.name || "";
//                     return newFileNames;
//                 });
//             }

//             return { ...prevFormData, documents: newDocuments };
//         });
//     };

//     const handleAddDocuments = () => {
//         setFormData((prevFormData) => ({
//             ...prevFormData,
//             documents: [
//                 ...prevFormData.documents,
//                 { document_name: "", document_file: null },
//             ],
//         }));
//     };

//     const handleRemoveDocument = (index) => {
//         setFormData((prevFormData) => ({
//             ...prevFormData,
//             documents: prevFormData.documents.filter((_, i) => i !== index),
//         }));
//         setFileNames((prevFileNames) =>
//             prevFileNames.filter((_, i) => i !== index)
//         );
//     };

//     const createCustomFile = (originalFile) => {
//         const randomCode = generateRandomString();
//         const now = new Date();
//         const date = now.toISOString().split("T")[0];
//         const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
//         const customFileName = `Aimantra ${date} ${time}_${randomCode}_${originalFile.name}`;
//         return new File([originalFile], customFileName, {
//             type: originalFile.type,
//         });
//     };

//     const generateRandomString = () => {
//         const chars =
//             "!@#$%^&*()_+abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
//         return Array.from(
//             { length: 8 },
//             () => chars[Math.floor(Math.random() * chars.length)]
//         ).join("");
//     };

//     const options = trackRecordList
//         .sort((a, b) => parseInt(a.letter_num) - parseInt(b.letter_num))
//         .map((e) => ({
//             value: e.id,
//             label: `${e.letter_num} - ${e.letter_date}`,
//         }));


//     const handleChangecc = (selected) => {
//         const associated_letters =
//             selected.length > 0 ? selected.map((item) => item.value) : "";
//         setFormData((prevState) => ({
//             ...prevState,
//             associated_letters,
//         }));
//     };

//     console.log("cosID");
//     console.log(cosID);
//     // const fetchAssociatedLetters = async () => {
//     //   try {
//     //     const res = await axios.get(
//     //       eotID !== "null" ? `${BASE_URL}/project_details/letterrecordsbyid/${(eotFormData.eot_status === "pending" && eotFormData.close_letter !== "") ? eotFormData.close_letter : eotFormData.letter}/` :
//     //         progressID !== "null" ? `${BASE_URL}/project_details/letterrecordsbyid/${progressData.submitted_letter}/` :
//     //           cosID !== "null" ? `${BASE_URL}/project_details/letterrecordsbyid/${cosFormData.letter}/` :
//     //             `${BASE_URL}/project_details/letterrecordbclosestatus/${formData.project || 'null'
//     //             }/${formData.workperformedby_contractor || 'null'}/${formData.lettertype || 'null'}/`
//     //     );
//     //     setTrackRecordList(res.data);
//     //   } catch (err) {
//     //     console.error("Error fetching letters.", err);
//     //   }
//     // };
//     const fetchAssociatedLetters = async () => {
//         try {
//             let url = "";

//             if (eotID !== "null") {
//                 const letterId =
//                     eotFormData?.close_letter
//                         ? eotFormData.close_letter
//                         : eotFormData?.letter;
//                 url = `${BASE_URL}/project_details/letterrecordsbyid/${letterId}/`;
//             } else if (progressID !== "null") {
//                 url = `${BASE_URL}/project_details/letterrecordsbyid/${progressData?.submitted_letter}/`;
//             } else if (cosID !== "null") {
//                 const letterId =
//                     cosFormData?.close_letter
//                         ? cosFormData.close_letter
//                         : cosFormData?.letter;
//                 url = `${BASE_URL}/project_details/letterrecordsbyid/${letterId}/`;
//             } else {
//                 url = `${BASE_URL}/project_details/letterrecordbclosestatus/${formData.project || 'null'}/${formData.workperformedby_contractor || 'null'}/${formData.lettertype || 'null'}/`;
//             }

//             const res = await axios.get(url);
//             setTrackRecordList(res.data);
//         } catch (err) {
//             console.error("Error fetching letters.", err);
//         }
//     };


//     console.log("eotid")
//     console.log(eotID)
//     const getSiteDepartment = async () => {
//         setBuffering(true); //buffering logic // Start Buffering
//         try {
//             const res = await axios.get(`${BASE_URL}/project_details/department/`);
//             setSiteDepartmentList(res.data);
//         } catch (err) {
//             //toast Logic
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false); //buffering logic // End Buffering
//         }
//     };
//     const getProjectContractorDetails = async () => {
//         try {
//             const contractordetails = await axios.get(
//                 `${BASE_URL}/project_details/contractorbyproject/${formData.project}/`
//             );
//             setContractorLists(contractordetails.data);
//         } catch (err) {
//             // handleErrorToast(err);
//         } finally {
//         }
//     };

//     console.log("progressID")
//     console.log(progressID)

//     const getEot = async () => {

//         try {
//             // let eot = await axios.get(`${BASE_URL}/project_details/eot/`);
//             let eot = await axios.get(`${BASE_URL}/project_details/eotfilter/${formData.project}/${formData.workperformedby_contractor}/${formData.contractor ? formData.contractor : null}/pending/`);
//             setEotList(eot.data);


//         } catch (err) {
//             //toast Logic
//             handleErrorToast(err);
//         } finally {

//         }
//     };
//     const getMilestone = async () => {

//         try {
//             let milestone = await axios.get(`${BASE_URL}/project_details/milestonebycontractor/${formData.contractor}/`);
//             setmileStoneList(milestone.data);


//         } catch (err) {
//             //toast Logic
//             handleErrorToast(err);
//         } finally {

//         }
//     };
//     const getCOS = async () => {

//         try {
//             // let eot = await axios.get(`${BASE_URL}/project_details/eot/`);
//             let cos = await axios.get(`${BASE_URL}/project_details/cosfilter/${formData.project}/${formData.workperformedby_contractor}/${formData.contractor ? formData.contractor : null}/pending/`);
//             setCosList(cos.data);


//         } catch (err) {
//             //toast Logic
//             handleErrorToast(err);
//         } finally {

//         }
//     };
//     const { month, year } = progressData;


//     useEffect(() => {
//         if ((formData.project && formData.workperformedby_contractor) || eotID !== "null" || cosID !== "null" || progressID !== "null") {
//             fetchAssociatedLetters();
//         }
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [formData.project, formData.workperformedby_contractor, formData.lettertype, formData.select, eotID, eotFormData.letter, cosFormData.letter, progressID, progressData.submitted_letter, eotFormData.eot_status, eotFormData.close_letter, cosFormData.close_letter]);


//     useEffect(() => {
//         if (!progressData.submitted_letter) {


//             if (!progressData.month || !progressData.year) {
//                 console.error("Both month and year are required to fetch progress data.");
//                 return;
//             }
//         }

//         const fetchProgressData = async () => {

//             try {
//                 if (year < oldestYear) {
//                     console.warn(`Skipping loop: Year (${year}) is not greater than oldestYear (${oldestYear}).`);
//                     return;
//                 }
//                 let currentMonth = month - 1 === 0 ? 12 : month - 1; // Start with the previous month
//                 let currentYear = month - 1 === 0 ? year - 1 : year; // Adjust year if previous month is December
//                 let dataFound = false; // Flag to check if data is found

//                 while (!dataFound) {
//                     const response = await axios.get(
//                         `${BASE_URL}/project_details/progressbyproject/${formData.project}/${formData.contractor}/${currentMonth}/${currentYear}/`
//                     );

//                     const progressData = response.data;

//                     if (progressData.length > 0) {
//                         // Assuming progressData is an array
//                         const { financial_progress, physical_progress } = progressData[0]; // Take the first item

//                         // Set the values
//                         setPreviousProgressData({
//                             financial_progress,
//                             physical_progress,
//                         });

//                         console.log("Financial Progress:", financial_progress);
//                         console.log("Physical Progress:", physical_progress);

//                         dataFound = true; // Exit the loop
//                     } else {
//                         console.warn(
//                             `No progress data found for ${currentMonth}/${currentYear}. Checking the previous month.`
//                         );

//                         // Move to the previous month
//                         currentMonth -= 1;
//                         if (currentMonth === 0) {
//                             currentMonth = 12;
//                             currentYear -= 1; // Move to the previous year
//                         }

//                         // Stop the loop if we reach an unrealistic limit (e.g., 10 years back)
//                         if (currentYear < year - 1) {
//                             console.error("No data found for the past year.");
//                             break;
//                         }
//                     }
//                 }
//             } catch (error) {
//                 console.error("Error fetching progress data:", error);
//             }
//         };




//         fetchProgressData();
//     }, [month, year]);

//     const getProgress = async () => {
//         setBuffering(true); // Start buffering

//         try {
//             const response = await axios.get(
//                 `${BASE_URL}/project_details/progressbyproject/${formData.project}/${formData.contractor}/`
//             );

//             setprogressList(response.data);

//             // Extract and process year field
//             const yearField = response.data.map(item => ({
//                 ...item,
//                 year: item.year || 0, // Default to 0 if missing
//             }));



//             // Find the oldest year
//             const oldestYear = yearField.reduce((min, item) =>
//                 item.year && item.year < min ? item.year : min,
//                 Infinity
//             );
//             setOldestYear(oldestYear);

//             console.log("Oldest Year:", oldestYear);

//         } catch (err) {
//             console.log("Error fetching progress:", err);
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false); // End buffering
//         }
//     };






//     useEffect(() => {
//         // Check if conditions are met before calling getEot
//         if (formData.project !== "null"
//         ) {

//             if (formData.lettertype === "Eot") {
//                 getEot();
//             }
//             if (formData.lettertype === "cos") {
//                 getCOS();
//             }
//             if (formData.contractor !== "" && formData.lettertype === "Milestone") {
//                 getMilestone();
//             }

//             if (formData.contractor !== "" && formData.lettertype === "SiteProgress") {
//                 getProgress();
//             }
//         }
//     }, [formData.project, formData.workperformedby_contractor, formData.contractor, formData.lettertype, formData.select, eotID, cosID, mileStoneID, progressID]);



//     const handleFormSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true);
//             // const loadingToastId = toast.loading("Loading: Please wait...");

//             try {
//                 const formDataToSend = new FormData();

//                 // // Append general form fields (excluding documents)
//                 // Object.keys(formData).forEach((key) => {
//                 //   if (key !== "documents" && formData[key]) {
//                 //     if (key === "associated_letters") {
//                 //       formData[key].forEach((value) => formDataToSend.append(key, value));
//                 //     } else {
//                 //       formDataToSend.append(key, formData[key]);
//                 //     }
//                 //   }
//                 // });

//                 // Append general form fields (excluding documents)
//                 Object.keys(formData).forEach((key) => {
//                     if (key !== "documents" && formData[key]) {
//                         if (key === "associated_letters") {
//                             formDataToSend.append(key, JSON.stringify(formData[key])); // stringify the array
//                         } else {
//                             formDataToSend.append(key, formData[key]);
//                         }
//                     }
//                 });




//                 // Upload files in chunks and collect file IDs
//                 let fileIndex = 0;
//                 for (let doc of formData.documents) {
//                     if (doc.document_file) {
//                         const fileId = await uploadFileInChunks(doc.document_file, doc.document_name);
//                         if (!fileId) {
//                             console.error(`❌ Failed to upload file: ${doc.document_name}`);
//                             continue; // Skip this file instead of returning
//                         }
//                         console.log(doc, "documents")
//                         formDataToSend.append("file_ids", fileId);
//                         formDataToSend.append(`documents[${fileIndex}][document_name]`, doc.document_name);
//                         // const fileNameWithoutExt = doc.document_file.name.substring(0, doc.document_file.name.lastIndexOf('.')) || doc.document_file.name;
//                         // formDataToSend.append(`documents[${fileIndex}][original_filename]`, doc.document_file.file);
//                         formDataToSend.append(`documents[${fileIndex}][original_filename]`, doc.document_file.name);
//                         formDataToSend.append(`documents[${fileIndex}][file]`, doc.document_file);

//                         fileIndex++; // Ensure indices remain correct


//                     }
//                 }

//                 if (!formDataToSend.has("file_ids")) {
//                     console.error("❌ No valid files were uploaded.");
//                     setLoading(false);
//                     return;
//                 }

//                 // Send request with updated FormData
//                 const res = await axiosInstance.post(
//                     `/project_details/documentbulkwithletter-new/`,
//                     formDataToSend,
//                     {
//                         onUploadProgress: (progressEvent) => {
//                             const percentCompleted = Math.round(
//                                 (progressEvent.loaded * 100) / progressEvent.total
//                             );
//                             setUploadProgress(percentCompleted);
//                         },
//                     }
//                 );

//                 if (res.status === 200) {
//                     if (res.data.letter.id) {
//                         const generatedId = res.data.letter.id;

//                         if (formData.lettertype === "Eot") {
//                             if (eotID === "null") {

//                                 setEOTFormData((prev) => ({
//                                     ...prev,
//                                     letter: generatedId,
//                                     eot_code: eotFormData.eot_code,
//                                     days: eotFormData.days,
//                                 }));
//                                 const updatedEotData = {
//                                     ...eotFormData,
//                                     letter: generatedId,
//                                     eot_code: eotFormData.eot_code,
//                                     days: eotFormData.days,
//                                 };
//                                 const eotpost = await axios.post(`${BASE_URL}/project_details/eot/`, updatedEotData);

//                                 if (eotpost.status === 200) {
//                                     await getEot();

//                                 }
//                             } else if (eotID !== "null") {
//                                 setEOTFormData((prev) => ({
//                                     ...prev,
//                                     close_letter: generatedId,
//                                 }));
//                                 const updatedEotData = {
//                                     ...eotFormData,
//                                     close_letter: generatedId,
//                                 };
//                                 const eotUpdate = await axios.put(`${BASE_URL}/project_details/eot/${eotID}/`, updatedEotData);

//                                 if (eotUpdate.status === 200) {
//                                     await getEot();
//                                 }
//                             }


//                         }
//                         if (formData.lettertype === "cos") {
//                             if (cosID === "null") {

//                                 setCOSFormData((prev) => ({
//                                     ...prev,
//                                     letter: generatedId,
//                                     cos_code: cosFormData.cos_code,
//                                     cos_type: cosFormData.cos_type,
//                                     negativeamount: cosFormData.negativeamount,
//                                     amount: cosFormData.amount,
//                                 }));
//                                 const updatedCOSData = {
//                                     ...cosFormData,
//                                     letter: generatedId,
//                                     cos_code: cosFormData.cos_code,
//                                     cos_type: cosFormData.cos_type,
//                                     amount: cosFormData.amount,
//                                     negativeamount: cosFormData.negativeamount,
//                                 };
//                                 const cospost = await axios.post(`${BASE_URL}/project_details/cos/`, updatedCOSData);

//                                 if (cospost.status === 200) {
//                                     await getCOS();

//                                 }
//                             } else if (cosID !== "null") {
//                                 setCOSFormData((prev) => ({
//                                     ...prev,
//                                     close_letter: generatedId,
//                                 }));
//                                 const updatedCOSData = {
//                                     ...cosFormData,
//                                     close_letter: generatedId,
//                                 };
//                                 const cosUpdate = await axios.put(`${BASE_URL}/project_details/cos/${cosID}/`, updatedCOSData);

//                                 if (cosUpdate.status === 200) {
//                                     await getCOS();
//                                 }
//                             }


//                         }
//                         if (formData.lettertype === "SiteProgress") {
//                             if (progressID === "null") {

//                                 setProgressData((prev) => ({
//                                     ...prev,
//                                     submitted_letter: generatedId,
//                                     month: progressData.month
//                                 }));
//                                 const updateProgressData = {
//                                     ...progressData,
//                                     submitted_letter: generatedId,
//                                     month: progressData.month,
//                                 };
//                                 const progressPost = await axios.post(`${BASE_URL}/project_details/progressget/`, updateProgressData);

//                                 if (progressPost.status === 200) {
//                                     await getProgress();

//                                 }
//                             } else if (progressID !== "null") {
//                                 setProgressData((prev) => ({
//                                     ...prev,
//                                     approved_letter: generatedId,
//                                 }));
//                                 const UpdatedProgressData = {
//                                     ...progressData,
//                                     approved_letter: generatedId,
//                                 };
//                                 const progressUpdate = await axios.put(`${BASE_URL}/project_details/progressupdate/${progressID}/`, UpdatedProgressData);

//                                 if (progressUpdate.status === 200) {
//                                     await getProgress();
//                                 }
//                             }


//                         }
//                         if (formData.lettertype === "Milestone") {
//                             if (mileStoneFormData.mile_stone_type === "actual") {

//                                 setmileStoneFormData((prev) => ({
//                                     ...prev,
//                                     actual_letter: generatedId,
//                                 }));
//                                 const updatedactualMilestone = {
//                                     ...mileStoneFormData,
//                                     actual_letter: generatedId,
//                                 };
//                                 const milestoneactual = await axios.put(`${BASE_URL}/project_details/milestone/${mileStoneID}/`, updatedactualMilestone);

//                                 if (milestoneactual.status === 200) {
//                                     await getMilestone();

//                                 }
//                             } else if (mileStoneFormData.mile_stone_type === "reschedule") {
//                                 setmileStoneFormData((prev) => ({
//                                     ...prev,
//                                     reschedule_letter: generatedId,
//                                 }));
//                                 const updatedRescheduleMilestone = {
//                                     ...mileStoneFormData,
//                                     reschedule_letter: generatedId,
//                                 };
//                                 const milestoneUpdate = await axios.put(`${BASE_URL}/project_details/milestone/${mileStoneID}/`, updatedRescheduleMilestone);

//                                 if (milestoneUpdate.status === 200) {
//                                     await getMilestone();
//                                 }
//                             }


//                         }
//                     }


//                     await getProjects();

//                     toast.success("Letter Documents uploaded successfully!");
//                     handleClose();
//                     // toast.dismiss(loadingToastId);

//                 } else {
//                     throw new Error("Document upload failed");
//                 }
//             } catch (err) {
//                 toast.error("Error uploading documents");
//                 console.error("Error uploading documents", err);
//             } finally {
//                 setLoading(false);
//                 // toast.dismiss(loadingToastId);
//                 setUploadProgress(0);
//             }
//         }
//     };



//     useEffect(() => {
//         setFormData((prevFormData) => ({
//             ...prevFormData,
//             contractor: letterfor === "contractor" ? contractor : "",
//         }));
//     }, [contractor]);
//     useEffect(() => {
//         if (formData.project !== "null") {
//             getProjectContractorDetails();
//         }
//     }, [formData.project]);

//     console.log("doc.document_file.name");

//     console.log(formData.documents.name);

//     return (
//         <>
//             <button
//                 title={`Add ${title} Details`}
//                 className="upload-svg equal-hieg"
//                 onClick={handleShow}
//             >
//                 <AddwithWhiteCircle /> {` ${title}`}
//             </button>
//             <Modal
//                 show={show}
//                 onHide={handleClose}
//                 dialogClassName="ourcompany-model"
//             >
//                 <Modal.Header
//                     closeButton
//                     className="justify-center task-Tab-heading font-weight500 font-size-heading"
//                 >
//                     <Modal.Title>Add {title}</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <form className="register-form">
//                         <div className="form-flex-wrap">

//                             {sessionStorage.getItem('role') === "SiteManagement" ? "" :

//                                 ((projectId === 'null' || projectId === undefined || projectId === "") && (
//                                     <div className="form-group">
//                                         <RenderSelectField
//                                             title="Site Project"
//                                             name="project"
//                                             required={true}
//                                             options={projectList?.map((project) => ({
//                                                 value: project.id,
//                                                 label: `${project.site_prcode} - ${project.project_short_name}`,
//                                             }))}
//                                             placeholder="Select a Project"
//                                             formData={formData}
//                                             errors={errors}
//                                             inputState={inputState}
//                                             handleInputChange={handleInputChange}
//                                         />
//                                         {errors.project && (
//                                             <div className="error-message col">
//                                                 {errors.project}
//                                             </div>
//                                         )}
//                                     </div>
//                                 ))
//                             }



//                             <div className="form-group">
//                                 <RenderSelectField
//                                     title="Letter Exchange"
//                                     name="letterExchange"
//                                     required={true}
//                                     options={[
//                                         { value: "send", label: "Send" },
//                                         { value: "receive", label: "Received" },
//                                     ]}
//                                     placeholder="Select an Exchange Type"
//                                     formData={formData}
//                                     errors={errors}
//                                     inputState={inputState}
//                                     handleInputChange={handleInputChange}
//                                 />
//                                 {errors.letterExchange && (
//                                     <div className="error-message col">
//                                         {errors.letterExchange}
//                                     </div>
//                                 )}
//                             </div>

//                             {formData.letterExchange === "send" && (
//                                 <div className="form-group">
//                                     <RenderSelectField
//                                         title="Reply By"
//                                         name="reply_by"
//                                         required={true}
//                                         options={[
//                                             { value: "HO", label: "Head Office" },
//                                             { value: "SO", label: "Site Office" },
//                                         ]}
//                                         placeholder="Select a Reply By"
//                                         formData={formData}
//                                         errors={errors}
//                                         inputState={inputState}
//                                         handleInputChange={handleInputChange}
//                                     />
//                                     {errors.reply_by && (
//                                         <div className="error-message col">{errors.reply_by}</div>
//                                     )}
//                                 </div>
//                             )}

//                             <div className="form-group">
//                                 <RenderInputField
//                                     title={`${formData.letterExchange === "null" ? "" : toTitleCase(formData.letterExchange)} Letter No.`}
//                                     name="letter_num"
//                                     required={true}
//                                     placeholder="Letter Number"
//                                     formData={formData}
//                                     errors={errors}
//                                     inputState={inputState}
//                                     handleInputChange={handleInputChange}
//                                 />
//                                 {errors.letter_num && (
//                                     <div className="error-message col">{errors.letter_num}</div>
//                                 )}
//                             </div>


//                             {letterfor ? <></> :

//                                 (
//                                     <div className="form-group">
//                                         <RenderSelectField
//                                             title="Letter Related To"
//                                             name="workperformedby_contractor"
//                                             required={true}
//                                             options={[
//                                                 ...(formData.project &&
//                                                     ((Array.isArray(contractorlist) &&
//                                                         contractorlist.length > 0) ||
//                                                         (Array.isArray(contractorlists) &&
//                                                             contractorlists.length > 0))
//                                                     ? [{ value: "contractor", label: "Contractor" }]
//                                                     : []),
//                                                 { value: "consultant", label: "Consultant" },
//                                             ]}
//                                             placeholder="Select Option"
//                                             formData={formData}
//                                             errors={errors}
//                                             inputState={inputState}
//                                             handleInputChange={handleInputChange}
//                                         />
//                                         {errors.workperformedby_contractor && (
//                                             <div className="error-message col">
//                                                 {errors.workperformedby_contractor}
//                                             </div>
//                                         )}
//                                     </div>
//                                 )}

//                             {formData.workperformedby_contractor === 'contractor' ?
//                                 <div className="form-group">
//                                     <div title=" Contractor Name" className="flex-column form-group-selectt">
//                                         <label htmlFor="project" className="form-labels  font-weight500    font-size-subheading">
//                                             Contractor Name<span className="required">*</span>
//                                         </label>
//                                         <br />
//                                         <select
//                                             id="contractor"
//                                             name="contractor"
//                                             value={formData.contractor}
//                                             onChange={handleInputChange}
//                                             disabled={!!contractor}

//                                             className={`form-input form-group-selection ${errors.contractor ? "error" : inputState.contractor ? "success" : ""
//                                                 }`}
//                                         >
//                                             <option value="">Select a Contractor</option>
//                                             {contractorlists?.sort((a, b) => a.name?.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (<>
//                                                 <option value={i.id}>{i.name}</option>
//                                             </>))
//                                             }
//                                         </select>


//                                         <DropdownArrow />

//                                     </div>

//                                     {errors.contractor && (
//                                         <div className="error-message col">{errors.contractor}</div>
//                                     )}
//                                 </div>
//                                 : ""
//                             }

//                             {lettertype ?
//                                 <></>
//                                 :
//                                 <>
//                                     <div className="form-group">
//                                         <RenderSelectField
//                                             title="Letter Type"
//                                             name="lettertype"
//                                             required={true}
//                                             options={[
//                                                 { value: "show-cause", label: "Show Cause" },
//                                                 { value: "informative", label: "Informative" },
//                                                 { value: "eot", label: "EOT" },
//                                                 { value: "cos", label: "COS" },
//                                                 { value: "billing", label: "Billing" },
//                                                 { value: "design", label: "Design" },
//                                                 { value: "ncr", label: "NCR" },

//                                                 { value: "Design & Drawing", label: "Design & Drawing" },
//                                                 { value: "P&P", label: "P&P" },
//                                                 { value: "QAP", label: "QAP" },
//                                                 { value: "Structure", label: "Structure" },
//                                                 { value: "Q & ME", label: "Q & ME" },
//                                                 { value: "BBS", label: "BBS" },
//                                                 { value: "noc", label: "NOC" },
//                                                 { value: "Road Safety", label: "Road Safety" },
//                                                 { value: "Work Plan", label: "Work Plan" },
//                                                 { value: "Drain", label: "Drain" },
//                                                 { value: "Hydrology", label: "Hydrology" },
//                                                 { value: "Survey", label: "Survey" },
//                                                 ...(formData.workperformedby_contractor === "contractor"
//                                                     ? [{ value: "Milestone", label: "Milestone" }]
//                                                     : []),
//                                                 { value: "query", label: "Query" },
//                                                 { value: "SiteProgress", label: "SiteProgress" },
//                                                 { value: "other", label: "Others" }
//                                             ]}
//                                             placeholder="Select a Letter Type"
//                                             formData={formData}
//                                             errors={errors}
//                                             inputState={inputState}
//                                             handleInputChange={handleInputChange}
//                                         />
//                                         {errors.lettertype && (
//                                             <div className="error-message col">{errors.lettertype}</div>
//                                         )}
//                                     </div></>
//                             }
//                             {(formData.lettertype === "Eot" ||
//                                 formData.lettertype === "cos" ||
//                                 formData.lettertype === "Milestone" ||
//                                 formData.lettertype === "SiteProgress") &&
//                                 formData.workperformedby_contractor !== "null" && (
//                                     <div className="form-group">
//                                         <div className="flex-column form-group-selectt">
//                                             <label
//                                                 htmlFor="select"
//                                                 className="form-labels font-weight500 font-size-subheading"
//                                             >
//                                                 <span>Select {formData.lettertype}<span className="required">*</span></span>
//                                             </label>
//                                             <br />
//                                             <select
//                                                 id="select"
//                                                 name="select"
//                                                 placeholder="select"
//                                                 value={formData.select}
//                                                 onChange={handleInputChange}
//                                                 className={`form-input form-group-selection ${errors.select ? "error" : inputState.select ? "success" : ""}`}
//                                             >
//                                                 <option value="">Select</option>

//                                                 {formData.lettertype !== "Milestone" && (
//                                                     <option value="new">New {formData.lettertype}</option>
//                                                 )}
//                                                 <option value="existing">Existing {formData.lettertype}</option>

//                                                 {/* {(formData.lettertype === "Eot" && eotList?.length > 0) ||
//                           (formData.lettertype === "cos" && cosList?.length > 0) ||
//                           (formData.lettertype === "Milestone" && mileStoneList?.length > 0) ||
//                           (formData.lettertype === "SiteProgress" && progressData?.length > 0) ? (
//                           <option value="existing">Existing {formData.lettertype}</option>
//                         ) : null} */}
//                                             </select>

//                                             <DropdownArrow />
//                                         </div>

//                                         {errors.select && <div className="error-message col">{errors.select}</div>}
//                                     </div>
//                                 )}



//                             {formData.select === "new" ?
//                                 <>
//                                     {formData.lettertype === "Eot" ?
//                                         <>
//                                             <div className="form-group">
//                                                 <RenderDateInputField
//                                                     title={`${formData.letterExchange === "null" ? "" : toTitleCase(formData.letterExchange)} Letter Date`}
//                                                     name="letter_date"
//                                                     type="date"
//                                                     max={today}
//                                                     required={true}
//                                                     formData={formData}
//                                                     errors={errors}
//                                                     inputState={inputState}
//                                                     handleInputChange={handleInputChange}
//                                                 />
//                                                 {errors.letter_date && (
//                                                     <div className="error-message col">{errors.letter_date}</div>
//                                                 )}
//                                             </div>
//                                             <div className="flex-column">
//                                                 <label className="form-labels font-weight500 font-size-subheading"
//                                                     title="EOT Code">EOT Code<span className="required">*</span></label>
//                                                 <input
//                                                     type="text"
//                                                     name="eot_code"
//                                                     placeholder="EOT Code"
//                                                     title="EOT Code"
//                                                     value={eotFormData.eot_code}
//                                                     onChange={handleEotInputChange}
//                                                     className={`form-input ${errors.eot_code ? "error" : eotinputState.eot_code ? "success" : ""}`}
//                                                 />
//                                                 {errors.eot_code && <span className="error-message font-size-text">{errors.eot_code}</span>}
//                                             </div>
//                                             <div className="flex-column">
//                                                 <label className="form-labels font-weight500 font-size-subheading" title="Initiate Days">
//                                                     Initiate Days
//                                                 </label>
//                                                 <input
//                                                     type="number"
//                                                     name="days"
//                                                     title="Initiate Days"
//                                                     placeholder="Initiate Days"
//                                                     value={eotFormData.days}
//                                                     onChange={handleEotInputChange}
//                                                     className={`form-input ${errors.days
//                                                         ? "error"
//                                                         : inputState.days
//                                                             ? "success"
//                                                             : ""
//                                                         }`}
//                                                 />
//                                                 {errors.days && (
//                                                     <span className="error-message font-size-text">
//                                                         {errors.days}
//                                                     </span>
//                                                 )}
//                                             </div>

//                                         </> : ""
//                                     }
//                                     {formData.lettertype === "cos" ?
//                                         <>
//                                             <div className="form-group">
//                                                 <RenderInputField
//                                                     title={`${formData.letterExchange === "null" ? "" : toTitleCase(formData.letterExchange)} Letter Date`}
//                                                     name="letter_date"
//                                                     type="date"
//                                                     required={true}
//                                                     formData={formData}
//                                                     max={today}
//                                                     errors={errors}
//                                                     inputState={inputState}
//                                                     handleInputChange={handleInputChange}
//                                                 />
//                                                 {errors.letter_date && (
//                                                     <div className="error-message col">{errors.letter_date}</div>
//                                                 )}
//                                             </div>
//                                             <div className="flex-column">
//                                                 <label className="form-labels font-weight500 font-size-subheading"
//                                                     title="COS Code">COS Code<span className="required">*</span></label>
//                                                 <input
//                                                     type="text"
//                                                     name="cos_code"
//                                                     placeholder="COS Code"
//                                                     title="COS Code"
//                                                     value={cosFormData.cos_code}
//                                                     onChange={handleCOSInputChange}
//                                                     className={`form-input ${errors.cos_code ? "error" : eotinputState.cos_code ? "success" : ""}`}
//                                                 />
//                                                 {errors.cos_code && <span className="error-message font-size-text">{errors.cos_code}</span>}
//                                             </div>
//                                             <div className="flex-column form-group-selectt">
//                                                 <label className="form-labels font-weight500 font-size-subheading" title="COS Type">COS Type <span className="required">*</span></label>
//                                                 <br />
//                                                 <select
//                                                     name="cos_type"
//                                                     title="COS Type"
//                                                     value={cosFormData.cos_type}
//                                                     onChange={handleCOSInputChange}
//                                                     className={`form-input form-group-selection`}
//                                                 >
//                                                     <option value="">Select COS Type</option>
//                                                     <option value="negativecos">Negative COS</option>
//                                                     <option value="positivecos">Positive COS</option>

//                                                 </select>
//                                                 <div className="form-group-selection-arrow">
//                                                     <svg
//                                                         xmlns="http://www.w3.org/2000/svg"
//                                                         width="20"
//                                                         height="25"
//                                                         fill="currentColor"
//                                                         className="bi bi-caret-down-fill"
//                                                         viewBox="0 0 16 16"
//                                                     >
//                                                         <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
//                                                     </svg>
//                                                 </div>
//                                                 {errors.cos_type && <div className="error-message font-size-text">{errors.cos_type}</div>}
//                                             </div>
//                                             {cosFormData.cos_type === 'positivecos' ?
//                                                 <div className="flex-column">
//                                                     <label className="form-labels font-weight500 font-size-subheading"
//                                                         title="Positive COS Amount">Positive COS Amount(Write Full Amount)<span className="required">*</span></label>
//                                                     <input
//                                                         type="number"
//                                                         name="amount"
//                                                         placeholder="Positive COS Amount"
//                                                         title="Positive COS Amount"
//                                                         value={cosFormData.amount}
//                                                         onChange={handleCOSInputChange}
//                                                         className={`form-input ${errors.amount ? "error" : eotinputState.amount ? "success" : ""}`}
//                                                     />
//                                                     {errors.amount && <span className="error-message font-size-text">{errors.amount}</span>}
//                                                 </div> :
//                                                 cosFormData.cos_type === 'negativecos' ?
//                                                     <div className="flex-column">
//                                                         <label className="form-labels font-weight500 font-size-subheading"
//                                                             title="Negative COS Amount">Negative COS Amount(Write Full Amount)<span className="required">*</span></label>
//                                                         <input
//                                                             type="number"
//                                                             name="negativeamount"
//                                                             placeholder="Negative COS Amount"
//                                                             title="Negative COS Amount"
//                                                             value={cosFormData.negativeamount}
//                                                             onChange={handleCOSInputChange}
//                                                             className={`form-input ${errors.negativeamount ? "error" : eotinputState.negativeamount ? "success" : ""}`}
//                                                         />
//                                                         {errors.negativeamount && <span className="error-message font-size-text">{errors.negativeamount}</span>}
//                                                     </div> : ""
//                                             }
//                                         </> : ""
//                                     }
//                                     {formData.lettertype === "SiteProgress" &&
//                                         <>
//                                             <div className="form-group">
//                                                 <RenderInputField
//                                                     title={`${formData.letterExchange === "null" ? "" : toTitleCase(formData.letterExchange)} Letter Date`}
//                                                     name="letter_date"
//                                                     type="date"
//                                                     required={true}
//                                                     max={today}
//                                                     formData={formData}
//                                                     errors={errors}
//                                                     inputState={inputState}
//                                                     handleInputChange={handleInputChange}
//                                                 />
//                                                 {errors.letter_date && (
//                                                     <div className="error-message col">{errors.letter_date}</div>
//                                                 )}
//                                             </div>
//                                             <div className="flex-column">
//                                                 <label className="form-labels font-weight500 font-size-subheading">
//                                                     Month<span className="required">*</span>
//                                                 </label>
//                                                 <select
//                                                     name="month"
//                                                     value={progressData.month}
//                                                     className="form-input"
//                                                     onChange={handleProgressData}
//                                                 >
//                                                     <option value=''>Select Month</option>
//                                                     {months.map((month) => (
//                                                         <option
//                                                             key={month.value}
//                                                             value={month.value}
//                                                             disabled={progressList.some(
//                                                                 (data) => data.month === String(month.value) && data.year === String(progressData.year)
//                                                             )}
//                                                         >
//                                                             {month.text}
//                                                         </option>
//                                                     ))}
//                                                 </select>
//                                                 {errors.month && <span className="error-message font-size-text">{errors.month}</span>}

//                                             </div>

//                                             {/* Frozen Year Field */}
//                                             <div className="flex-column">
//                                                 <label className="form-labels font-weight500 font-size-subheading">
//                                                     Year<span className="required">*</span>
//                                                 </label>
//                                                 <select
//                                                     name="year"
//                                                     value={progressData.year}
//                                                     className="form-input"
//                                                     onChange={handleProgressData}
//                                                 >
//                                                     <option value=''>Select Year</option>

//                                                     {[...Array(10)].map((_, index) => {
//                                                         const year = new Date().getFullYear() - index;
//                                                         return (
//                                                             <option
//                                                                 key={year}
//                                                                 value={year}
//                                                                 disabled={progressList.some(
//                                                                     (data) => data.year === String(year) && data.month === String(progressData.month)
//                                                                 )}
//                                                             >
//                                                                 {year}
//                                                             </option>
//                                                         );
//                                                     })}
//                                                 </select>
//                                                 {errors.year && <span className="error-message font-size-text">{errors.year}</span>}

//                                             </div>
//                                             <>
//                                                 {(progressData.month && progressData.year) &&
//                                                     <>
//                                                         <div className="flex-column">
//                                                             <label className="form-labels font-weight500 font-size-subheading">
//                                                                 Submitted Physical Progress (%)<span className="required">*</span>
//                                                             </label>
//                                                             <input
//                                                                 type="number"
//                                                                 min={previousprogressdata.physical_progress}
//                                                                 placeholder={previousprogressdata.physical_progress || 0}
//                                                                 name="submitted_physical_progress"
//                                                                 onChange={handleProgressData}
//                                                                 className={`form-input ${progresserrors.submitted_physical_progress ? "input-error" : ""}`}
//                                                             />
//                                                             {progresserrors.submitted_physical_progress && (
//                                                                 <span className="error-message">{progresserrors.submitted_physical_progress}</span>
//                                                             )}
//                                                         </div>

//                                                         {/* Submitted Financial Progress */}
//                                                         <div className="flex-column">
//                                                             <label className="form-labels font-weight500 font-size-subheading">
//                                                                 Submitted Financial Progress (%)<span className="required">*</span>
//                                                             </label>
//                                                             <input
//                                                                 type="number"
//                                                                 min={previousprogressdata.financial_progress}
//                                                                 placeholder={previousprogressdata.financial_progress || 0}
//                                                                 name="submitted_financial_progress"
//                                                                 onChange={handleProgressData}
//                                                                 className={`form-input ${progresserrors.submitted_financial_progress ? "input-error" : ""}`}
//                                                             />
//                                                             {progresserrors.submitted_financial_progress && (
//                                                                 <span className="error-message">{progresserrors.submitted_financial_progress}</span>
//                                                             )}
//                                                         </div>
//                                                     </>
//                                                 }
//                                             </>


//                                         </>
//                                     }


//                                 </>
//                                 :
//                                 formData.select === "existing" ?
//                                     <>
//                                         {formData.lettertype === "Eot" ?
//                                             <div className="form-group">
//                                                 <div className="flex-column form-group-selectt">
//                                                     <label
//                                                         htmlFor="select"
//                                                         className="form-labels  font-weight500    font-size-subheading"
//                                                     >
//                                                         Existing EOT<span className="required">*</span>
//                                                     </label>
//                                                     <br />
//                                                     <select

//                                                         value={eotID}
//                                                         onChange={(e) => setEotId(e.target.value)}


//                                                         className={`form-input form-group-selection`}
//                                                     >
//                                                         <option value="">Select Existing Eot</option>
//                                                         {eotList?.sort((a, b) => a.eot_code?.localeCompare(b.eot_code, 'en', { ignorePunctuation: true })).map((i, index) => (<>
//                                                             <option value={i.id}>{i.eot_code}</option>
//                                                         </>))
//                                                         }
//                                                     </select>
//                                                     <DropdownArrow />
//                                                 </div>
//                                                 {errors.eotID && (
//                                                     <div className="error-message col">{errors.eotID}</div>
//                                                 )}
//                                             </div>
//                                             : ""
//                                         }
//                                         {formData.lettertype === "cos" ?
//                                             <div className="form-group">
//                                                 <div className="flex-column form-group-selectt">
//                                                     <label
//                                                         htmlFor="select"
//                                                         className="form-labels  font-weight500    font-size-subheading"
//                                                     >
//                                                         Existing COS<span className="required">*</span>
//                                                     </label>
//                                                     <br />
//                                                     <select

//                                                         value={cosID}
//                                                         onChange={(e) => setCosId(e.target.value)}


//                                                         className={`form-input form-group-selection`}
//                                                     >
//                                                         <option value="">Select Existing Cos</option>
//                                                         {cosList?.sort((a, b) => a.cos_code?.localeCompare(b.cos_code, 'en', { ignorePunctuation: true })).map((i, index) => (<>
//                                                             <option value={i.id}>{i.cos_code}</option>
//                                                         </>))
//                                                         }
//                                                     </select>
//                                                     <DropdownArrow />
//                                                 </div>
//                                                 {errors.cosID && (
//                                                     <div className="error-message col">{errors.cosID}</div>
//                                                 )}
//                                             </div>
//                                             : ""
//                                         }
//                                         {formData.lettertype === "SiteProgress" ?
//                                             <div className="form-group">
//                                                 <div className="flex-column form-group-selectt">
//                                                     <label
//                                                         htmlFor="select"
//                                                         className="form-labels  font-weight500    font-size-subheading"
//                                                     >
//                                                         Existing Site Progress<span className="required">*</span>
//                                                     </label>
//                                                     <br />
//                                                     <select

//                                                         value={progressID}
//                                                         onChange={(e) => setprogressID(e.target.value)}


//                                                         className={`form-input form-group-selection`}
//                                                     >
//                                                         <option value="">Select Existing Site Progress</option>
//                                                         {progressList?.filter(
//                                                             (item) => !item.approved_letter // Exclude items with either actualLetter or rescheduleLetter
//                                                         ).sort((a, b) => a.year?.localeCompare(b.year, 'en', { ignorePunctuation: true })).map((i, index) => (<>
//                                                             <option value={i.id}>{i.month}-{i.year}</option>
//                                                         </>))
//                                                         }
//                                                     </select>
//                                                     <DropdownArrow />
//                                                 </div>
//                                                 {errors.progressID && (
//                                                     <div className="error-message col">{errors.progressID}</div>
//                                                 )}
//                                             </div>
//                                             : ""
//                                         }
//                                         {formData.lettertype === "Milestone" ?
//                                             <>
//                                                 <div className="form-group">
//                                                     <div className="flex-column form-group-selectt">
//                                                         <label
//                                                             htmlFor="select"
//                                                             className="form-labels  font-weight500    font-size-subheading"
//                                                         >
//                                                             Existing Milestone<span className="required">*</span>
//                                                         </label>
//                                                         <br />
//                                                         <select

//                                                             value={mileStoneID}
//                                                             onChange={(e) => setmileStoneId(e.target.value)}


//                                                             className={`form-input form-group-selection`}
//                                                         >
//                                                             <option value="">Select Existing Milestone</option>
//                                                             {mileStoneList
//                                                                 ?.filter(
//                                                                     (item) => !item.reschedule_letter && !item.actual_letter // Exclude items with either actualLetter or rescheduleLetter
//                                                                 )
//                                                                 .sort((a, b) => a.name?.localeCompare(b.name, 'en', { ignorePunctuation: true }))
//                                                                 .map((i) => (
//                                                                     <option key={i.id} value={i.id}>
//                                                                         {i.name}
//                                                                     </option>
//                                                                 ))}

//                                                         </select>
//                                                         <DropdownArrow />
//                                                     </div>
//                                                     {errors.mileStoneID && (
//                                                         <div className="error-message col">{errors.mileStoneID}</div>
//                                                     )}
//                                                 </div>
//                                                 <div className="form-group">
//                                                     <div className="flex-column form-group-selectt">
//                                                         <label
//                                                             htmlFor="mile_stone_type"
//                                                             className="form-labels  font-weight500    font-size-subheading"
//                                                         >
//                                                             Milestone Type
//                                                             <span className="required">*</span>
//                                                         </label>
//                                                         <br />
//                                                         <select id="mile_stone_type"
//                                                             name="mile_stone_type"
//                                                             placeholder="Select"
//                                                             value={mileStoneFormData.mile_stone_type}

//                                                             onChange={handleMilestoneChange}
//                                                             className={`form-input form-group-selection ${errors.select ? "error" : inputState.select ? "success" : ""
//                                                                 }`}
//                                                         >
//                                                             <option value="null">Select Milestone Type</option>
//                                                             <option value="actual">Actual {formData.lettertype}</option>
//                                                             <option value="reschedule">Reschedule {formData.lettertype}</option>

//                                                         </select>
//                                                         <DropdownArrow />

//                                                     </div>
//                                                     {errors.mile_stone_type && (
//                                                         <div className="error-message col">{errors.mile_stone_type}</div>
//                                                     )}
//                                                 </div>
//                                             </>
//                                             : ""
//                                         }

//                                     </> : ""
//                             }
//                             {formData.select !== "new" &&
//                                 <div className="form-group">
//                                     <RenderInputField
//                                         title={`${formData.letterExchange === "null" ? "" : toTitleCase(formData.letterExchange)} Letter Date`}
//                                         name="letter_date"
//                                         type="date"
//                                         required={true}
//                                         max={today}

//                                         formData={formData}
//                                         errors={errors}
//                                         inputState={inputState}
//                                         handleInputChange={handleInputChange}
//                                     />
//                                     {errors.letter_date && (
//                                         <div className="error-message col">{errors.letter_date}</div>
//                                     )}
//                                 </div>
//                             }


//                             {eotID !== "null" ?
//                                 <>
//                                     <div className="form-group">
//                                         <div className="flex-column form-group-selectt">
//                                             <label className="form-labels font-weight500 font-size-subheading" title="EOT Status">EOT Status</label>
//                                             <br />
//                                             <select
//                                                 name="eot_status"
//                                                 title="EOT status"
//                                                 value={eotFormData.eot_status}
//                                                 onChange={handleEotInputChange}
//                                                 className={`form-input form-group-selection`}
//                                             >
//                                                 <option value="">Select Status</option>
//                                                 <option value="pending">Pending</option>
//                                                 <option value="Approved">Approved</option>
//                                                 <option value="rejected">Rejected</option>

//                                             </select>
//                                             <DropdownArrow />
//                                         </div>
//                                         {errors.eot_status && <div className="error-message font-size-text">{errors.eot_status}</div>}
//                                     </div>

//                                     {
//                                         eotFormData.eot_status === "Approved" &&
//                                         <div className="flex-column">
//                                             <label className="form-labels font-weight500 font-size-subheading" title="Approved Days">
//                                                 Approved Days
//                                             </label>
//                                             <input
//                                                 type="number"
//                                                 name="approved_days"
//                                                 title="Approved Days"
//                                                 placeholder="Approved Days"
//                                                 value={eotFormData.approved_days}
//                                                 onChange={handleEotInputChange}
//                                                 className={`form-input ${errors.approved_days
//                                                     ? "error"
//                                                     : inputState.approved_days
//                                                         ? "success"
//                                                         : ""
//                                                     }`}
//                                             />
//                                             {errors.approved_days && (
//                                                 <span className="error-message font-size-text">
//                                                     {errors.approved_days}
//                                                 </span>
//                                             )}
//                                         </div>
//                                     }




//                                 </> : <></>

//                             }
//                             {cosID !== "null" ?
//                                 <>
//                                     <div className="form-group">
//                                         <div className="flex-column form-group-selectt">
//                                             <label className="form-labels font-weight500 font-size-subheading" title="Cos Status">Cos Status</label>
//                                             <br />
//                                             <select
//                                                 name="cos_status"
//                                                 title="Cos status"
//                                                 value={cosFormData.cos_status}
//                                                 onChange={handleCOSInputChange}
//                                                 className={`form-input form-group-selection`}
//                                             >
//                                                 <option value="">Select Status</option>
//                                                 <option value="pending">Pending</option>
//                                                 <option value="Approved">Approved</option>
//                                                 <option value="rejected">Rejected</option>

//                                             </select>
//                                             <DropdownArrow />
//                                         </div>
//                                         {errors.cos_status && <div className="error-message font-size-text">{errors.cos_status}</div>}
//                                     </div>

//                                     {
//                                         cosFormData.cos_status === "Approved" &&
//                                         <div className="flex-column">
//                                             <label className="form-labels font-weight500 font-size-subheading" title="Approved Amount">
//                                                 Approved Amount
//                                             </label>
//                                             <input
//                                                 type="number"
//                                                 name="approved_amount"
//                                                 title="Approved Amount"
//                                                 placeholder="Approved Amount"
//                                                 value={cosFormData.approved_amount}
//                                                 onChange={handleCOSInputChange}
//                                                 className={`form-input ${errors.approved_amount
//                                                     ? "error"
//                                                     : cosinputState.approved_amount
//                                                         ? "success"
//                                                         : ""
//                                                     }`}
//                                             />
//                                             {errors.approved_amount && (
//                                                 <span className="error-message font-size-text">
//                                                     {errors.approved_amount}
//                                                 </span>
//                                             )}
//                                         </div>
//                                     }




//                                 </> : <></>

//                             }
//                             {progressID !== "null" && formData.letter_date !== "null" ?
//                                 <>
//                                     <div className="flex-column">
//                                         <label className="form-labels font-weight500 font-size-subheading">
//                                             Actual  Physical Progress (%)<span className="required">*</span>
//                                         </label>
//                                         <input
//                                             type="number"
//                                             min={previousprogressdata.physical_progress}
//                                             placeholder={previousprogressdata.physical_progress || 0}
//                                             name="physical_progress"
//                                             onChange={handleProgressData}
//                                             className={`form-input ${progresserrors.physical_progress ? "input-error" : ""}`}
//                                         />
//                                         {progresserrors.physical_progress && (
//                                             <span className="error-message">{progresserrors.physical_progress}</span>
//                                         )}
//                                     </div>

//                                     {/* Submitted Financial Progress */}
//                                     <div className="flex-column">
//                                         <label className="form-labels font-weight500 font-size-subheading">
//                                             Actual Financial Progress (%)<span className="required">*</span>
//                                         </label>
//                                         <input
//                                             type="number"
//                                             min={previousprogressdata.financial_progress}
//                                             placeholder={previousprogressdata.financial_progress || 0}
//                                             name="financial_progress"
//                                             onChange={handleProgressData}
//                                             className={`form-input ${progresserrors.financial_progress ? "input-error" : ""}`}
//                                         />
//                                         {progresserrors.financial_progress && (
//                                             <span className="error-message">{progresserrors.financial_progress}</span>
//                                         )}
//                                     </div>





//                                 </> : <></>

//                             }
//                             {mileStoneID !== "null" ?
//                                 <>

//                                     {
//                                         mileStoneFormData.mile_stone_type === "actual" &&
//                                         <div className="flex-column">
//                                             <label className="form-labels font-weight500 font-size-subheading" title="Actual Gap Days">
//                                                 Actual Gap Days<span className="required">(Read-Only)*</span>
//                                             </label>
//                                             <input
//                                                 type="number"
//                                                 name="actual_gap_days"
//                                                 title="Actual Gap Days"
//                                                 placeholder="Actual Gap Days"
//                                                 value={mileStoneFormData.actual_gap_days}
//                                                 onChange={handleMilestoneChange}
//                                                 className={`form-input ${errors.actual_gap_days
//                                                     ? "error"
//                                                     : mileStoneinputState.actual_gap_days
//                                                         ? "success"
//                                                         : ""
//                                                     }`}
//                                             />
//                                             {errors.actual_gap_days && (
//                                                 <span className="error-message font-size-text">
//                                                     {errors.actual_gap_days}
//                                                 </span>
//                                             )}
//                                         </div>
//                                     }
//                                     {
//                                         mileStoneFormData.mile_stone_type === "reschedule" &&
//                                         <div className="flex-column">
//                                             <label className="form-labels font-weight500 font-size-subheading" title="Reschedule Gap Days">
//                                                 Reschedule Gap Days<span className="required">(Read-Only)*</span>
//                                             </label>
//                                             <input
//                                                 type="number"
//                                                 name="rescedule_gap_days"
//                                                 title="Reschedule Gap Days"
//                                                 placeholder="Reschedule Gap Days"
//                                                 value={mileStoneFormData.rescedule_gap_days}
//                                                 onChange={handleMilestoneChange}
//                                                 className={`form-input ${errors.rescedule_gap_days
//                                                     ? "error"
//                                                     : mileStoneinputState.rescedule_gap_days
//                                                         ? "success"
//                                                         : ""
//                                                     }`}
//                                             />
//                                             {errors.rescedule_gap_days && (
//                                                 <span className="error-message font-size-text">
//                                                     {errors.rescedule_gap_days}
//                                                 </span>
//                                             )}
//                                         </div>
//                                     }




//                                 </> : <></>

//                             }




//                             <div className="form-group">
//                                 <RenderInputTextareaField
//                                     title="Subject"
//                                     name="subject"
//                                     placeholder="Enter subject here..."
//                                     rows={5}
//                                     cols={50}
//                                     formData={formData}
//                                     errors={errors}
//                                     required={true}
//                                     inputState={inputState}
//                                     handleInputChange={handleInputChange}
//                                 />
//                                 {errors.subject && (
//                                     <div className="error-message col">{errors.subject}</div>
//                                 )}
//                             </div>
//                             <div className="form-group">
//                                 <div title="Status" className="flex-column form-group-selectt">
//                                     <label
//                                         htmlFor="status"
//                                         className="form-labels  font-weight500    font-size-subheading"
//                                     >
//                                         Status<span className="required">*</span>
//                                     </label>
//                                     <br />
//                                     <select id="status"
//                                         name="status"
//                                         placeholder="Status"
//                                         value={formData.status}
//                                         onChange={handleInputChange}
//                                         className={`form-input form-group-selection ${errors.status ? "error" : inputState.status ? "success" : ""
//                                             }`}
//                                     >
//                                         <option value="">Select a Status</option>
//                                         <option value="pending">Pending</option>
//                                         {formData.letterExchange === "receive" ? "" :
//                                             <option value="close">Close</option>
//                                         }

//                                     </select>
//                                     <DropdownArrow />
//                                 </div>
//                                 {errors.status && (
//                                     <div className="error-message col">{errors.status}</div>
//                                 )}
//                             </div>

//                             <div className="form-group">
//                                 <RenderSelectField
//                                     title="Department"
//                                     name="letterdepartment"
//                                     required={true}
//                                     options={siteDepartmentList
//                                         .map((department) => ({
//                                             value: department.id,
//                                             label: `${department.title}`,
//                                         }))}
//                                     placeholder="Select a Department"
//                                     formData={formData}
//                                     errors={errors}
//                                     inputState={inputState}
//                                     handleInputChange={handleInputChange}
//                                 />
//                                 {errors.letterdepartment && (
//                                     <div className="error-message col">{errors.letterdepartment}</div>
//                                 )}
//                             </div>







//                             {formData.letterExchange === 'receive' &&
//                                 <div className="form-group">
//                                     <RenderInputField
//                                         title="Letter From"
//                                         name="letter_from"
//                                         placeholder="Letter From"
//                                         max={100}
//                                         formData={formData}
//                                         required={true}
//                                         errors={errors}
//                                         inputState={inputState}
//                                         handleInputChange={handleInputChange}
//                                     />
//                                     {errors.letter_from && (
//                                         <div className="error-message col">
//                                             {errors.letter_from}
//                                         </div>
//                                     )}
//                                 </div>}

//                             <div className="form-group">
//                                 <RenderInputField
//                                     title="Letter To"
//                                     name="letter_to"
//                                     placeholder="Letter To"
//                                     max={100}
//                                     required={true}
//                                     formData={formData}
//                                     errors={errors}
//                                     inputState={inputState}
//                                     handleInputChange={handleInputChange}
//                                 />
//                                 {errors.letter_to && (
//                                     <div className="error-message col">{errors.letter_to}</div>
//                                 )}
//                             </div>
//                             <div className="form-group">
//                                 <RenderInputField
//                                     title="Remarks"
//                                     name="remarks"
//                                     placeholder="Remarks"
//                                     max={100}
//                                     required={true}
//                                     formData={formData}
//                                     errors={errors}
//                                     inputState={inputState}
//                                     handleInputChange={handleInputChange}
//                                 />
//                                 {errors.remarks && (
//                                     <div className="error-message col">{errors.remarks}</div>
//                                 )}
//                             </div>

//                             <div className="flex-column">
//                                 <label
//                                     htmlFor="names"
//                                     className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
//                                 >
//                                     Associated Letters
//                                 </label>
//                                 <Select
//                                     options={options}
//                                     isMulti
//                                     onChange={handleChangecc}
//                                     styles={{
//                                         control: (provided) => ({
//                                             ...provided,
//                                             width: '33vw',
//                                             height: '50px',
//                                             borderRadius: '10px',
//                                             border: '1px solid #e3e3e3',
//                                             margin: '10px 0px 20px 0px',
//                                             color: '#4a4a4a',
//                                             backgroundColor: '#f7f8fa',
//                                             padding: '0px 10px',
//                                         }),
//                                         placeholder: (provided) => ({
//                                             ...provided,
//                                             color: '#4a4a4a',
//                                         }),
//                                         menu: (provided) => ({
//                                             ...provided,
//                                             width: '33vw',
//                                             borderRadius: '10px',
//                                             marginTop: '0',
//                                         }),
//                                         singleValue: (provided) => ({
//                                             ...provided,
//                                             color: '#4a4a4a',
//                                         }),
//                                         input: (provided) => ({
//                                             ...provided,
//                                             color: '#4a4a4a',
//                                         }),
//                                     }}
//                                 />
//                                 {errors.associated_letters && (
//                                     <span className="error-message font-size-text">
//                                         {errors.associated_letters}
//                                     </span>
//                                 )}
//                             </div>

//                             {/* Show status options if associated letters are selected */}
//                             {formData.associated_letters &&
//                                 formData.associated_letters.length > 0 && (
//                                     <>
//                                         <div className="form-column">
//                                             <RenderSelectField
//                                                 title="Update Status of Associated Letters"
//                                                 name="associated_letters_status"
//                                                 required={true}
//                                                 options={[
//                                                     { value: "pending", label: "Pending" },
//                                                     { value: "close", label: "Close" },
//                                                 ]}
//                                                 placeholder="Select Status"
//                                                 formData={formData}
//                                                 errors={errors}
//                                                 inputState={inputState}
//                                                 handleInputChange={handleInputChange}
//                                             />
//                                             {errors.associated_letters_status && (
//                                                 <div className="error-message col">
//                                                     {errors.associated_letters_status}
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </>
//                                 )}
//                         </div>

//                         <DocumentSection
//                             formData={formData}
//                             handleDocInputChange={handleDocInputChange}
//                             handleAddDocuments={handleAddDocuments}
//                             handleRemoveDocument={handleRemoveDocument}
//                             errors={errors}
//                             fileNames={fileNames}
//                             inputState={inputState}
//                         />

//                         {/* Upload Progress Bar */}
//                         {uploadProgress > 0 && (
//                             <div className="progress-bar">
//                                 <div
//                                     className="progress-bar-fill"
//                                     style={{ width: `${uploadProgress}%` }}
//                                 ></div>
//                                 <span>{uploadProgress}%</span>
//                             </div>
//                         )}

//                         <div className="button-models">
//                             <button
//                                 onClick={handleFormSubmit}
//                                 className="model-button font-weight500 model-button-submit"
//                                 disabled={loading}
//                             >
//                                 Submit
//                             </button>
//                         </div>
//                         <p className="error-message font-size-text">
//                             {isSubmitted && Object.keys(errors).length > 0 && (
//                                 Object.keys(errors).length > 5 ? (
//                                     <h5 className="text-center">Please fill all mandatory fields!</h5>
//                                 ) : (

//                                     <h6 className="text-center">
//                                         {Object.keys(errors).map((field) =>
//                                             field.charAt(0).toUpperCase() + field.slice(1)
//                                         ).join(', ') + ' are required!'}
//                                     </h6>
//                                 )
//                             )}
//                         </p>
//                     </form>
//                     <ToastContainer
//                         position="top-center"
//                         autoClose={1000}
//                         hideProgressBar={false}
//                         newestOnTop
//                         closeOnClick
//                         rtl={false}
//                         pauseOnFocusLoss
//                         draggable
//                         pauseOnHover
//                     />
//                 </Modal.Body>


//             </Modal>
//         </>
//     )

// };



const AddLetterLinked = ({
    getProjects,
    projectList,
    projectId,
    contractor,
    contractorlist,
    lettertype,
    letterfor,
    title,
}) => {
    const [oldestYear, setOldestYear] = useState("");
    const [previousprogressdata, setPreviousProgressData] = useState([]);
    const [show, setShow] = useState(false);
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [inputState, setInputState] = useState({});
    const [fileNames, setFileNames] = useState([]);
    const [trackRecordList, setTrackRecordList] = useState([]);
    const [buffer, setBuffering] = useState(true);
    const [contractorlists, setContractorLists] = useState([]);
    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0); // For upload progress
    const [eotinputState, seteotInputState] = useState({});
    const [cosinputState, setcosInputState] = useState({});
    const [eotList, setEotList] = useState([]);
    const [mileStoneinputState, setmileStoneInputState] = useState({});
    const [progressInputState, setprogressInputState] = useState({});
    const [mileStoneList, setmileStoneList] = useState([]);
    const [progressList, setprogressList] = useState([]);
    const [mileStoneID, setmileStoneId] = useState("null");
    const [progressID, setprogressID] = useState("null");
    const [cosList, setCosList] = useState([]);
    const [eotID, setEotId] = useState("null");
    const [cosID, setCosId] = useState("null");
    const [contractorData, setContractorData] = useState([]);
    const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
    const [LetterId, setletterId] = useState("null");

    console.log("contractorData")
    console.log(contractorData)

    const months = [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
    ];

    const handleShow = () => {
        setShow(true);
    };

    const handleClose = () => {
        setFileNames("");
        setErrors("");
        setShow(false);
        setFormData({
            project: projectId ? projectId : "null",
            letter_num: "",
            reply_by: "",
            subject: "",
            letter_date: "null",
            status: "pending",
            workperformedby_contractor: letterfor ? letterfor : "null",
            lettertype: lettertype ? lettertype : "null",
            letterExchange: "null",
            associated_letters: [],
            associated_letters_status: "pending",
            letterdepartment: "",
            letter_from: "null",
            letter_to: "",
            documents: [{ document_name: "", document_file: "" }],
            contractor: contractor ? contractor : "",
            remarks: '',
            select: '',
        })

        setEOTFormData({
            project: formData.project ? formData.project : "null",
            eot_code: "",
            workperformedby_contractor: formData.workperformedby_contractor ? formData.workperformedby_contractor : "",
            approved_days: "",
            approved_date: "",
            close_letter: "",
            letter: "",
            contractor: "",
            process_initiate_date: "",
            eot_status: "pending",
            days: "",
        });

        setCOSFormData({
            project: formData.project ? formData.project : "null",
            cos_code: "",
            approval_date: "",
            contractor: "",
            process_initiate_date: "",
            cos_status: "pending",
            amount: "",
            workperformedby_contractor: formData.workperformedby_contractor ? formData.workperformedby_contractor : "",
            letter: "",
            approved_amount: "",
            close_letter: "",
            cos_type: "",
            negativeamount: "",
        })

        setmileStoneFormData({
            name: "",
            milestone_date: "",
            milestone_as_per_reschedule: "",
            milestone_as_per_actual: "",
            day: "",
            rescedule_gap_days: "",
            actual_gap_days: "",
            workperformedby_contractor: "contractor",
            project: formData.project ? formData.project : "null",
            reschedule_letter: "",
            contractor: "",
            actual_letter: "",
        });

        setProgressErrors("");
    };

    const [formData, setFormData] = useState({
        project: projectId ? projectId : "null",
        letter_num: "",
        reply_by: "",
        subject: "",
        letter_date: "null",
        status: "pending",
        workperformedby_contractor: letterfor ? letterfor : "null",
        lettertype: lettertype ? lettertype : "null",
        letterExchange: "null",
        associated_letters: null,
        associated_letters_status: "pending",
        letterdepartment: "",
        letter_from: "null",
        letter_to: "",
        documents: [{ document_name: "", document_file: "" }],
        contractor: contractor ? contractor : "",
        remarks: '',
        select: '',
        other_letter_type: "",
    });

    // const filteredData = eotList.filter(i => i.id === eotID);
    const [filteredData, setFilteredData] = useState([]);
    const [cosFilteredData, setcosFilteredData] = useState([]);
    const [mileStoneFilteredData, setmileStoneFilteredData] = useState([]);
    const [progressfilterData, setprogressfilterData] = useState([]);


    console.log("EOTcoDE")
    console.log(filteredData[0]?.eot_code);
    console.log(filteredData)

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            project: projectId
        }))
    }, [projectId]);


    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            workperformedby_contractor: letterfor
        }))
    }, [letterfor]);



    const [eotFormData, setEOTFormData] = useState({
        project: formData.project ? formData.project : "null",
        eot_code: "",
        workperformedby_contractor: "",
        approved_days: "",
        approved_date: "",
        close_letter: "",
        letter: "",
        contractor: "",
        process_initiate_date: "",
        eot_status: "pending",
        days: "",
    });

    const [cosFormData, setCOSFormData] = useState({
        project: formData.project ? formData.project : "null",
        cos_code: "",
        approval_date: "",
        contractor: "",
        process_initiate_date: "",
        cos_status: "pending",
        amount: "",
        workperformedby_contractor: "",
        letter: "",
        approved_amount: "",
        close_letter: "",
        cos_type: "",
        negativeamount: "",
    })
    const [mileStoneFormData, setmileStoneFormData] = useState({
        name: "",
        milestone_date: "",
        milestone_as_per_reschedule: "",
        milestone_as_per_actual: "",
        day: "",
        rescedule_gap_days: "",
        actual_gap_days: "",
        workperformedby_contractor: "",
        project: formData.project ? formData.project : "null",
        reschedule_letter: "",
        contractor: "",
        actual_letter: "",
        mile_stone_type: "null",
    })

    const [progressData, setProgressData] = useState({
        project: formData.project ? formData.project : "null",
        submitted_financial_progress: "0",
        submitted_physical_progress: "0",
        month: "",
        year: "",
        submitted_letter: "",
        contractor,
        financial_progress: "0",
        approved_letter: "",
        physical_progress: "0",
        date: "null"
    })


    const calculateActualDays = (commencementDate, letterDate) => {
        if (!commencementDate || !letterDate) return null;
        const startDate = new Date(commencementDate);
        const endDate = new Date(letterDate);
        const timeDifference = endDate - startDate;
        const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
        return daysDifference;
    };

    useEffect(() => {

        setEotId("null");
        seteotInputState({});
        setFormData((prevFormData) => ({
            ...prevFormData,
            letter_date: "null",

        }));
        setErrors("");
        setEOTFormData({
            project: formData.project || "",
            eot_code: "",
            workperformedby_contractor: "",
            approved_days: "",
            approved_date: "",
            close_letter: "",
            letter: "",
            contractor: "",
            process_initiate_date: "",
            eot_status: "pending",
            days: "",
        });


        setCosId("null");
        setcosInputState({});

        setCOSFormData({
            project: formData.project || "",
            cos_code: "",
            approval_date: "",
            contractor: "",
            process_initiate_date: "",
            cos_status: "pending",
            amount: "",
            workperformedby_contractor: "",
            letter: "",
            approved_amount: "",
            close_letter: "",
            cos_type: "",
            negativeamount: "",
        })

        setmileStoneId("null");
        setmileStoneInputState({});
        setmileStoneFormData({
            name: "",
            milestone_date: "",
            milestone_as_per_reschedule: "",
            milestone_as_per_actual: "",
            day: "",
            rescedule_gap_days: "",
            actual_gap_days: "",
            workperformedby_contractor: "",
            project: formData.project || "",
            reschedule_letter: "",
            contractor: "",
            actual_letter: "",

        });
        setprogressID("null");
        setprogressInputState({})
        setProgressData({
            project: formData.project || "",
            submitted_financial_progress: "0",
            submitted_physical_progress: "0",
            month: "",
            year: "",
            submitted_letter: "",
            contractor,
            financial_progress: "0",
            approved_letter: "",
            physical_progress: "0",
        })



    }, [formData.workperformedby_contractor, formData.contractor, formData.project, formData.select, formData.lettertype]);

    useEffect(() => {

        setEOTFormData({
            approved_days: "",
            eot_status: "",
        });
        setCOSFormData({
            approved_amount: "",
            cos_status: "",
        });
        setProgressData((prev) => ({
            ...prev,
            month: "",
            year: "",
        }))
        setmileStoneFormData({
            mile_stone_type: "null",
        });
        setFormData((prev) => ({
            ...prev,
            letter_date: "null",
        }));
    }, [eotID, cosID, mileStoneID, progressID]);


    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            lettertype: "null",
        }))

    }, [formData.workperformedby_contractor])

    useEffect(() => {
        if ((Array.isArray(contractorlist) && contractorlist.length < 0) ||
            (Array.isArray(contractorlists) && contractorlists.length < 0)) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                workperformedby_contractor: "consultant",
                contractor: contractor ? contractor : "",
            }))
        }
        else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                workperformedby_contractor: letterfor ? letterfor : "null",
                contractor: contractor ? contractor : "",
            }))
        }
    }, [formData.project]);



    useEffect(() => {
        if (eotID !== "null") {
            const data = eotList.filter((i) => i.id === eotID);
            setFilteredData(data);
        }
        else if (cosID !== "null") {
            const data = cosList.filter((i) => i.id === cosID);
            setcosFilteredData(data);
        }
        else if (mileStoneID !== "null") {
            const data = mileStoneList.filter((i) => i.id === mileStoneID);
            setmileStoneFilteredData(data);
        }
        else if (progressID !== "null") {
            const data = progressList.filter((i) => i.id === progressID);
            setprogressfilterData(data);
        }
        else {
            setFilteredData([]);
            setcosFilteredData([]);
            setmileStoneFilteredData([]);
            setprogressfilterData([]);
        }
    }, [eotID, eotList, cosID, cosList, mileStoneID, mileStoneList, progressID, progressList]);

    console.log("filteredData", filteredData);
    console.log("cosFilteredData", cosFilteredData);


    useEffect(() => {
        const days = calculateActualDays(contractorData.commencement_date, formData.letter_date);
        if (eotID !== "null") {
            if (filteredData.length > 0) {
                const data = filteredData[0];
                setEOTFormData((prev) => ({
                    ...prev,
                    project: formData.project,
                    workperformedby_contractor: formData.workperformedby_contractor,
                    contractor: formData.contractor,
                    approved_date: formData.letter_date,
                    process_initiate_date: data?.process_initiate_date,
                    eot_code: data?.eot_code,
                    letter: data?.letter,
                    days: data?.days,
                    close_letter: data.close_letter ? data?.close_letter : formData?.letter,
                }));
            }
        }
        if (cosID !== "null") {
            if (cosFilteredData.length > 0) {
                const data = cosFilteredData[0];
                setCOSFormData((prev) => ({
                    ...prev,
                    project: formData.project,
                    workperformedby_contractor: formData.workperformedby_contractor,
                    contractor: formData.contractor,
                    approval_date: formData.letter_date,
                    amount: data?.amount,
                    process_initiate_date: data?.process_initiate_date,
                    cos_code: data?.cos_code,
                    letter: data?.letter,
                    cos_type: data?.cos_type,
                    negativeamount: data?.negativeamount,
                    close_letter: data?.close_letter ? data?.close_letter : formData?.letter,
                }));
            }
        }
        if (progressID !== "null") {
            if (progressfilterData.length > 0) {
                const data = progressfilterData[0];
                setProgressData((prev) => ({
                    ...prev,
                    project: formData.project,
                    submitted_physical_progress: data?.submitted_physical_progress,
                    submitted_financial_progress: data?.submitted_financial_progress,
                    month: data?.month,
                    year: data?.year,
                    submitted_letter: data?.submitted_letter,
                    approved_letter: formData?.letter,
                    contractor: formData.contractor,
                    date: formData.date


                }));
            }
        }
        if (mileStoneID !== "null" && mileStoneFormData.mile_stone_type === "actual") {
            if (mileStoneFilteredData.length > 0) {
                const data = mileStoneFilteredData[0];
                setmileStoneFormData((prev) => ({
                    ...prev,
                    project: formData.project,
                    workperformedby_contractor: formData.workperformedby_contractor,
                    contractor: formData.contractor,
                    milestone_as_per_actual: formData.letter_date,
                    milestone_as_per_reschedule: null,
                    rescedule_gap_days: "",
                    actual_gap_days: days,
                    milestone_date: data?.milestone_date,
                    name: data?.name,
                    day: data?.day,
                    // close_letter: formData?.letter,
                }));
            }
        }
        if (mileStoneID !== "null" && mileStoneFormData.mile_stone_type === "reschedule") {
            if (mileStoneFilteredData.length > 0) {
                const data = mileStoneFilteredData[0];
                setmileStoneFormData((prev) => ({
                    ...prev,
                    project: formData.project,
                    workperformedby_contractor: formData.workperformedby_contractor,
                    contractor: formData.contractor,
                    milestone_as_per_reschedule: formData.letter_date,
                    milestone_date: data?.milestone_date,
                    rescedule_gap_days: days,
                    day: data?.day,
                    milestone_as_per_actual: null,
                    actual_gap_days: "",
                    // close_letter: formData?.letter,
                }));
            }
        }
        if (cosFormData.cos_status === "rejected") {
            setCOSFormData((prev) => ({
                ...prev,
                approved_amount: "",
            }))
        }
        if (formData.lettertype === "Eot" && eotID === "null") {
            setEOTFormData((prev) => ({
                ...prev,
                contractor: formData.contractor,
                project: formData.project,
                workperformedby_contractor: formData.workperformedby_contractor,
                process_initiate_date: formData.letter_date,
                approved_date: null,
                eot_code: "",
                letter: "",
                days: "",
            }));
        }
        if (formData.lettertype === 'cos' && cosID === "null") {
            setCOSFormData((prev) => ({
                ...prev,
                contractor: formData.contractor,
                project: formData.project,
                workperformedby_contractor: formData.workperformedby_contractor,
                process_initiate_date: formData.letter_date,
                approval_date: null,
                cos_code: "",
                letter: "",
                amount: "",
                negativeamount: "",
                cos_type: "",
            }))
        }
        if (formData.lettertype === 'SiteProgress' && progressID === "null") {
            setProgressData((prev) => ({
                ...prev,
                contractor: formData.contractor,
                project: formData.project,
                submitted_letter: "",
                financial_progress: "",
                physical_progress: "",
                month: "",
                year: "",
                submitted_physical_progress: "",
                submitted_financial_progress: "",
            }))
        }
    }, [formData.project, formData.workperformedby_contractor, formData.contractor, formData.letter_date, formData.select, formData.lettertype, eotID, eotFormData.eot_status, cosID, cosFormData.cos_status, mileStoneID, mileStoneFormData.mile_stone_type, contractorData.commencement_date, progressID]);

    useEffect(() => {
        if (cosFormData.cos_type === "positivecos") {

            setCOSFormData((prev) => ({
                ...prev,
                negativeamount: "",
            }));
        }
        if (cosFormData.cos_type === "negativecos") {

            setCOSFormData((prev) => ({
                ...prev,
                amount: "",
            }));
        }
        else {
            setCOSFormData((prev) => ({
                ...prev,
                amount: "",
                negativeamount: "",
            }));
        }
    }, [cosFormData.cos_type])

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            letter_date: "null",
        }));

        setmileStoneFormData((prev) => ({
            ...prev,
            actual_gap_days: "",
            rescedule_gap_days: "",
        }))
    }, [mileStoneFormData.mile_stone_type])

    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            select: "",
        }));
    }, [formData.lettertype]);






    const validateForm = () => {
        const requiredFields = [
            // 'letter_num',
            'project',
            // 'subject',
            'letter_date',
            // 'status',
            'lettertype',
            'workperformedby_contractor',
            // 'letterExchange',
            // 'letter_to',
            // 'letterdepartment',
            // 'letter_from',
        ];
        const newErrors = requiredFields.reduce((acc, field) => {
            if (
                !formData[field] ||
                formData[field] === "null" ||
                (Array.isArray(formData[field]) && formData[field].length === 0)
            ) {
                acc[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required!`;
            }
            return acc;
        }, {});
        if (formData.workperformedby_contractor === "contractor" && !formData.contractor) {
            newErrors["contractor"] = "Contractor Name is required!";
        }
        if ((formData.lettertype === "Eot" || formData.lettertype === "cos" || formData.lettertype === "Milestone" || formData.lettertype === "SiteProgress") && (!formData.select || formData.select.trim() === "")) {
            newErrors["select"] = `Select ${formData.lettertype} is required`;
        }
        if (formData.select === "new") {
            if (formData.lettertype === "Eot" && (!eotFormData.eot_code || eotFormData.eot_code.trim() === "")) {
                newErrors["eot_code"] = `eot_code is required`;
            }
            if (formData.lettertype === "Eot" && (!eotFormData.days || eotFormData.days.trim() === "")) {
                newErrors["days"] = `Initiate days are required`;
            }
            if (formData.lettertype === "cos" && (!cosFormData.cos_code || cosFormData.cos_code.trim() === "")) {
                newErrors["cos_code"] = `cos_code is required`;
            }
            if (formData.lettertype === "cos" && (!cosFormData.cos_type || cosFormData.cos_type.trim() === "")) {
                newErrors["cos_type"] = `COS Type is required`;
            }
            if ((formData.lettertype === "cos" && cosFormData.cos_type === "negativecos") && (!cosFormData.negativeamount || cosFormData.negativeamount.trim() === "")) {
                newErrors["negativeamount"] = `Negative Amount is required`;
            }
            if ((formData.lettertype === "cos" && cosFormData.cos_type === "negativecos") && (!cosFormData.amount || cosFormData.amount.trim() === "")) {
                newErrors["amount"] = `Positive Amount is required`;
            }
            if (formData.lettertype === "SiteProgress" && (!progressData.month || progressData.month.trim() === "")) {
                newErrors["month"] = `Month is required`;
            }
            if (formData.lettertype === "SiteProgress" && (!progressData.year || progressData.year.trim() === "")) {
                newErrors["year"] = `Year is required`;
            }
            // if (formData.lettertype === "SiteProgress" && (!progressData.submitted_financial_progress || progressData.submitted_financial_progress.trim() === "")) {
            //   newErrors["submitted_financial_progress"] = `Submitted financial Progress is required`;
            // }
            // if (formData.lettertype === "SiteProgress" && (!progressData.submitted_physical_progress || progressData.submitted_physical_progress.trim() === "")) {
            //   newErrors["submitted_physical_progress"] = `Submitted Physcial Progress is required`;
            // }
        }

        if (formData.select === "existing") {
            if (formData.lettertype === "Eot" && (eotID === "null")) {
                newErrors["eotID"] = `Existing Eot is required`;
            }
            if (formData.lettertype === "Eot" && eotID !== "null" && (!eotFormData.eot_status || eotFormData.eot_status.trim() === "")) {
                newErrors["eot_status"] = `Eot Status is required`;
            }
            if (formData.lettertype === "Eot" && eotID !== "null" && eotFormData.eot_status === "Approved" && (!eotFormData.approved_days || eotFormData.approved_days.trim() === "")) {
                newErrors["approved_days"] = `Approved Days is required`;
            }
            if (formData.lettertype === "Eot" && eotID !== "null" && (!formData.associated_letters || formData.associated_letters.length === 0)) {
                newErrors["associated_letters"] = `Associated Letter  is required`;
            }
            if (formData.lettertype === "cos" && (cosID === "null")) {
                newErrors["cosID"] = `Existing COS is required`;
            }
            if (formData.lettertype === "cos" && cosID !== "null" && (!cosFormData.cos_status || cosFormData.cos_status.trim() === "")) {
                newErrors["cos_status"] = `COS Status is required`;
            }
            if (formData.lettertype === "cos" && cosID !== "null" && cosFormData.cos_status === "Approved" && (!cosFormData.approved_amount || cosFormData.approved_amount.trim() === "")) {
                newErrors["approved_amount"] = `Approved Amount is required`;
            }
            if (formData.lettertype === "cos" && cosID !== "null" && (!formData.associated_letters || formData.associated_letters.length === 0)) {
                newErrors["associated_letters"] = `Associated Letter  is required`;
            }
            if (formData.lettertype === "Milestone" && (mileStoneID === "null")) {
                newErrors["mileStoneID"] = `Existing Milestone is required`;
            }
            if (formData.lettertype === "Milestone" && mileStoneID !== "null" && (!mileStoneFormData.mile_stone_type || mileStoneFormData.mile_stone_type.trim() === "null")) {
                newErrors["mile_stone_type"] = `MileStone Type is required`;
            }
            if (formData.lettertype === "SiteProgress" && (progressID === "null")) {
                newErrors["progressID"] = `Existing Progress is required`;
            }
            // if (formData.lettertype === "SiteProgress" && progressID !== "null" && (!progressData.physical_progress || progressData.physical_progress.trim() === "0")) {
            //   newErrors["physical_progress"] = `Physical Progress is required`;
            // }
            // if (formData.lettertype === "SiteProgress" && progressID !== "null" && (!progressData.financial_progress || progressData.financial_progress.trim() === "0")) {
            //   newErrors["financial_progress"] = `Financial Progress is required`;
            // }


        }


        if (
            formData.associated_letters &&
            formData.associated_letters.length > 0 &&
            !formData.associated_letters_status
        ) {
            newErrors["associated_letters_status"] =
                "Status for associated letters is required!";
        }

        // Validate documents array
        formData.documents.forEach((doc, index) => {
            if (!doc.document_name || doc.document_name.trim() === "") {
                newErrors[`document_name_${index}`] = `Document Name is required for document ${index + 1}`;
            }
            if (!doc.document_file) {
                newErrors[`document_file_${index}`] = `Document File is required for document ${index + 1}`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    console.log("errors");
    console.log(errors);

    const getContractorData = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/project_details/contractorbyproject/${formData.project || ''}`);
            setContractorData(res.data)
        } catch (error) {
            console.error(error);

        }
    }



    useEffect(() => {
        getContractorData();
    }, [formData.project])

    const handleInputChange = (e) => {
        const { name, value, type, options } = e.target;

        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else {
            newValue = value;
        }

        // Update the input state for validation feedback
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                newValue && (Array.isArray(newValue) ? newValue.length > 0 : newValue)
                    ? "success"
                    : "",
        }));

        // Update form data with additional logic for resetting the contractor field
        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,

                // Handle the letter_from logic if reply_by and letterExchange conditions are met
                ...(name === "reply_by" &&
                    prevFormData.letterExchange === "send" && {
                    letter_from: value,
                }),

                // Reset contractor if workperformedby_contractor is set to consultant
                ...(name === "workperformedby_contractor" &&
                    value === "consultant" && {
                    contractor: "",
                }),
            };

            return updatedFormData;
        });
    };

    const handleEotInputChange = (e) => {
        const { name, value } = e.target;
        seteotInputState({
            ...eotinputState,
            [name]: value.trim() ? "green" : "",
        });
        setEOTFormData({
            ...eotFormData,
            [name]: value,
        });
    };
    const handleCOSInputChange = (e) => {
        const { name, value } = e.target;
        setcosInputState({
            ...cosinputState,
            [name]: value.trim() ? "green" : "",
        });
        setCOSFormData({
            ...cosFormData,
            [name]: value,
        });
    };
    const handleMilestoneChange = (e) => {
        const { name, value } = e.target;
        setmileStoneInputState({
            ...mileStoneinputState,
            [name]: value.trim() ? "green" : "",
        });
        setmileStoneFormData({
            ...mileStoneFormData,
            [name]: value,
        });
    };

    const [progresserrors, setProgressErrors] = useState({
        submitted_physical_progress: "",
        submitted_financial_progress: "",
    });

    const handleProgressData = (e) => {
        const { name, value } = e.target;
        let errorMessage = "";

        if (name === "submitted_physical_progress") {
            if (Number(value) < previousprogressdata.physical_progress || Number(value) > 100) {
                errorMessage = `Value must be between ${previousprogressdata.physical_progress}% - 100%`;
            }
        }
        if (name === "physical_progress") {
            if (Number(value) < previousprogressdata.physical_progress || Number(value) > 100) {
                errorMessage = `Value must be between ${previousprogressdata.physical_progress}% - 100%`;
            }
        }

        if (name === "financial_progress") {
            if (Number(value) < previousprogressdata.financial_progress || Number(value) > 100) {
                errorMessage = `Value must be between ${previousprogressdata.financial_progress}% - 100%`;
            }
        }
        if (name === "submitted_financial_progress") {
            if (Number(value) < previousprogressdata.financial_progress || Number(value) > 100) {
                errorMessage = `Value must be between ${previousprogressdata.financial_progress}% - 100%`;
            }
        }
        setprogressInputState({
            ...progressInputState,
            [name]: value.trim() ? "green" : "",
        });

        setProgressData({
            ...progressData,
            [name]: value,
        });

        setProgressErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMessage,
        }));
    };




    const handleDocInputChange = (index, e) => {
        const { name, value, files } = e.target;

        setFormData((prevFormData) => {
            const newDocuments = [...prevFormData.documents];
            newDocuments[index] = {
                ...newDocuments[index],
                [name]: files ? files[0] : value,
            };
            if (files) {
                setFileNames((prevFileNames) => {
                    const newFileNames = [...prevFileNames];
                    newFileNames[index] = files[0]?.name || "";
                    return newFileNames;
                });
            }

            return { ...prevFormData, documents: newDocuments };
        });
    };

    const handleAddDocuments = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            documents: [
                ...prevFormData.documents,
                { document_name: "", document_file: null },
            ],
        }));
    };

    const handleRemoveDocument = (index) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            documents: prevFormData.documents.filter((_, i) => i !== index),
        }));
        setFileNames((prevFileNames) =>
            prevFileNames.filter((_, i) => i !== index)
        );
    };

    const createCustomFile = (originalFile) => {
        const randomCode = generateRandomString();
        const now = new Date();
        const date = now.toISOString().split("T")[0];
        const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
        const customFileName = `Aimantra ${date} ${time}_${randomCode}_${originalFile.name}`;
        return new File([originalFile], customFileName, {
            type: originalFile.type,
        });
    };

    const generateRandomString = () => {
        const chars =
            "!@#$%^&*()_+abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        return Array.from(
            { length: 8 },
            () => chars[Math.floor(Math.random() * chars.length)]
        ).join("");
    };

    const options = trackRecordList
        .sort((a, b) => parseInt(a.letter_num) - parseInt(b.letter_num))
        .map((e) => ({
            value: e.id,
            label: `${e.letter_num} - ${e.letter_date}`,
        }));


    const handleChangecc = (selected) => {
        const associated_letters =
            selected.length > 0 ? selected.map((item) => item.value) : "";
        setFormData((prevState) => ({
            ...prevState,
            associated_letters,
        }));
    };

    console.log("cosID");
    console.log(cosID);
    // const fetchAssociatedLetters = async () => {
    //   try {
    //     const res = await axios.get(
    //       eotID !== "null" ? `${BASE_URL}/project_details/letterrecordsbyid/${(eotFormData.eot_status === "pending" && eotFormData.close_letter !== "") ? eotFormData.close_letter : eotFormData.letter}/` :
    //         progressID !== "null" ? `${BASE_URL}/project_details/letterrecordsbyid/${progressData.submitted_letter}/` :
    //           cosID !== "null" ? `${BASE_URL}/project_details/letterrecordsbyid/${cosFormData.letter}/` :
    //             `${BASE_URL}/project_details/letterrecordbclosestatus/${formData.project || 'null'
    //             }/${formData.workperformedby_contractor || 'null'}/${formData.lettertype || 'null'}/`
    //     );
    //     setTrackRecordList(res.data);
    //   } catch (err) {
    //     console.error("Error fetching letters.", err);
    //   }
    // };
    const fetchAssociatedLetters = async () => {
        try {
            let url = "";

            if (eotID !== "null") {
                const letterId =
                    eotFormData?.close_letter
                        ? eotFormData.close_letter
                        : eotFormData?.letter;
                url = `${BASE_URL}/correspondence/letterrecordsbyid/${letterId}/`;
            } else if (progressID !== "null") {
                url = `${BASE_URL}/correspondence/letterrecordsbyid/${progressData?.submitted_letter}/`;
            } else if (cosID !== "null") {
                const letterId =
                    cosFormData?.close_letter
                        ? cosFormData.close_letter
                        : cosFormData?.letter;
                url = `${BASE_URL}/correspondence/letterrecordsbyid/${letterId}/`;
            } else {
                url = `${BASE_URL}/correspondence/letterrecordbclosestatus/${formData.project || 'null'}/${formData.workperformedby_contractor || 'null'}/${formData.lettertype || 'null'}/`;
            }

            const res = await axios.get(url);
            setTrackRecordList(res.data);
        } catch (err) {
            console.error("Error fetching letters.", err);
        }
    };


    console.log("eotid")
    console.log(eotID)

    const getProjectContractorDetails = async () => {
        try {
            const contractordetails = await axios.get(
                `${BASE_URL}/project_details/contractorbyproject/${formData.project}/`
            );
            setContractorLists(contractordetails.data);
            setContractorData(contractordetails.data)
        } catch (err) {
            // handleErrorToast(err);
        } finally {
        }
    };

    console.log("progressID")
    console.log(progressID)

    const getEot = async () => {

        try {
            // let eot = await axios.get(`${BASE_URL}/project_details/eot/`);
            let eot = await axios.get(`${BASE_URL}/project_details/eotfilter/${formData.project}/${formData.workperformedby_contractor}/${formData.contractor ? formData.contractor : null}/pending/`);
            setEotList(eot.data);


        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {

        }
    };
    const getMilestone = async () => {

        try {
            let milestone = await axios.get(`${BASE_URL}/project_details/milestonebycontractor/${formData.contractor}/`);
            setmileStoneList(milestone.data);


        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {

        }
    };
    const getCOS = async () => {

        try {
            // let eot = await axios.get(`${BASE_URL}/project_details/eot/`);
            let cos = await axios.get(`${BASE_URL}/project_details/cosfilter/${formData.project}/${formData.workperformedby_contractor}/${formData.contractor ? formData.contractor : null}/pending/`);
            setCosList(cos.data);


        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {

        }
    };
    const { month, year } = progressData;


    useEffect(() => {
        if ((formData.project && formData.workperformedby_contractor) || eotID !== "null" || cosID !== "null" || progressID !== "null") {
            fetchAssociatedLetters();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.project, formData.workperformedby_contractor, formData.lettertype, formData.select, eotID, eotFormData.letter, cosFormData.letter, progressID, progressData.submitted_letter, eotFormData.eot_status, eotFormData.close_letter, cosFormData.close_letter]);


    useEffect(() => {
        if (!progressData.submitted_letter) {


            if (!progressData.month || !progressData.year) {
                console.error("Both month and year are required to fetch progress data.");
                return;
            }
        }

        const fetchProgressData = async () => {

            try {
                if (year < oldestYear) {
                    console.warn(`Skipping loop: Year (${year}) is not greater than oldestYear (${oldestYear}).`);
                    return;
                }
                let currentMonth = month - 1 === 0 ? 12 : month - 1; // Start with the previous month
                let currentYear = month - 1 === 0 ? year - 1 : year; // Adjust year if previous month is December
                let dataFound = false; // Flag to check if data is found

                while (!dataFound) {
                    const response = await axios.get(
                        `${BASE_URL}/project_details/progressbyproject/${formData.project}/${formData.contractor}/${currentMonth}/${currentYear}/`
                    );

                    const progressData = response.data;

                    if (progressData.length > 0) {
                        // Assuming progressData is an array
                        const { financial_progress, physical_progress } = progressData[0]; // Take the first item

                        // Set the values
                        setPreviousProgressData({
                            financial_progress,
                            physical_progress,
                        });

                        console.log("Financial Progress:", financial_progress);
                        console.log("Physical Progress:", physical_progress);

                        dataFound = true; // Exit the loop
                    } else {
                        console.warn(
                            `No progress data found for ${currentMonth}/${currentYear}. Checking the previous month.`
                        );

                        // Move to the previous month
                        currentMonth -= 1;
                        if (currentMonth === 0) {
                            currentMonth = 12;
                            currentYear -= 1; // Move to the previous year
                        }

                        // Stop the loop if we reach an unrealistic limit (e.g., 10 years back)
                        if (currentYear < year - 1) {
                            console.error("No data found for the past year.");
                            break;
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching progress data:", error);
            }
        };




        fetchProgressData();
    }, [month, year]);

    const getProgress = async () => {
        setBuffering(true); // Start buffering

        try {
            const response = await axios.get(
                `${BASE_URL}/project_details/progressbyproject/${formData.project}/${formData.contractor}/`
            );

            setprogressList(response.data);

            // Extract and process year field
            const yearField = response.data.map(item => ({
                ...item,
                year: item.year || 0, // Default to 0 if missing
            }));



            // Find the oldest year
            const oldestYear = yearField.reduce((min, item) =>
                item.year && item.year < min ? item.year : min,
                Infinity
            );
            setOldestYear(oldestYear);

            console.log("Oldest Year:", oldestYear);

        } catch (err) {
            console.log("Error fetching progress:", err);
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End buffering
        }
    };






    useEffect(() => {
        // Check if conditions are met before calling getEot
        if (formData.project !== "null"
        ) {

            if (formData.lettertype === "Eot") {
                getEot();
            }
            if (formData.lettertype === "cos") {
                getCOS();
            }
            if (formData.contractor !== "" && formData.lettertype === "Milestone") {
                getMilestone();
            }

            if (formData.contractor !== "" && formData.lettertype === "SiteProgress") {
                getProgress();
            }
        }
    }, [formData.project, formData.workperformedby_contractor, formData.contractor, formData.lettertype, formData.select, eotID, cosID, mileStoneID, progressID]);



    const handleFormSubmit = async (e) => {
        e.preventDefault();

        for (let doc of formData.documents) {
            console.log(doc, "doc")
        }
        if (validateForm()) {
            setLoading(true);
            // const loadingToastId = toast.loading("Loading: Please wait...");

            try {
                const formDataToSend = new FormData();

                // // Append general form fields (excluding documents)
                // Object.keys(formData).forEach((key) => {
                //   if (key !== "documents" && formData[key]) {
                //     if (key === "associated_letters") {
                //       formData[key].forEach((value) => formDataToSend.append(key, value));
                //     } else {
                //       formDataToSend.append(key, formData[key]);
                //     }
                //   }
                // });

                // Append general form fields (excluding documents)
                Object.keys(formData).forEach((key) => {
                    if (key !== "documents" && formData[key]) {
                        if (key === "associated_letters") {
                            formDataToSend.append(key, JSON.stringify(formData[key])); // stringify the array
                        } else {
                            formDataToSend.append(key, formData[key]);
                        }
                    }
                });




                // Upload files in chunks and collect file IDs
                let fileIndex = 0;
                for (let doc of formData.documents) {

                    if (doc.document_file) {
                        const fileId = await uploadFileInChunks(doc.document_file, doc.document_name);
                        if (!fileId) {
                            console.error(`❌ Failed to upload file: ${doc.document_name}`);
                            continue; // Skip this file instead of returning
                        }
                        console.log(doc, "documents")
                        formDataToSend.append("file_ids", fileId);
                        formDataToSend.append(`documents[${fileIndex}][document_name]`, doc.document_name);
                        // const fileNameWithoutExt = doc.document_file.name.substring(0, doc.document_file.name.lastIndexOf('.')) || doc.document_file.name;
                        // formDataToSend.append(`documents[${fileIndex}][original_filename]`, doc.document_file.file);
                        formDataToSend.append(`documents[${fileIndex}][original_filename]`, doc.document_file.name);
                        formDataToSend.append(`documents[${fileIndex}][file]`, doc.document_file);

                        fileIndex++; // Ensure indices remain correct


                    }
                }

                if (!formDataToSend.has("file_ids")) {
                    console.error("❌ No valid files were uploaded.");
                    setLoading(false);
                    return;
                }

                // Send request with updated FormData
                const res = await axiosInstance.post(
                    `${BASE_URL}/correspondence/documentbulkwithletter-new/`,
                    formDataToSend,
                    {
                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            setUploadProgress(percentCompleted);
                        },
                    }
                );

                if (res.status === 200) {

                    // handleClose();
                    // toast.dismiss(loadingToastId);
                    const generatedId = res.data.letter.id;
                    setletterId(generatedId);
                    try {
                        const letteremail = await axios.post(
                            `${BASE_URL}/correspondence/sendletternotificationtoauthorityengineeronNewLetter/`,
                            { letter_id: generatedId }
                        );

                        if (letteremail.status === 200) {
                            await getProjects();
                            toast.success("Letter Documents uploaded successfully!");
                            handleClose();
                        }
                    } catch (error) {
                        console.error(error);
                    }
                } else {
                    throw new Error("Document upload failed");
                }
            } catch (err) {
                toast.error("Error uploading documents");
                console.error("Error uploading documents", err);
            } finally {
                setLoading(false);
                // toast.dismiss(loadingToastId);
                setUploadProgress(0);
            }
        }
    };



    useEffect(() => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            contractor: letterfor === "contractor" ? contractor : "",
        }));
    }, [contractor]);
    useEffect(() => {
        if (formData.project !== "null") {
            getProjectContractorDetails();
        }
    }, [formData.project]);

    console.log("doc.document_file.name");

    console.log(formData.documents.name);

    return (
        <>
            <button
                title={`Add ${title} Details`}
                className="upload-svg equal-hieg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> {` ${title}`}
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title>Add {title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="register-form">
                        <div className="form-flex-wrap">

                            {sessionStorage.getItem('role') === "SiteManagement" ? "" :

                                ((projectId === 'null' || projectId === undefined || projectId === "") && (
                                    <div className="form-group">
                                        <RenderSelectField
                                            title="Project"
                                            name="project"
                                            required={true}
                                            options={projectList?.map((project) => ({
                                                value: project.id,
                                                label: `${project.site_prcode} - ${project.project_short_name}`,
                                            }))}
                                            placeholder="Select a Project"
                                            formData={formData}
                                            errors={errors}
                                            inputState={inputState}
                                            handleInputChange={handleInputChange}
                                        />
                                        {errors.project && (
                                            <div className="error-message col">
                                                {errors.project}
                                            </div>
                                        )}
                                    </div>
                                ))
                            }



                            <div className="form-group">
                                <RenderSelectField
                                    title="Letter Exchange"
                                    name="letterExchange"

                                    options={[
                                        { value: "send", label: "Send" },
                                        { value: "receive", label: "Received" },
                                    ]}
                                    placeholder="Select an Exchange Type"
                                    formData={formData}
                                    errors={errors}
                                    inputState={inputState}
                                    handleInputChange={handleInputChange}
                                />
                                {errors.letterExchange && (
                                    <div className="error-message col">
                                        {errors.letterExchange}
                                    </div>
                                )}
                            </div>

                            {formData.letterExchange === "send" && (
                                <div className="form-group">
                                    <RenderSelectField
                                        title="Reply By"
                                        name="reply_by"

                                        options={[
                                            { value: "HO", label: "Head Office" },
                                            { value: "SO", label: "Site Office" },
                                        ]}
                                        placeholder="Select a Reply By"
                                        formData={formData}
                                        errors={errors}
                                        inputState={inputState}
                                        handleInputChange={handleInputChange}
                                    />
                                    {errors.reply_by && (
                                        <div className="error-message col">{errors.reply_by}</div>
                                    )}
                                </div>
                            )}

                            <div className="form-group">
                                <RenderInputField
                                    title={`${formData.letterExchange === "null" ? "" : toTitleCase(formData.letterExchange)} Letter No.`}
                                    name="letter_num"

                                    placeholder="Letter Number"
                                    formData={formData}
                                    errors={errors}
                                    inputState={inputState}
                                    handleInputChange={handleInputChange}
                                />
                                {errors.letter_num && (
                                    <div className="error-message col">{errors.letter_num}</div>
                                )}
                            </div>


                            {letterfor ? <></> :

                                (
                                    <div className="form-group">
                                        <RenderSelectField
                                            title="Letter Related To"
                                            name="workperformedby_contractor"

                                            // options={[
                                            //     ...(formData.project &&
                                            //         ((Array.isArray(contractorlist) &&
                                            //             contractorlist.length > 0) ||
                                            //             (Array.isArray(contractorlists) &&
                                            //                 contractorlists.length > 0))
                                            //         ? [{ value: "contractor", label: "Contractor" }]
                                            //         : []),
                                            //     { value: "consultant", label: "Consultant" },
                                            // ]}
                                            options={contractorData?.map(contractor => ({
                                                value: contractor.id,
                                                label: contractor.name,
                                            }))}
                                            required={true}
                                            placeholder="Select Option"
                                            formData={formData}
                                            errors={errors}
                                            inputState={inputState}
                                            handleInputChange={handleInputChange}
                                        />
                                        {errors.workperformedby_contractor && (
                                            <div className="error-message col">
                                                {errors.workperformedby_contractor}
                                            </div>
                                        )}
                                    </div>
                                )}

                            {formData.workperformedby_contractor === 'contractor' ?
                                <div className="form-group">
                                    <div title=" Contractor Name" className="flex-column form-group-selectt">
                                        <label htmlFor="project" className="form-labels  font-weight500    font-size-subheading">
                                            Contractor Name
                                        </label>
                                        <br />
                                        <select
                                            id="contractor"
                                            name="contractor"
                                            value={formData.contractor}
                                            onChange={handleInputChange}
                                            disabled={!!contractor}

                                            className={`form-input form-group-selection ${errors.contractor ? "error" : inputState.contractor ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select a Contractor</option>
                                            {contractorlists?.sort((a, b) => a.name?.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                                <option value={i.id}>{i.name}</option>
                                            </>))
                                            }
                                        </select>


                                        <DropdownArrow />

                                    </div>

                                    {errors.contractor && (
                                        <div className="error-message col">{errors.contractor}</div>
                                    )}
                                </div>
                                : ""
                            }

                            {lettertype ?
                                <></>
                                :
                                <>
                                    <div className="form-group">
                                        <RenderSelectField
                                            title="Letter Type"
                                            name="lettertype"

                                            options={[
                                                { value: "show-cause", label: "Show Cause" },
                                                { value: "informative", label: "Informative" },
                                                // { value: "eot", label: "EOT" },
                                                // { value: "cos", label: "COS" },
                                                { value: "billing", label: "Billing" },
                                                { value: "design", label: "Design" },
                                                { value: "ncr", label: "NCR" },

                                                { value: "Design & Drawing", label: "Design & Drawing" },
                                                { value: "P&P", label: "P&P" },
                                                { value: "QAP", label: "QAP" },
                                                { value: "Structure", label: "Structure" },
                                                { value: "Q & ME", label: "Q & ME" },
                                                { value: "BBS", label: "BBS" },
                                                { value: "noc", label: "NOC" },
                                                { value: "Road Safety", label: "Road Safety" },
                                                { value: "Work Plan", label: "Work Plan" },
                                                { value: "Drain", label: "Drain" },
                                                { value: "Hydrology", label: "Hydrology" },
                                                { value: "Survey", label: "Survey" },
                                                // ...(formData.workperformedby_contractor === "contractor"
                                                //     ? [{ value: "Milestone", label: "Milestone" }]
                                                //     : []),
                                                { value: "query", label: "Query" },
                                                // { value: "SiteProgress", label: "SiteProgress" },
                                                { value: "other", label: "Others" }
                                            ]}
                                            placeholder="Select a Letter Type"
                                            formData={formData}
                                            errors={errors}
                                            inputState={inputState}
                                            handleInputChange={handleInputChange}
                                        />
                                        {errors.lettertype && (
                                            <div className="error-message col">{errors.lettertype}</div>
                                        )}
                                    </div></>
                            }
                            {formData.lettertype === "other" && <div className="form-group">
                                <RenderInputField
                                    title={`${formData.lettertype === "other" ? "" : toTitleCase(formData.lettertype)} Letter Type Other.`}
                                    name="other_letter_type"
                                    required={true}
                                    placeholder="Letter Type Other"
                                    formData={formData}
                                    errors={errors}
                                    inputState={inputState}
                                    handleInputChange={handleInputChange}
                                />
                                {errors.letter_num && (
                                    <div className="error-message col">{errors.letter_num}</div>
                                )}
                            </div>}
                            {(formData.lettertype === "Eot" ||
                                formData.lettertype === "COS" ||
                                formData.lettertype === "MP" ||
                                formData.lettertype === "SP") &&
                                formData.workperformedby_contractor !== "null" && (
                                    <div className="form-group">
                                        <div className="flex-column form-group-selectt">
                                            <label
                                                htmlFor="select"
                                                className="form-labels font-weight500 font-size-subheading"
                                            >
                                                <span>Select {formData.lettertype}</span>
                                            </label>
                                            <br />
                                            <select
                                                id="select"
                                                name="select"
                                                placeholder="select"
                                                value={formData.select}
                                                onChange={handleInputChange}
                                                className={`form-input form-group-selection ${errors.select ? "error" : inputState.select ? "success" : ""}`}
                                            >
                                                <option value="">Select</option>

                                                {formData.lettertype !== "Milestone" && (
                                                    <option value="new">New {formData.lettertype}</option>
                                                )}
                                                <option value="existing">Existing {formData.lettertype}</option>

                                                {/* {(formData.lettertype === "Eot" && eotList?.length > 0) ||
                          (formData.lettertype === "cos" && cosList?.length > 0) ||
                          (formData.lettertype === "Milestone" && mileStoneList?.length > 0) ||
                          (formData.lettertype === "SiteProgress" && progressData?.length > 0) ? (
                          <option value="existing">Existing {formData.lettertype}</option>
                        ) : null} */}
                                            </select>

                                            <DropdownArrow />
                                        </div>

                                        {errors.select && <div className="error-message col">{errors.select}</div>}
                                    </div>
                                )}



                            {formData.select === "new" ?
                                <>
                                    {formData.lettertype === "Eot" ?
                                        <>
                                            <div className="form-group">
                                                <RenderDateInputField
                                                    title={`${formData.letterExchange === "null" ? "" : toTitleCase(formData.letterExchange)} Letter Date`}
                                                    name="letter_date"
                                                    type="date"
                                                    max={today}
                                                    required={true}
                                                    formData={formData}
                                                    errors={errors}
                                                    inputState={inputState}
                                                    handleInputChange={handleInputChange}
                                                />
                                                {errors.letter_date && (
                                                    <div className="error-message col">{errors.letter_date}</div>
                                                )}
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-labels font-weight500 font-size-subheading"
                                                    title="EOT Code">EOT Code</label>
                                                <input
                                                    type="text"
                                                    name="eot_code"
                                                    placeholder="EOT Code"
                                                    title="EOT Code"
                                                    value={eotFormData.eot_code}
                                                    onChange={handleEotInputChange}
                                                    className={`form-input ${errors.eot_code ? "error" : eotinputState.eot_code ? "success" : ""}`}
                                                />
                                                {errors.eot_code && <span className="error-message font-size-text">{errors.eot_code}</span>}
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-labels font-weight500 font-size-subheading" title="Initiate Days">
                                                    Initiate Days
                                                </label>
                                                <input
                                                    type="number"
                                                    name="days"
                                                    title="Initiate Days"
                                                    placeholder="Initiate Days"
                                                    value={eotFormData.days}
                                                    onChange={handleEotInputChange}
                                                    className={`form-input ${errors.days
                                                        ? "error"
                                                        : inputState.days
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                />
                                                {errors.days && (
                                                    <span className="error-message font-size-text">
                                                        {errors.days}
                                                    </span>
                                                )}
                                            </div>

                                        </> : ""
                                    }
                                    {formData.lettertype === "COS" ?
                                        <>
                                            <div className="form-group">
                                                <RenderInputField
                                                    title={`${formData.letterExchange === "null" ? "" : toTitleCase(formData.letterExchange)} Letter Date`}
                                                    name="letter_date"
                                                    type="date"
                                                    required={true}
                                                    formData={formData}
                                                    max={today}
                                                    errors={errors}
                                                    inputState={inputState}
                                                    handleInputChange={handleInputChange}
                                                />
                                                {errors.letter_date && (
                                                    <div className="error-message col">{errors.letter_date}</div>
                                                )}
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-labels font-weight500 font-size-subheading"
                                                    title="COS Code">COS Code</label>
                                                <input
                                                    type="text"
                                                    name="cos_code"
                                                    placeholder="COS Code"
                                                    title="COS Code"
                                                    value={cosFormData.cos_code}
                                                    onChange={handleCOSInputChange}
                                                    className={`form-input ${errors.cos_code ? "error" : eotinputState.cos_code ? "success" : ""}`}
                                                />
                                                {errors.cos_code && <span className="error-message font-size-text">{errors.cos_code}</span>}
                                            </div>
                                            <div className="flex-column form-group-selectt">
                                                <label className="form-labels font-weight500 font-size-subheading" title="COS Type">COS Type <span className="required">*</span></label>
                                                <br />
                                                <select
                                                    name="cos_type"
                                                    title="COS Type"
                                                    value={cosFormData.cos_type}
                                                    onChange={handleCOSInputChange}
                                                    className={`form-input form-group-selection`}
                                                >
                                                    <option value="">Select COS Type</option>
                                                    <option value="negativecos">Negative COS</option>
                                                    <option value="positivecos">Positive COS</option>

                                                </select>
                                                <div className="form-group-selection-arrow">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="25"
                                                        fill="currentColor"
                                                        className="bi bi-caret-down-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                                    </svg>
                                                </div>
                                                {errors.cos_type && <div className="error-message font-size-text">{errors.cos_type}</div>}
                                            </div>
                                            {cosFormData.cos_type === 'positivecos' ?
                                                <div className="flex-column">
                                                    <label className="form-labels font-weight500 font-size-subheading"
                                                        title="Positive COS Amount">Positive COS Amount(Write Full Amount)</label>
                                                    <input
                                                        type="number"
                                                        name="amount"
                                                        placeholder="Positive COS Amount"
                                                        title="Positive COS Amount"
                                                        value={cosFormData.amount}
                                                        onChange={handleCOSInputChange}
                                                        className={`form-input ${errors.amount ? "error" : eotinputState.amount ? "success" : ""}`}
                                                    />
                                                    {errors.amount && <span className="error-message font-size-text">{errors.amount}</span>}
                                                </div> :
                                                cosFormData.cos_type === 'negativecos' ?
                                                    <div className="flex-column">
                                                        <label className="form-labels font-weight500 font-size-subheading"
                                                            title="Negative COS Amount">Negative COS Amount(Write Full Amount)</label>
                                                        <input
                                                            type="number"
                                                            name="negativeamount"
                                                            placeholder="Negative COS Amount"
                                                            title="Negative COS Amount"
                                                            value={cosFormData.negativeamount}
                                                            onChange={handleCOSInputChange}
                                                            className={`form-input ${errors.negativeamount ? "error" : eotinputState.negativeamount ? "success" : ""}`}
                                                        />
                                                        {errors.negativeamount && <span className="error-message font-size-text">{errors.negativeamount}</span>}
                                                    </div> : ""
                                            }
                                        </> : ""
                                    }
                                    {formData.lettertype === "SP" &&
                                        <>
                                            <div className="form-group">
                                                <RenderInputField
                                                    title={`${formData.letterExchange === "null" ? "" : toTitleCase(formData.letterExchange)} Letter Date`}
                                                    name="letter_date"
                                                    type="date"

                                                    max={today}
                                                    formData={formData}
                                                    errors={errors}
                                                    inputState={inputState}
                                                    handleInputChange={handleInputChange}
                                                />
                                                {errors.letter_date && (
                                                    <div className="error-message col">{errors.letter_date}</div>
                                                )}
                                            </div>
                                            <div className="flex-column">
                                                <label className="form-labels font-weight500 font-size-subheading">
                                                    Month
                                                </label>
                                                <select
                                                    name="month"
                                                    value={progressData.month}
                                                    className="form-input"
                                                    onChange={handleProgressData}
                                                >
                                                    <option value=''>Select Month</option>
                                                    {months.map((month) => (
                                                        <option
                                                            key={month.value}
                                                            value={month.value}
                                                            disabled={progressList.some(
                                                                (data) => data.month === String(month.value) && data.year === String(progressData.year)
                                                            )}
                                                        >
                                                            {month.text}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.month && <span className="error-message font-size-text">{errors.month}</span>}

                                            </div>

                                            {/* Frozen Year Field */}
                                            <div className="flex-column">
                                                <label className="form-labels font-weight500 font-size-subheading">
                                                    Year
                                                </label>
                                                <select
                                                    name="year"
                                                    value={progressData.year}
                                                    className="form-input"
                                                    onChange={handleProgressData}
                                                >
                                                    <option value=''>Select Year</option>

                                                    {[...Array(10)].map((_, index) => {
                                                        const year = new Date().getFullYear() - index;
                                                        return (
                                                            <option
                                                                key={year}
                                                                value={year}
                                                                disabled={progressList.some(
                                                                    (data) => data.year === String(year) && data.month === String(progressData.month)
                                                                )}
                                                            >
                                                                {year}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                                {errors.year && <span className="error-message font-size-text">{errors.year}</span>}

                                            </div>
                                            <>
                                                {(progressData.month && progressData.year) &&
                                                    <>
                                                        <div className="flex-column">
                                                            <label className="form-labels font-weight500 font-size-subheading">
                                                                Submitted Physical Progress (%)
                                                            </label>
                                                            <input
                                                                type="number"
                                                                min={previousprogressdata.physical_progress}
                                                                placeholder={previousprogressdata.physical_progress || 0}
                                                                name="submitted_physical_progress"
                                                                onChange={handleProgressData}
                                                                className={`form-input ${progresserrors.submitted_physical_progress ? "input-error" : ""}`}
                                                            />
                                                            {progresserrors.submitted_physical_progress && (
                                                                <span className="error-message">{progresserrors.submitted_physical_progress}</span>
                                                            )}
                                                        </div>

                                                        {/* Submitted Financial Progress */}
                                                        <div className="flex-column">
                                                            <label className="form-labels font-weight500 font-size-subheading">
                                                                Submitted Financial Progress (%)
                                                            </label>
                                                            <input
                                                                type="number"
                                                                min={previousprogressdata.financial_progress}
                                                                placeholder={previousprogressdata.financial_progress || 0}
                                                                name="submitted_financial_progress"
                                                                onChange={handleProgressData}
                                                                className={`form-input ${progresserrors.submitted_financial_progress ? "input-error" : ""}`}
                                                            />
                                                            {progresserrors.submitted_financial_progress && (
                                                                <span className="error-message">{progresserrors.submitted_financial_progress}</span>
                                                            )}
                                                        </div>
                                                    </>
                                                }
                                            </>


                                        </>
                                    }


                                </>
                                :
                                formData.select === "existing" ?
                                    <>
                                        {formData.lettertype === "Eot" ?
                                            <div className="form-group">
                                                <div className="flex-column form-group-selectt">
                                                    <label
                                                        htmlFor="select"
                                                        className="form-labels  font-weight500    font-size-subheading"
                                                    >
                                                        Existing EOT
                                                    </label>
                                                    <br />
                                                    <select

                                                        value={eotID}
                                                        onChange={(e) => setEotId(e.target.value)}


                                                        className={`form-input form-group-selection`}
                                                    >
                                                        <option value="">Select Existing Eot</option>
                                                        {eotList?.sort((a, b) => a.eot_code?.localeCompare(b.eot_code, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                                            <option value={i.id}>{i.eot_code}</option>
                                                        </>))
                                                        }
                                                    </select>
                                                    <DropdownArrow />
                                                </div>
                                                {errors.eotID && (
                                                    <div className="error-message col">{errors.eotID}</div>
                                                )}
                                            </div>
                                            : ""
                                        }
                                        {formData.lettertype === "COS" ?
                                            <div className="form-group">
                                                <div className="flex-column form-group-selectt">
                                                    <label
                                                        htmlFor="select"
                                                        className="form-labels  font-weight500    font-size-subheading"
                                                    >
                                                        Existing COS
                                                    </label>
                                                    <br />
                                                    <select

                                                        value={cosID}
                                                        onChange={(e) => setCosId(e.target.value)}


                                                        className={`form-input form-group-selection`}
                                                    >
                                                        <option value="">Select Existing Cos</option>
                                                        {cosList?.sort((a, b) => a.cos_code?.localeCompare(b.cos_code, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                                            <option value={i.id}>{i.cos_code}</option>
                                                        </>))
                                                        }
                                                    </select>
                                                    <DropdownArrow />
                                                </div>
                                                {errors.cosID && (
                                                    <div className="error-message col">{errors.cosID}</div>
                                                )}
                                            </div>
                                            : ""
                                        }
                                        {formData.lettertype === "SP" ?
                                            <div className="form-group">
                                                <div className="flex-column form-group-selectt">
                                                    <label
                                                        htmlFor="select"
                                                        className="form-labels  font-weight500    font-size-subheading"
                                                    >
                                                        Existing Site Progress<span className="required">*</span>
                                                    </label>
                                                    <br />
                                                    <select

                                                        value={progressID}
                                                        onChange={(e) => setprogressID(e.target.value)}


                                                        className={`form-input form-group-selection`}
                                                    >
                                                        <option value="">Select Existing Site Progress</option>
                                                        {progressList?.filter(
                                                            (item) => !item.approved_letter // Exclude items with either actualLetter or rescheduleLetter
                                                        ).sort((a, b) => a.year?.localeCompare(b.year, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                                            <option value={i.id}>{i.month}-{i.year}</option>
                                                        </>))
                                                        }
                                                    </select>
                                                    <DropdownArrow />
                                                </div>
                                                {errors.progressID && (
                                                    <div className="error-message col">{errors.progressID}</div>
                                                )}
                                            </div>
                                            : ""
                                        }
                                        {formData.lettertype === "milestone" ?
                                            <>
                                                <div className="form-group">
                                                    <div className="flex-column form-group-selectt">
                                                        <label
                                                            htmlFor="select"
                                                            className="form-labels  font-weight500    font-size-subheading"
                                                        >
                                                            Existing Milestone
                                                        </label>
                                                        <br />
                                                        <select

                                                            value={mileStoneID}
                                                            onChange={(e) => setmileStoneId(e.target.value)}


                                                            className={`form-input form-group-selection`}
                                                        >
                                                            <option value="">Select Existing Milestone</option>
                                                            {mileStoneList
                                                                ?.filter(
                                                                    (item) => !item.reschedule_letter && !item.actual_letter // Exclude items with either actualLetter or rescheduleLetter
                                                                )
                                                                .sort((a, b) => a.name?.localeCompare(b.name, 'en', { ignorePunctuation: true }))
                                                                .map((i) => (
                                                                    <option key={i.id} value={i.id}>
                                                                        {i.name}
                                                                    </option>
                                                                ))}

                                                        </select>
                                                        <DropdownArrow />
                                                    </div>
                                                    {errors.mileStoneID && (
                                                        <div className="error-message col">{errors.mileStoneID}</div>
                                                    )}
                                                </div>
                                                <div className="form-group">
                                                    <div className="flex-column form-group-selectt">
                                                        <label
                                                            htmlFor="mile_stone_type"
                                                            className="form-labels  font-weight500    font-size-subheading"
                                                        >
                                                            Milestone Type

                                                        </label>
                                                        <br />
                                                        <select id="mile_stone_type"
                                                            name="mile_stone_type"
                                                            placeholder="Select"
                                                            value={mileStoneFormData.mile_stone_type}

                                                            onChange={handleMilestoneChange}
                                                            className={`form-input form-group-selection ${errors.select ? "error" : inputState.select ? "success" : ""
                                                                }`}
                                                        >
                                                            <option value="null">Select Milestone Type</option>
                                                            <option value="actual">Actual {formData.lettertype}</option>
                                                            <option value="reschedule">Reschedule {formData.lettertype}</option>

                                                        </select>
                                                        <DropdownArrow />

                                                    </div>
                                                    {errors.mile_stone_type && (
                                                        <div className="error-message col">{errors.mile_stone_type}</div>
                                                    )}
                                                </div>
                                            </>
                                            : ""
                                        }

                                    </> : ""
                            }
                            {formData.select !== "new" &&
                                <div className="form-group">
                                    <RenderInputField
                                        title={`${formData.letterExchange === "null" ? "" : toTitleCase(formData.letterExchange)} Letter Date`}
                                        name="letter_date"
                                        type="date"
                                        required={true}
                                        max={today}

                                        formData={formData}
                                        errors={errors}
                                        inputState={inputState}
                                        handleInputChange={handleInputChange}
                                    />
                                    {errors.letter_date && (
                                        <div className="error-message col">{errors.letter_date}</div>
                                    )}
                                </div>
                            }


                            {eotID !== "null" ?
                                <>
                                    <div className="form-group">
                                        <div className="flex-column form-group-selectt">
                                            <label className="form-labels font-weight500 font-size-subheading" title="EOT Status">EOT Status</label>
                                            <br />
                                            <select
                                                name="eot_status"
                                                title="EOT status"
                                                value={eotFormData.eot_status}
                                                onChange={handleEotInputChange}
                                                className={`form-input form-group-selection`}
                                            >
                                                <option value="">Select Status</option>
                                                <option value="pending">Pending</option>
                                                <option value="Approved">Approved</option>
                                                <option value="rejected">Rejected</option>

                                            </select>
                                            <DropdownArrow />
                                        </div>
                                        {errors.eot_status && <div className="error-message font-size-text">{errors.eot_status}</div>}
                                    </div>

                                    {
                                        eotFormData.eot_status === "Approved" &&
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading" title="Approved Days">
                                                Approved Days
                                            </label>
                                            <input
                                                type="number"
                                                name="approved_days"
                                                title="Approved Days"
                                                placeholder="Approved Days"
                                                value={eotFormData.approved_days}
                                                onChange={handleEotInputChange}
                                                className={`form-input ${errors.approved_days
                                                    ? "error"
                                                    : inputState.approved_days
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.approved_days && (
                                                <span className="error-message font-size-text">
                                                    {errors.approved_days}
                                                </span>
                                            )}
                                        </div>
                                    }




                                </> : <></>

                            }
                            {cosID !== "null" ?
                                <>
                                    <div className="form-group">
                                        <div className="flex-column form-group-selectt">
                                            <label className="form-labels font-weight500 font-size-subheading" title="Cos Status">Cos Status</label>
                                            <br />
                                            <select
                                                name="cos_status"
                                                title="Cos status"
                                                value={cosFormData.cos_status}
                                                onChange={handleCOSInputChange}
                                                className={`form-input form-group-selection`}
                                            >
                                                <option value="">Select Status</option>
                                                <option value="pending">Pending</option>
                                                <option value="Approved">Approved</option>
                                                <option value="rejected">Rejected</option>

                                            </select>
                                            <DropdownArrow />
                                        </div>
                                        {errors.cos_status && <div className="error-message font-size-text">{errors.cos_status}</div>}
                                    </div>

                                    {
                                        cosFormData.cos_status === "Approved" &&
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading" title="Approved Amount">
                                                Approved Amount
                                            </label>
                                            <input
                                                type="number"
                                                name="approved_amount"
                                                title="Approved Amount"
                                                placeholder="Approved Amount"
                                                value={cosFormData.approved_amount}
                                                onChange={handleCOSInputChange}
                                                className={`form-input ${errors.approved_amount
                                                    ? "error"
                                                    : cosinputState.approved_amount
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.approved_amount && (
                                                <span className="error-message font-size-text">
                                                    {errors.approved_amount}
                                                </span>
                                            )}
                                        </div>
                                    }




                                </> : <></>

                            }
                            {progressID !== "null" && formData.letter_date !== "null" ?
                                <>
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Actual  Physical Progress (%)
                                        </label>
                                        <input
                                            type="number"
                                            min={previousprogressdata.physical_progress}
                                            placeholder={previousprogressdata.physical_progress || 0}
                                            name="physical_progress"
                                            onChange={handleProgressData}
                                            className={`form-input ${progresserrors.physical_progress ? "input-error" : ""}`}
                                        />
                                        {progresserrors.physical_progress && (
                                            <span className="error-message">{progresserrors.physical_progress}</span>
                                        )}
                                    </div>

                                    {/* Submitted Financial Progress */}
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Actual Financial Progress (%)<span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            min={previousprogressdata.financial_progress}
                                            placeholder={previousprogressdata.financial_progress || 0}
                                            name="financial_progress"
                                            onChange={handleProgressData}
                                            className={`form-input ${progresserrors.financial_progress ? "input-error" : ""}`}
                                        />
                                        {progresserrors.financial_progress && (
                                            <span className="error-message">{progresserrors.financial_progress}</span>
                                        )}
                                    </div>





                                </> : <></>

                            }
                            {mileStoneID !== "null" ?
                                <>

                                    {
                                        mileStoneFormData.mile_stone_type === "actual" &&
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading" title="Actual Gap Days">
                                                Actual Gap Days<span className="required">(Read-Only)*</span>
                                            </label>
                                            <input
                                                type="number"
                                                name="actual_gap_days"
                                                title="Actual Gap Days"
                                                placeholder="Actual Gap Days"
                                                value={mileStoneFormData.actual_gap_days}
                                                onChange={handleMilestoneChange}
                                                className={`form-input ${errors.actual_gap_days
                                                    ? "error"
                                                    : mileStoneinputState.actual_gap_days
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.actual_gap_days && (
                                                <span className="error-message font-size-text">
                                                    {errors.actual_gap_days}
                                                </span>
                                            )}
                                        </div>
                                    }
                                    {
                                        mileStoneFormData.mile_stone_type === "reschedule" &&
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading" title="Reschedule Gap Days">
                                                Reschedule Gap Days<span className="required">(Read-Only)*</span>
                                            </label>
                                            <input
                                                type="number"
                                                name="rescedule_gap_days"
                                                title="Reschedule Gap Days"
                                                placeholder="Reschedule Gap Days"
                                                value={mileStoneFormData.rescedule_gap_days}
                                                onChange={handleMilestoneChange}
                                                className={`form-input ${errors.rescedule_gap_days
                                                    ? "error"
                                                    : mileStoneinputState.rescedule_gap_days
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.rescedule_gap_days && (
                                                <span className="error-message font-size-text">
                                                    {errors.rescedule_gap_days}
                                                </span>
                                            )}
                                        </div>
                                    }




                                </> : <></>

                            }




                            <div className="form-group">
                                <RenderInputTextareaField
                                    title="Subject"
                                    name="subject"
                                    placeholder="Enter subject here..."
                                    rows={5}
                                    cols={50}
                                    formData={formData}
                                    errors={errors}

                                    inputState={inputState}
                                    handleInputChange={handleInputChange}
                                />
                                {errors.subject && (
                                    <div className="error-message col">{errors.subject}</div>
                                )}
                            </div>
                            <div className="form-group">
                                <div title="Status" className="flex-column form-group-selectt">
                                    <label
                                        htmlFor="status"
                                        className="form-labels  font-weight500    font-size-subheading"
                                    >
                                        Status<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select id="status"
                                        name="status"
                                        placeholder="Status"
                                        value={formData.status}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.status ? "error" : inputState.status ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select a Status</option>
                                        <option value="pending">Pending</option>
                                        <option value="approved">Approved</option>
                                        <option value="submit">Submit</option>
                                        {formData.letterExchange === "receive" ? "" :
                                            <option value="close">Close</option>
                                        }

                                    </select>
                                    <DropdownArrow />
                                </div>
                                {errors.status && (
                                    <div className="error-message col">{errors.status}</div>
                                )}
                            </div>


                            {formData.letterExchange === 'receive' &&
                                <div className="form-group">
                                    <RenderInputField
                                        title="Letter From"
                                        name="letter_from"
                                        placeholder="Letter From"
                                        max={100}
                                        formData={formData}

                                        errors={errors}
                                        inputState={inputState}
                                        handleInputChange={handleInputChange}
                                    />
                                    {errors.letter_from && (
                                        <div className="error-message col">
                                            {errors.letter_from}
                                        </div>
                                    )}
                                </div>}

                            <div className="form-group">
                                <RenderInputField
                                    title="Letter To"
                                    name="letter_to"
                                    placeholder="Letter To"
                                    max={100}

                                    formData={formData}
                                    errors={errors}
                                    inputState={inputState}
                                    handleInputChange={handleInputChange}
                                />
                                {errors.letter_to && (
                                    <div className="error-message col">{errors.letter_to}</div>
                                )}
                            </div>
                            <div className="form-group">
                                <RenderInputField
                                    title="Remarks"
                                    name="remarks"
                                    placeholder="Remarks"
                                    max={100}

                                    formData={formData}
                                    errors={errors}
                                    inputState={inputState}
                                    handleInputChange={handleInputChange}
                                />
                                {errors.remarks && (
                                    <div className="error-message col">{errors.remarks}</div>
                                )}
                            </div>

                            <div className="flex-column">
                                <label
                                    htmlFor="names"
                                    className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                >
                                    Associated Letters
                                </label>
                                <Select
                                    options={options}
                                    isMulti
                                    onChange={handleChangecc}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '33vw',
                                            minHeight: '50px',
                                            // height: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f7f8fa',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            width: '33vw',
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />
                                {errors.associated_letters && (
                                    <span className="error-message font-size-text">
                                        {errors.associated_letters}
                                    </span>
                                )}
                            </div>

                            {/* Show status options if associated letters are selected */}
                            {formData.associated_letters &&
                                formData.associated_letters.length > 0 && (
                                    <>
                                        <div className="form-column">
                                            <RenderSelectField
                                                title="Update Status of Associated Letters"
                                                name="associated_letters_status"

                                                options={[
                                                    { value: "pending", label: "Pending" },
                                                    { value: "close", label: "Close" },
                                                ]}
                                                placeholder="Select Status"
                                                formData={formData}
                                                errors={errors}
                                                inputState={inputState}
                                                handleInputChange={handleInputChange}
                                            />
                                            {errors.associated_letters_status && (
                                                <div className="error-message col">
                                                    {errors.associated_letters_status}
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                        </div>

                        <DocumentSection
                            formData={formData}
                            handleDocInputChange={handleDocInputChange}
                            handleAddDocuments={handleAddDocuments}
                            handleRemoveDocument={handleRemoveDocument}
                            errors={errors}
                            fileNames={fileNames}
                            inputState={inputState}
                        />

                        {/* Upload Progress Bar */}
                        {uploadProgress > 0 && (
                            <div className="progress-bar">
                                <div
                                    className="progress-bar-fill"
                                    style={{ width: `${uploadProgress}%` }}
                                ></div>
                                <span>{uploadProgress}%</span>
                            </div>
                        )}

                        <div className="button-models">
                            <button
                                onClick={handleFormSubmit}
                                className="model-button font-weight500 model-button-submit"
                                disabled={loading}
                            >
                                Submit
                            </button>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (

                                    <h6 className="text-center">
                                        {Object.keys(errors).map((field) =>
                                            field.charAt(0).toUpperCase() + field.slice(1)
                                        ).join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </form>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>


            </Modal>
        </>
    )

};







const UpdateTrackRecordDetails = ({
    i,
    title,
    getProjects,
    projectList,
    projectId,
    letterType,
    workperformedby_contractor,
    associatedletters,
    documents,

}) => {
    const [show, setShow] = useState(false);

    const [letterdata, setLetterdata] = useState(false);
    const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format








    const handleClose = () => {
        setShow(false);
        setFileNames([]);
        setErrors("");
        setFormDataDoc({
            documents: [
                {
                    document_name: "",
                    document_file: "",
                },
            ],
        })

        // setFormData({
        //   letter_num: "",
        //   project: projectId ? projectId : "",
        //   subject: "",
        //   letter_date: "",
        //   reply_by: "",
        //   status: "pending",
        //   workperformedby_contractor: workperformedby_contractor ? workperformedby_contractor : "",
        //   lettertype: letterType ? letterType : "",
        //   letterExchange: "",
        //   letter_from: "",
        //   letterdepartment: "null",
        //   documents: [
        //     {
        //       document_name: "",
        //       document_file: "",
        //     },
        //   ],
        //   letter_to: "",
        //   associated_letters: associatedletters ? associatedletters : [],
        //   associated_letters_status: "",

        // });


    }



    const handleShow = () => {
        setFormData(i)
        setShow(true);
        // getAsociatedLetters(i);
        getLettersingle();

    };
    const getLettersingle = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/correspondence/getletterrecordanddoc/${i.id
                }/`
            );
            setLetterdata(res.data);

            setFormData(res.data)
        } catch (err) {
            // toast.error('Error fetching letters.');
            handleErrorToast(err);
        }
    };




    const [formData, setFormData] = useState({
        letter_num: "",
        project: projectId ? projectId : "",
        subject: "",
        letter_date: "",
        reply_by: "",
        status: "pending",
        workperformedby_contractor: workperformedby_contractor ? workperformedby_contractor : "",
        lettertype: letterType ? letterType : "",
        letterExchange: "",
        letter_from: "",
        letterdepartment: "null",

        letter_to: "",
        associated_letters: associatedletters ? associatedletters : [],
        associated_letters_status: "",
        documents: [
            {
                document_name: "",
                document_file: "",
            },
        ],
    });

    const [formDataDoc, setFormDataDoc] = useState({
        documents: [
            // {
            //     document_name: "",
            //     document_file: "",
            // },
        ],
    });




    // console.log(i)





    const [trackRecordList, setTrackRecordList] = useState([]);
    const [optionsList, setoptionsList] = useState([]);
    const getAsociatedLetters = async (i) => {
        try {
            const res = await axios.get(
                `${BASE_URL}/correspondence/letterrecordbclosestatus/${i.project
                }/${i.workperformedby_contractor}/${i.lettertype}`
            );
            setTrackRecordList(res.data);
        } catch (err) {
            // toast.error('Error fetching letters.');
            handleErrorToast(err);
        }
    };

    // useEffect(() => {

    // }, [formData.workperformedby_contractor, formData.project]);

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const requiredFields = [
            // "letter_num",
            // "project",
            // "subject",
            // "letter_date",
            // "status",
            // "lettertype",
            // "workperformedby_contractor",
            // 'workperformedby_contractor',
            // 'letterExchange',
            // 'letter_to',
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        const newErrors = requiredFields.reduce((acc, field) => {
            if (
                !formData[field] ||
                (Array.isArray(formData[field]) && formData[field].length === 0)
            ) {
                acc[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required!`;
            }
            return acc;
        }, {});

        // if (
        //   formData.associated_letters &&
        //   formData.associated_letters.length > 0 &&
        //   !formData.associated_letters_status
        // ) {
        //   newErrors["associated_letters_status"] =
        //     "Status for associated letters is required!";
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // const handleInputChange = (e) => {
    //   const {name, value} = e.target;

    //   setInputState({
    //     ...inputState,
    //     [name]: value.trim() ? "green" : "",
    //   });

    //   setFormData({
    //     ...formData,
    //     [name]: value,
    //   });
    // };

    const handleInputChange = (e) => {
        const { name, value, type, options } = e.target;
        console.log(name, value, "name ,vlaue")
        let newValue;
        // Handle multiple select inputs
        if (type === 'select-multiple') {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else {
            newValue = value;
        }

        // Update input state for UI feedback
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                newValue && (Array.isArray(newValue) ? newValue.length > 0 : newValue)
                    ? "success"
                    : "",
        }));

        // Update form data based on the input change
        setFormData((prevFormData) => {
            const updatedData = {
                ...prevFormData,
                [name]: newValue,
                //  *********  Need to check this condition *********
                // ...(name === 'lettertype' && {
                //     status:
                //         newValue === 'informative' || newValue === 'show-cause'
                //             ? newValue
                //             : prevFormData.status,
                // }),

                ...(name === 'reply_by' && prevFormData.letterExchange === 'send' && {
                    letter_from: value,
                }),
            };




            return updatedData;
        });

    };

    // ?  ************** Validation End **************  ! //

    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); // Start loading
            const loadingToastId = toast.loading("Loading: Please wait..."); // Display loading toast
            console.log("1")
            try {
                const formDataToSend = new FormData();

                // Loop through formData keys, skipping 'documents'
                Object.keys(formData).forEach((key) => {
                    if (key !== "documents" && formData[key]) {
                        if (key === "associated_letters") {
                            // Append each associated letter to the form data
                            formData[key].forEach((value) => formDataToSend.append(key, value));
                        } else {
                            formDataToSend.append(key, formData[key]);
                        }
                    }
                });

                console.log("2")
                // // Process documents, create custom filenames, and append to formData
                // formDataDoc.documents.forEach((doc, index) => {
                //   const symbols = "!@#$%^&*()_-+=";
                //   const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
                //   const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                //   const numbers = "0123456789";
                //   const now = new Date();
                //   const date = now.toLocaleDateString("en-GB").split("/").reverse().join("-");
                //   const time = now.toLocaleTimeString("en-GB", { hour12: false }).replace(/:/g, "-");
                //   const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
                //   let randomCode = "";

                //   // Generate random code for unique filename
                //   for (let i = 0; i < 8; i++) {
                //     const randomIndex = Math.floor(Math.random() * allChars.length);
                //     randomCode += allChars[randomIndex];
                //   }

                //   const originalFile = doc.document_file;
                //   const customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
                //   const customFile = new File([originalFile], customFileName, {
                //     type: originalFile.type,
                //   });

                //   // Check if the document has a valid file before appending
                //   if (doc.document_file) {
                //     formDataToSend.append(`documents[${index}][document_name]`, doc.document_name);
                //     formDataToSend.append(`documents[${index}][document_file]`, customFile);
                //   } else {
                //     console.warn(`Document file at index ${index} is not valid.`);
                //   }
                // });

                // // Logging for debugging (can be removed in production)
                // console.log("FormData to send:");
                // formDataToSend.forEach((value, key) => {
                //   if (value instanceof File) {
                //     console.log(`${key}: [File] ${value.name} - ${value.size} bytes`);
                //   } else {
                //     console.log(`${key}: ${value}`);
                //   }
                // });


                // Upload files in chunks and collect file IDs
                let fileIndex = 0;

                for (let doc of formDataDoc.documents) {
                    if (doc.document_file) {
                        const fileId = await uploadFileInChunks(doc.document_file, doc.document_name);
                        if (!fileId) {
                            console.error(`❌ Failed to upload file: ${doc.document_name}`);
                            continue; // Skip this file instead of returning
                        }
                        console.log(doc, "documents")
                        formDataToSend.append("file_ids", fileId);
                        formDataToSend.append(`documents[${fileIndex}][document_name]`, doc.document_name);
                        // const fileNameWithoutExt = doc.document_file.name.substring(0, doc.document_file.name.lastIndexOf('.')) || doc.document_file.name;
                        // formDataToSend.append(`documents[${fileIndex}][original_filename]`, doc.document_file.file);
                        formDataToSend.append(`documents[${fileIndex}][original_filename]`, doc.document_file.name);
                        // formDataToSend.append(`documents[${fileIndex}][file]`, doc.document_file);
                        formDataToSend.append(`documents[${fileIndex}][document_file]`, doc.document_file);

                        fileIndex++; // Ensure indices remain correct


                    }
                }
                console.log("3")
                console.log("formDataToSend")
                console.log(formDataToSend)

                if (!formDataToSend.has("file_ids")) {
                    console.error("❌ No valid files were uploaded.");
                    // setLoading(false);
                    // return;
                }
                console.log("4")

                // Send the PUT request with the FormData
                let res = await axios.put(
                    `${BASE_URL}/correspondence/documentbulkwithletterupdate/${formData.id}/`,
                    formDataToSend,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                console.log("5")

                // Handle response
                if (res.status === 200) {
                    console.log("6")
                    setShow(false); // Close modal or update UI
                    await getProjects(); // Fetch updated project data
                } else {
                    alert("Failed to update the record.");
                }
                console.log("7")
            } catch (err) {
                handleErrorToast(err); // Handle and show errors using toast
            } finally {
                setLoading(false); // End loading
                toast.dismiss(loadingToastId); // Dismiss loading toast
            }
        }
    };


    const [fileNames, setFileNames] = useState([]);

    const handleDocInputChange = (index, e) => {
        const { name, value, type, files } = e.target;

        setFormDataDoc((prevFormData) => {
            const newDocuments = [...prevFormData.documents];
            if (type === "file") {
                newDocuments[index] = {
                    ...newDocuments[index],
                    [name]: files[0],
                };
                setFileNames((prevFileNames) => {
                    const newFileNames = [...prevFileNames];
                    newFileNames[index] = files[0]?.name;
                    return newFileNames;
                });
            } else {
                newDocuments[index] = {
                    ...newDocuments[index],
                    [name]: value.trim() ? value : "",
                };
            }
            return {
                ...prevFormData,
                documents: newDocuments,
            };
        });
    };

    const handleAddDocuments = (e) => {
        e.preventDefault();
        setFormDataDoc((prevFormData) => ({
            ...prevFormData,
            documents: [
                ...prevFormData.documents,
                {
                    document_name: "",
                    document_file: null,
                },
            ],
        }));
    };

    const handleRemoveDocument = (index) => {
        setFormDataDoc((prevFormData) => {
            const newDocuments = [...prevFormData.documents];
            newDocuments.splice(index, 1);
            return {
                ...prevFormData,
                documents: newDocuments,
            };
        });
        setFileNames((prevFileNames) => {
            const newFileNames = [...prevFileNames];
            newFileNames.splice(index, 1);
            return newFileNames;
        });
    };

    const handlePicDelete = async (e, i, getProjects) => {
        e.preventDefault();

        setLoading(true); // loading logic
        const loadingToastId = toast.loading("Loading: Please wait..."); // toast logic

        try {
            let res = await axios.delete(
                `${BASE_URL}/correspondence/documents/${i.id}/`
            );

            if (res.status === 200) {
                await getProjects();
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false); // loading logic
            toast.dismiss(loadingToastId);
        }
    };

    useEffect(() => {
        if (trackRecordList.length > 0) {
            const valuetoshowinoptions = trackRecordList.filter((option) => option?.letter_num !== formData?.letter_num)
            setoptionsList(valuetoshowinoptions);
        }
    }, [trackRecordList])


    const handleChangecc = (selected) => {
        const associated_letters = selected.length > 0 ? selected.map((item) => item.value) : [];

        // Update the formData with the selected associated letters
        setFormData((prevState) => ({
            ...prevState,
            associated_letters,
        }));

        // Check if any selected associated letter does not exist in trackRecordList
        const missingLetters = associated_letters.filter(
            (id) => !trackRecordList.some((record) => record.id === id)
        );


        // If there are missing letters, set associated_letters_status to 'close'
        if (missingLetters.length > 0) {
            setFormData((prevState) => ({
                ...prevState,
                associated_letters_status: 'close', // Update status if missing letters found
            }));
        } else {
            setFormData((prevState) => ({
                ...prevState,
                associated_letters_status: '', // Reset status if all letters are found
            }));
        }
    };
    const [contractorlists, setContractorLists] = useState([]);
    const getProjectContractorDetails = async () => {
        try {
            const contractordetails = await axios.get(
                `${BASE_URL}/project_details/contractorbyproject/${formData.project}/`
            );
            setContractorLists(contractordetails.data);
        } catch (err) {
            // handleErrorToast(err);
        } finally {
        }
    };
    useEffect(() => {
        if (formData.project !== "null") {
            getProjectContractorDetails();
        }
    }, [formData.project]);

    return (
        <>
            <button onClick={handleShow} className="document-download-button  width-5vw  width-5vw" >
                View/Edit
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{title ? title : "Update Track Detailss"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="form-flex-wrap">
                        {sessionStorage.getItem('role') === "SiteManagement" ? "" :

                            ((projectId === 'null' || projectId === undefined || projectId === "") && (
                                <div className="form-group">
                                    <RenderSelectField
                                        title="Projects"
                                        name="project"
                                        required={true}
                                        options={projectList?.sort((a, b) =>
                                            a.project_short_name.localeCompare(b.project_short_name)
                                        )
                                            .map((project) => ({
                                                value: project.id,
                                                label: `${project.site_prcode} - ${project.project_short_name}`,
                                            }))}
                                        placeholder="Select a Project"
                                        formData={formData}
                                        errors={errors}
                                        inputState={inputState}
                                        handleInputChange={handleInputChange}
                                    />
                                    {errors.project && (
                                        <div className="error-message col">
                                            {errors.project}
                                        </div>
                                    )}
                                </div>
                            ))
                        }


                        <div className="form-group">
                            <RenderSelectField
                                title="Letter Exchange"
                                name="letterExchange"
                                required={true}
                                options={[
                                    { value: "send", label: "Send" },
                                    { value: "receive", label: "Received" },
                                ]}
                                placeholder="Select an Exchange Type"
                                formData={formData}
                                errors={errors}
                                inputState={inputState}
                                handleInputChange={handleInputChange}
                            />
                            {errors.letterExchange && (
                                <div className="error-message col">
                                    {errors.letterExchange}
                                </div>
                            )}
                        </div>

                        {formData.letterExchange === "send" && (
                            <div className="form-group">
                                <RenderSelectField
                                    title="Reply By"
                                    name="reply_by"
                                    required={true}
                                    options={[
                                        { value: "HO", label: "Head Office" },
                                        { value: "SO", label: "Site Office" },
                                    ]}
                                    placeholder="Select a Reply By"
                                    formData={formData}
                                    errors={errors}
                                    inputState={inputState}
                                    handleInputChange={handleInputChange}
                                />
                                {errors.reply_by && (
                                    <div className="error-message col">{errors.reply_by}</div>
                                )}
                            </div>
                        )}

                        <div className="form-group">
                            <RenderInputField
                                title={`${toTitleCase(formData.letterExchange)} Letter No.`}
                                name="letter_num"
                                placeholder="Letter Number"
                                formData={formData}
                                errors={errors}
                                required={true}
                                inputState={inputState}
                                handleInputChange={handleInputChange}
                            />
                            {errors.letter_num && (
                                <div className="error-message col">{errors.letter_num}</div>
                            )}
                        </div>

                        <div className="form-group">
                            <RenderInputField
                                title={`${toTitleCase(formData.letterExchange)} Letter Date`}
                                name="letter_date"
                                type="date"
                                max={today}
                                formData={formData}
                                errors={errors}
                                required={true}
                                inputState={inputState}
                                handleInputChange={handleInputChange}
                            />
                            {errors.letter_date && (
                                <div className="error-message col">{errors.letter_date}</div>
                            )}
                        </div>

                        <div className="form-group">
                            <RenderInputTextareaField
                                title="Subject"
                                name="subject"
                                placeholder="Enter subject here..."
                                rows={5}
                                cols={50}
                                formData={formData}
                                required={true}
                                errors={errors}
                                inputState={inputState}
                                handleInputChange={handleInputChange}
                            />
                            {errors.subject && (
                                <div className="error-message col">{errors.subject}</div>
                            )}
                        </div>
                        <div title="Status" className="flex-column form-group-selectt">
                            <label
                                htmlFor="status"
                                className="form-labels  font-weight500    font-size-subheading"
                            >
                                Status<span className="required">*</span>
                            </label>
                            <br />
                            <select
                                id="status"
                                name="status"
                                placeholder="Status"
                                value={formData.status}
                                onChange={handleInputChange}
                                className={`form-input form-group-selection ${errors.status ? "error" : inputState.status ? "success" : ""
                                    }`}

                            >
                                <option value="">Select a Status</option>

                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="submit">Submit</option>

                                <option value="close">Close</option>

                            </select>


                            <div className="form-group-selection-arrow">
                                <DropdownArrowOption />
                            </div>

                            <div>
                                {errors.status && (
                                    <span className="error-message font-size-text ">
                                        {errors.status}
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="form-group">
                            <RenderSelectField
                                title="Letter Type"
                                // disabled
                                name="lettertype"
                                required={true}
                                options={[
                                    { value: "show-cause", label: "Show Cause" },
                                    { value: "informative", label: "Informative" },
                                    { value: "eot", label: "EOT" },
                                    { value: "cos", label: "COS" },
                                    { value: "billing", label: "Billing" },
                                    { value: "design", label: "Design" },
                                    { value: "ncr", label: "NCR" },

                                    { value: "Design & Drawing", label: "Design & Drawing" },
                                    { value: "P&P", label: "P&P" },
                                    { value: "QAP", label: "QAP" },
                                    { value: "Structure", label: "Structure" },
                                    { value: "Q & ME", label: "Q & ME" },
                                    { value: "BBS", label: "BBS" },
                                    { value: "noc", label: "NOC" },
                                    { value: "Road Safety", label: "Road Safety" },
                                    { value: "Work Plan", label: "Work Plan" },
                                    { value: "Drain", label: "Drain" },
                                    { value: "Hydrology", label: "Hydrology" },
                                    { value: "Survey", label: "Survey" },
                                    { value: "Milestone", label: "Milestone" },
                                    { value: "query", label: "Query" },
                                    { value: "SiteProgress", label: "SiteProgress" },
                                    { value: "other", label: "Others" }
                                ]}
                                placeholder="Select a Letter Type"
                                formData={formData}
                                errors={errors}
                                inputState={inputState}
                                handleInputChange={handleInputChange}
                                readOnly
                            />
                            {errors.lettertype && (
                                <div className="error-message col">{errors.lettertype}</div>
                            )}
                        </div>



                        {formData.letterExchange === 'receive' &&
                            <div className="form-group">
                                <RenderInputField
                                    title="Letter From"
                                    name="letter_from"
                                    placeholder="Letter From"
                                    max={100}
                                    formData={formData}
                                    errors={errors}
                                    required={true}
                                    inputState={inputState}
                                    handleInputChange={handleInputChange}
                                />
                                {errors.letter_from && (
                                    <div className="error-message col">
                                        {errors.letter_from}
                                    </div>
                                )}
                            </div>}

                        <div className="form-group">
                            <RenderInputField
                                title="Letter To"
                                name="letter_to"
                                placeholder="Letter To"
                                max={100}
                                required={true}
                                formData={formData}
                                errors={errors}
                                inputState={inputState}
                                handleInputChange={handleInputChange}
                            />
                            {errors.letter_to && (
                                <div className="error-message col">{errors.letter_to}</div>
                            )}
                        </div>
                        <div className="form-group">
                            <RenderInputTextareaField
                                title="Remarks"
                                name="remarks"
                                placeholder="Remarks"
                                rows={5}
                                cols={50}
                                formData={formData}
                                required={true}
                                errors={errors}
                                inputState={inputState}
                                handleInputChange={handleInputChange}
                            />
                            {errors.remarks && (
                                <div className="error-message col">{errors.remarks}</div>
                            )}
                        </div>

                        <div className="flex-column">
                            <label
                                htmlFor="names"
                                className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                            >
                                Associated Letters
                            </label>

                            {/* Select component to show and handle associated letters */}
                            <Select
                                options={optionsList.map((e) => ({
                                    value: e.id,
                                    label: `${e.letter_num}`, // Display the letter number as label
                                }))}
                                isMulti
                                onChange={handleChangecc}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '33vw',
                                        height: '50px',
                                        borderRadius: '10px',
                                        border: '1px solid #e3e3e3',
                                        margin: '10px 0px 20px 0px',
                                        color: '#4a4a4a',
                                        backgroundColor: '#f7f8fa',
                                        padding: '0px 10px',
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        color: '#4a4a4a',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        width: '33vw',
                                        borderRadius: '10px',
                                        marginTop: '0',
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: '#4a4a4a',
                                    }),
                                    input: (provided) => ({
                                        ...provided,
                                        color: '#4a4a4a',
                                    }),
                                }}

                                value={trackRecordList
                                    .filter((option) => formData.associated_letters.includes(option.id))
                                    .map((e) => ({
                                        value: e.id,
                                        label: `${e.letter_num}`, // Pre-selected values showing letter_num
                                    }))}
                            />

                        </div>

                        {formData.associated_letters &&
                            formData.associated_letters.length > 0 && (
                                <RenderSelectField
                                    title="Update Status of Associated Letters"
                                    name="associated_letters_status"
                                    required={true}
                                    options={[
                                        { value: "pending", label: "Pending" },
                                        { value: "close", label: "Close" },
                                    ]}
                                    placeholder="Select Status"
                                    formData={formData}
                                    errors={errors}
                                    inputState={inputState}
                                    handleInputChange={handleInputChange}
                                />
                            )}
                    </div>

                    <>
                        <div className="jd-heading-outer heading-bg-color-white">
                            <div className="jd-heading-outer-flex">
                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                    Documents{" "}
                                </h2>
                                <div>
                                    <button
                                        title="Add Documents"
                                        onClick={handleAddDocuments}
                                        className="upload-svg equal-hieg"
                                        style={{ float: "right" }}
                                    >
                                        <AddwithWhiteCircle /> Document
                                    </button>
                                    {/* <br /> */}
                                </div>
                            </div>
                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>
                        </div>

                        <div className="form-flex-wrap">
                            <table className="table-css">
                                <thead>
                                    <tr className="custom-table-head-tr">
                                        <th className="align-left">S. No.</th>
                                        <th className="align-center">Name</th>
                                        <th className="align-center">File</th>
                                        <th className="align-right width-5vw">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {i?.documents?.map((i, index) => (
                                        <React.Fragment key={index}>
                                            {/* <tr className="tr-border-bottom">
                              <td colSpan="6"></td>
                            </tr> */}
                                            <tr className="custom-table-head-td">
                                                <td className="align-left">{index + 1}</td>
                                                <td className="align-center">{i.document_name}</td>
                                                {/* <td className="align-center">{getFileNameFromLink(i.document_file)}</td> */}
                                                <td className="align-center">
                                                    {i.document_file ? (
                                                        // <a href={i.document_file} target="blank">
                                                        //   View
                                                        // </a>
                                                        <a href={i.document_file} target="blank">
                                                            <DocumentIcon />
                                                        </a>
                                                    ) : (
                                                        "Document Not Attached"
                                                    )}
                                                </td>

                                                <td className="align-right width-5vw ">
                                                    <button
                                                        className="model-delete-button"
                                                        onClick={(e) =>
                                                            handlePicDelete(e, i, getProjects)
                                                        }
                                                    >
                                                        <DeleteDustbin />
                                                    </button>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <hr className="line" />

                        <div title="Documents" className="">
                            {/* <label className="form-labels font-weight500 font-size-subheading">Documents</label> */}
                            {formDataDoc?.documents?.map((doc, index) => (
                                <div key={index} className="expense-req">
                                    <div className="flex-column field-cont-div">
                                        <label
                                            htmlFor={`document_name_${index}`}
                                            className="form-labels announce-date font-weight500 font-size-heading"
                                        >
                                            File Name
                                        </label>
                                        <input
                                            type="text"
                                            id={`document_name_${index}`}
                                            name={`document_name`}
                                            placeholder="Document Name"
                                            value={doc.document_name}
                                            onChange={(e) => handleDocInputChange(index, e)}
                                            className={`form-modal-input ${errors[`document_name_${index}`]
                                                ? "error"
                                                : inputState[`document_name`]
                                                    ? "success"
                                                    : ""
                                                }`}
                                        />
                                        {errors[`document_name_${index}`] && (
                                            <span className="error-message font-size-text">
                                                {errors[`document_name_${index}`]}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column field-cont-div">
                                        <label
                                            htmlFor=""
                                            className="form-labels announce-date font-weight500 font-size-heading"
                                        >
                                            Upload File
                                        </label>
                                        <label
                                            htmlFor={`document_file_${index}`}
                                            className={`form-inputss custom-file-upload ${errors[`document_file_${index}`]
                                                ? "error"
                                                : inputState[`document_file`]
                                                    ? "success"
                                                    : ""
                                                }`}
                                        >
                                            <div className={`align-center pdf-input  ${errors[`document_file_${index}`] ? 'error' : ''}`}>
                                                <Attachment />
                                            </div>
                                        </label>
                                        <input
                                            id={`document_file_${index}`}
                                            name={`document_file`}
                                            type="file"
                                            onChange={(e) => handleDocInputChange(index, e)}
                                            style={{ display: "none", position: "relative" }}
                                        />
                                        {fileNames[index] && (
                                            <p className="file-name align-center">
                                                {fileNames[index]}
                                            </p>
                                        )}

                                        {errors[`document_file_${index}`] && (
                                            <span className="error-message font-size-text">
                                                {errors[`document_file_${index}`]}
                                            </span>
                                        )}
                                    </div>

                                    {index === 0 ? null : (
                                        <button
                                            type="button"
                                            className="model-button-cancel"
                                            onClick={() => handleRemoveDocument(index)}
                                        >
                                            Remove
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>
                    </>
                    <>
                        <div className="jd-heading-outer heading-bg-color-white">
                            <div className="jd-heading-outer-flex">
                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                    Authority Transfer List{" "}
                                </h2>
                                <div>
                                    <AddAssignTO
                                        siteprcode={i.site_prcode}
                                        projectname={i.project_short_name}
                                        letterdate={i.letter_date}
                                        letterno={i.letter_num}
                                        subject={i.subject}
                                        letterId={i.id}
                                        getData={getLettersingle}
                                    />
                                    {/* <br /> */}
                                </div>
                            </div>
                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>
                        </div>

                        <div className="form-flex-wrap">
                            <table className="table-css">
                                <thead className='table-heading'>
                                    <tr className="custom-table-head-tr">
                                        <th className="table-heading-text text-lefttt">S. No.</th>
                                        <th className="table-heading-text">Assigned Work</th>
                                        <th className="table-heading-text">Assigned By</th>
                                        <th className="table-heading-text">Assigned To</th>
                                        <th className="table-heading-text">Your Work</th>
                                        <th className="table-heading-text">Add/View Documents</th>
                                        <th className="table-heading-text text-right">Work Assigned Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {letterdata.letter_tracking?.map((i, index) => (
                                        <React.Fragment key={index}>
                                            {/* <tr className="tr-border-bottom">
                              <td colSpan="6"></td>
                            </tr> */}
                                            <tr className="custom-table-head-td">
                                                <td className="table-body text-lefttt">{index + 1}</td>
                                                <td className="table-body">{i.assiginee_remarks ? i.assiginee_remarks : "-"}</td>
                                                <td className="table-body">{i.assigned_by_name ? i.assigned_by_name : "-"}</td>
                                                <td className="table-body">{i.assigned_to_name ? i.assigned_to_name : "-"}</td>
                                                <td className="table-body">{i.remarks ? i.remarks : "-"}</td>
                                                <td className="text-left">
                                                    {i.documents && i.documents.length > 0 ? (
                                                        <td className="table-body ">
                                                            <div className="flex-row justify-center">
                                                                <DocumentModel letter_tracking={i.id} letterData={letterdata.letter_tracking} title={"Documents"} getDocument={getLettersingle} />
                                                            </div>
                                                        </td>
                                                    ) : (
                                                        "Document Not Attached"
                                                    )}

                                                </td>
                                                <td className="table-body text-right">
                                                    {new Date(i.created_at).toISOString().split('T')[0].split('-').reverse().join('/')}
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <hr className="line" />
                        <div className="button-models">
                            <button
                                onClick={handleFormSubmit}
                                className="model-button   font-weight500    model-button-submit"
                                disabled={loading}
                            >
                                {/* //loading logic */}
                                Update
                            </button>
                        </div>
                    </>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};


const UpdateTrackRecordDetailwithIDonly = ({
    i,
    title,
    getProjects,
    projectList,
    projectId,
    letterType,
    workperformedby_contractor,
    associatedletters,
    letterData,
    show,
    setShow
}) => {

    const handleClose = () => setShow(false);
    const handleShow = async () => {
        setFormData(i);

        // Trigger the API calls when the modal is shown
        await getLettersByID();
        // await getAsociatedLetters();
    };

    useEffect(() => {
        if (show) {
            handleShow();
        }
    }, [show]);

    const [formData, setFormData] = useState({
        letter_num: "",
        project: projectId ? projectId : "null",
        subject: "",
        letter_date: "",
        status: "",
        workperformedby_contractor: workperformedby_contractor ? workperformedby_contractor : "null",
        lettertype: letterType ? letterType : "null",
        letterExchange: "",
        letter_from: "",
        letter_to: "",
        remarks: '',
        associated_letters: associatedletters ? associatedletters : [],
        associated_letters_status: "pending",
        documents: [
            {
                document_name: null,
                document_file: "",
            },
        ],
        other_type_name: '',

    });
    const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format




    const [formDataDoc, setFormDataDoc] = useState({
        documents: [
            {
                document_name: null,
                document_file: "",
            },
        ],
    });




    const getLettersByID = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/correspondence/linked-letter-list/${i.id}/`
            );

            const filteredData = res.data.filter(item => item.id === i.id);
            if (filteredData.length > 0) {
                setFormData(prevState => ({
                    ...prevState,
                    ...filteredData[0], // Merge with existing state
                }));
            }

        } catch (err) {
            handleErrorToast(err);
        }
    };


    const [trackRecordList, setTrackRecordList] = useState([]);
    const getAsociatedLetters = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/correspondence/letterrecordbyfilters/${formData.project
                }/${formData.workperformedby_contractor}/${formData.lettertype
                }`
            );
            setTrackRecordList(res.data);
        } catch (err) {
            // toast.error('Error fetching letters.');
            handleErrorToast(err);
        }
    };

    // useEffect(() => {

    // }, [formData.workperformedby_contractor, formData.project]);

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const requiredFields = [
            // "letter_num",
            // "project",
            // "subject",
            // "letter_date",
            // "status",
            // "lettertype",
            // "workperformedby_contractor",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        const newErrors = requiredFields.reduce((acc, field) => {
            if (
                !formData[field] ||
                (Array.isArray(formData[field]) && formData[field].length === 0)
            ) {
                acc[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required!`;
            }
            return acc;
        }, {});

        if (
            formData.associated_letters &&
            formData.associated_letters.length > 0 &&
            !formData.associated_letters_status
        ) {
            newErrors["associated_letters_status"] =
                "Status for associated letters is required!";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // const handleInputChange = (e) => {
    //   const {name, value} = e.target;

    //   setInputState({
    //     ...inputState,
    //     [name]: value.trim() ? "green" : "",
    //   });

    //   setFormData({
    //     ...formData,
    //     [name]: value,
    //   });
    // };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        // if (name === "lettertype") {
        //   if (value === "informative") {
        //     setFormData({
        //       ...formData,
        //       [name]: value,
        //       status: "informative",
        //     });
        //   } else if (value === "show-cause") {
        //     setFormData({
        //       ...formData,
        //       [name]: value,
        //       status: "show-cause",
        //     });
        //   } else {
        //     setFormData({
        //       ...formData,
        //       [name]: value,
        //     });
        //   }
        // } else {
        //   setFormData({
        //     ...formData,
        //     [name]: value,
        //   });
        // }
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const createCustomFile = (originalFile) => {
        const randomCode = generateRandomString();
        const now = new Date();
        const date = now.toISOString().split("T")[0];
        const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
        const customFileName = `Aimantra ${date} ${time}_${randomCode}_${originalFile.name}`;
        return new File([originalFile], customFileName, {
            type: originalFile.type,
        });
    };

    const generateRandomString = () => {
        const chars =
            "!@#$%^&*()_+abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        return Array.from(
            { length: 8 },
            () => chars[Math.floor(Math.random() * chars.length)]
        ).join("");
    };



    // ?  ************** Validation End **************  ! //

    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                const formDataToSend = new FormData();

                // Append general form fields
                Object.keys(formData).forEach((key) => {
                    if (key !== "documents" && formData[key]) {
                        if (key === "associated_letters") {
                            formData[key].forEach((value) =>
                                formDataToSend.append(key, value)
                            );
                        } else {
                            formDataToSend.append(key, formData[key]);
                        }
                    }
                });

                // Append documents data
                formDataDoc.documents.forEach((doc, index) => {
                    const symbols = "!@#$%^&*()_-+=";
                    const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
                    const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                    const numbers = "0123456789";
                    const now = new Date();
                    const date = now.toLocaleDateString("en-GB").split("/").reverse().join("-");
                    const time = now.toLocaleTimeString("en-GB", { hour12: false }).replace(/:/g, "-");
                    const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
                    let randomCode = "";

                    // Generate random code for unique filename
                    for (let i = 0; i < 8; i++) {
                        const randomIndex = Math.floor(Math.random() * allChars.length);
                        randomCode += allChars[randomIndex];
                    }

                    const originalFile = doc.document_file;
                    const customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
                    const customFile = new File([originalFile], customFileName, {
                        type: originalFile.type,
                    });

                    // Check if the document has a valid file before appending
                    if (doc.document_file) {
                        formDataToSend.append(`documents[${index}][document_name]`, doc.document_name);
                        formDataToSend.append(`documents[${index}][document_file]`, customFile);
                    } else {
                        console.warn(`Document file at index ${index} is not valid.`);
                    }
                });
                let res = await axios.put(
                    `${BASE_URL}/correspondence/documentbulkwithletterupdate/${i.id}/`,
                    formDataToSend,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    setShow(false);
                    await getProjects();
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const [fileNames, setFileNames] = useState([]);

    const handleDocInputChange = (index, e) => {
        const { name, value, type, files } = e.target;

        setFormDataDoc((prevFormData) => {
            const newDocuments = [...prevFormData.documents];
            if (type === "file") {
                newDocuments[index] = {
                    ...newDocuments[index],
                    [name]: files[0],
                };
                setFileNames((prevFileNames) => {
                    const newFileNames = [...prevFileNames];
                    newFileNames[index] = files[0]?.name;
                    return newFileNames;
                });
            } else {
                newDocuments[index] = {
                    ...newDocuments[index],
                    [name]: value.trim() ? value : "",
                };
            }
            return {
                ...prevFormData,
                documents: newDocuments,
            };
        });
    };

    const handleAddDocuments = (e) => {
        e.preventDefault();
        setFormDataDoc((prevFormData) => ({
            ...prevFormData,
            documents: [
                ...prevFormData.documents,
                {
                    document_name: "",
                    document_file: null,
                },
            ],
        }));
    };

    const handleRemoveDocument = (index) => {
        setFormDataDoc((prevFormData) => {
            const newDocuments = [...prevFormData.documents];
            newDocuments.splice(index, 1);
            return {
                ...prevFormData,
                documents: newDocuments,
            };
        });
        setFileNames((prevFileNames) => {
            const newFileNames = [...prevFileNames];
            newFileNames.splice(index, 1);
            return newFileNames;
        });
    };

    const handlePicDelete = async (e, i, getProjects) => {
        e.preventDefault();

        setLoading(true); // loading logic
        const loadingToastId = toast.loading("Loading: Please wait..."); // toast logic

        try {
            let res = await axios.delete(
                `${BASE_URL}/correspondence/documents/${i.id}/`
            );

            if (res.status === 200) {
                await getProjects();
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false); // loading logic
            toast.dismiss(loadingToastId);
        }
    };

    const options = trackRecordList
        .sort((a, b) => parseInt(a.letter_num) - parseInt(b.letter_num))
        .map((e) => ({
            value: e.id,
            label: `${e.letter_num} - ${e.letter_date}`,
        }));






    const handleChangecc = (selected) => {
        const associated_letters =
            selected.length > 0 ? selected.map((item) => item.value) : "";
        setFormData((prevState) => ({
            ...prevState,
            associated_letters,
        }));
    };

    // ? Document End ===============================

    useEffect(() => {
        getAsociatedLetters();
    }, [formData.project, formData.workperformedby_contractor, formData.lettertype]);

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{title ? title : letterData ? "View Associated Letter Details" : "Update Track Details"}</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <div className="form-flex-wrap">
                        <div title="letter ID" className="flex-column">
                            <label
                                htmlFor="letter_num"
                                className="form-labels  font-weight500    font-size-subheading"
                            >
                                Letter No.<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                id="letter_num"
                                name="letter_num"
                                placeholder="Letter Number"
                                onChange={handleInputChange}
                                value={formData.letter_num}
                                className={`form-input ${errors.letter_num
                                    ? "error"
                                    : inputState.letter_num
                                        ? "success"
                                        : ""
                                    }`}
                                disabled={letterData}
                            />
                            {errors.letter_num && (
                                <span className="error-message font-size-text ">
                                    {errors.letter_num}
                                </span>
                            )}
                        </div>

                        <div title="Subject" className="flex-column">
                            <label
                                htmlFor="subject"
                                className="form-labels  font-weight500    font-size-subheading"
                            >
                                Subject<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                id="subject"
                                max={150}
                                name="subject"
                                placeholder="Subject"
                                onChange={handleInputChange}
                                value={formData.subject}
                                disabled={letterData}
                                className={`form-input ${errors.subject
                                    ? "error"
                                    : inputState.subject
                                        ? "success"
                                        : ""
                                    }`}
                            />
                            {errors.subject && (
                                <span className="error-message font-size-text ">
                                    {errors.subject}
                                </span>
                            )}
                        </div>

                        <div title="Letter Date" className="flex-column">
                            <label
                                htmlFor="letter_date"
                                className="form-labels  font-weight500    font-size-subheading"
                            >
                                Letter Date<span className="required">*</span>
                            </label>
                            <input
                                type="date"
                                id="letter_date"
                                name="letter_date"
                                max={today}
                                placeholder="Sent Letter Date"
                                onChange={handleInputChange}
                                value={formData.letter_date}
                                disabled={letterData}

                                className={`form-input ${errors.letter_date
                                    ? "error"
                                    : inputState.letter_date
                                        ? "success"
                                        : ""
                                    }`}
                            />
                            {errors.letter_date && (
                                <span className="error-message font-size-text ">
                                    {errors.letter_date}
                                </span>
                            )}
                        </div>

                        <div
                            title="Letter Type"
                            className="flex-column form-group-selectt"
                        >
                            <label
                                htmlFor="lettertype"
                                className="form-labels  font-weight500    font-size-subheading"
                            >
                                Letter Type<span className="required">*</span>
                            </label>
                            <br />
                            <select
                                id="lettertype"
                                name="lettertype"
                                placeholder="lettertype"
                                value={formData.lettertype}
                                onChange={handleInputChange}
                                disabled
                                className={`form-input form-group-selection ${errors.lettertype
                                    ? "error"
                                    : inputState.lettertype
                                        ? "success"
                                        : ""
                                    }`}

                            >
                                <option value="null">Select Letter Type</option>
                                <option value="eot">EOT</option>
                                <option value="cos">COS</option>
                                <option value="ncr">NCR</option>
                                <option value="billing">Billing</option>
                                <option value="design">Design</option>
                                <option value="informative">Informative</option>
                                <option value="show-cause">Show Cause</option>
                                <option value="Design & Drawing">Design & Drawing</option>
                                <option value="P&P">P&P</option>
                                <option value="QAP">QAP</option>
                                <option value="Structure">Structure</option>
                                <option value="billing">Billing</option>
                                <option value="Q & ME">Q & ME</option>
                                <option value="BBS">BBS</option>
                                <option value="noc">NOC</option>
                                <option value="Road Safety">Road Safety</option>
                                <option value="Work Plan">Work Plan</option>
                                <option value="Drain">Drain</option>
                                <option value="Hydrology">Hydrology</option>
                                <option value="Survey">Survey</option>
                                <option value="Milestone">Milestone</option>
                                <option value="SiteProgress">SiteProgress</option>
                                <option value="query">Query</option>
                                <option value="other">Others</option>


                            </select>
                            <div className="form-group-selection-arrow">

                            </div>
                            <div>
                                {errors.lettertype && (
                                    <span className="error-message font-size-text ">
                                        {errors.lettertype}
                                    </span>
                                )}
                            </div>
                        </div>


                        <div title="Status" className="flex-column form-group-selectt">
                            <label
                                htmlFor="status"
                                className="form-labels  font-weight500    font-size-subheading"
                            >
                                Status<span className="required">*</span>
                            </label>
                            <br />
                            <select
                                id="status"
                                name="status"
                                placeholder="Status"
                                disabled={letterData}
                                value={formData.status}
                                onChange={handleInputChange}
                                className={`form-input form-group-selection ${errors.status ? "error" : inputState.status ? "success" : ""
                                    }`}
                            >
                                <option value="">Select a Status</option>
                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="submit">Submit</option>
                                <option value="close">Close</option>

                            </select>


                            <div className="form-group-selection-arrow">

                            </div>

                            <div>
                                {errors.status && (
                                    <span className="error-message font-size-text ">
                                        {errors.status}
                                    </span>
                                )}
                            </div>
                        </div>


                        <div
                            title="Letter Exchange"
                            className="flex-column form-group-selectt"
                        >
                            <label className="form-labels font-weight500 font-size-subheading">
                                Letter Exchange<span className="required">*</span>
                            </label>
                            <br />
                            <select
                                id="letterExchange"
                                name="letterExchange"
                                value={formData.letterExchange}
                                disabled={letterData}
                                onChange={handleInputChange}
                                className={`form-input form-group-selection ${errors.letterExchange
                                    ? "error"
                                    : inputState.letterExchange
                                        ? "success"
                                        : ""
                                    }`}
                            >
                                <option value="">Select Letter</option>
                                <option value="send">Send</option>
                                <option value="receive">Receive</option>
                            </select>
                            <div className="form-group-selection-arrow">

                            </div>
                            {errors.letterExchange && (
                                <div className="error-message font-size-text">
                                    {errors.letterExchange}
                                </div>
                            )}
                        </div>

                        <div title="Letter From" className="flex-column">
                            <label
                                htmlFor="letter_from"
                                className="form-labels  font-weight500    font-size-subheading"
                            >
                                Letter From<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                id="letter_from"
                                max={100}
                                name="letter_from"
                                disabled={letterData}
                                placeholder="Letter From"
                                onChange={handleInputChange}
                                value={formData.letter_from}
                                className={`form-input ${errors.letter_from
                                    ? "error"
                                    : inputState.letter_from
                                        ? "success"
                                        : ""
                                    }`}
                            />
                            {errors.letter_from && (
                                <span className="error-message font-size-text ">
                                    {errors.letter_from}
                                </span>
                            )}
                        </div>
                        <div title="Letter To" className="flex-column">
                            <label
                                htmlFor="letter_to"
                                className="form-labels  font-weight500    font-size-subheading"
                            >
                                Letter To<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                id="letter_to"
                                max={100}
                                name="letter_to"
                                placeholder="Letter To"
                                disabled={letterData}
                                onChange={handleInputChange}
                                value={formData.letter_to}
                                className={`form-input ${errors.letter_to
                                    ? "error"
                                    : inputState.letter_to
                                        ? "success"
                                        : ""
                                    }`}
                            />
                            {errors.letter_to && (
                                <span className="error-message font-size-text ">
                                    {errors.letter_to}
                                </span>
                            )}
                        </div>
                        {letterData ? "" :
                            <>
                                <div className="flex-column">
                                    <label
                                        htmlFor="names"
                                        className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                    >
                                        Associated Letters
                                    </label>
                                    <Select
                                        options={options}
                                        isMulti
                                        onChange={handleChangecc}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '33vw',
                                                height: '50px',
                                                borderRadius: '10px',
                                                border: '1px solid #e3e3e3',
                                                margin: '10px 0px 20px 0px',
                                                color: '#4a4a4a',
                                                backgroundColor: '#f7f8fa',
                                                padding: '0px 10px',
                                            }),
                                            placeholder: (provided) => ({
                                                ...provided,
                                                color: '#4a4a4a',
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                width: '33vw',
                                                borderRadius: '10px',
                                                marginTop: '0',
                                            }),
                                            singleValue: (provided) => ({
                                                ...provided,
                                                color: '#4a4a4a',
                                            }),
                                            input: (provided) => ({
                                                ...provided,
                                                color: '#4a4a4a',
                                            }),
                                        }}
                                    />
                                    {errors.remarks && (
                                        <span className="error-message font-size-text">
                                            {errors.remarks}
                                        </span>
                                    )}
                                </div>
                                {formData.associated_letters &&
                                    formData.associated_letters.length > 0 && (
                                        <RenderSelectField
                                            title="Update Status of Associated Letters"
                                            name="associated_letters_status"
                                            required={true}
                                            options={[
                                                { value: "pending", label: "Pending" },
                                                { value: "close", label: "Close" },
                                            ]}
                                            placeholder="Select Status"
                                            formData={formData}
                                            errors={errors}
                                            inputState={inputState}
                                            handleInputChange={handleInputChange}
                                        />
                                    )}
                            </>
                        }
                    </div>


                    <>

                        <div className="jd-heading-outer  heading-bg-color-white">
                            <div className="jd-heading-outer-flex ">
                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                    Documents{" "}
                                </h2>
                                <div>

                                    <button
                                        title="Add Documents"
                                        onClick={handleAddDocuments}
                                        className="jd-heading-main font-weight600 -right-button"
                                        style={{ float: "right", backgroundColor: "#2576bc", color: 'white', borderRadius: '8px', marginRight: '10px', padding: '8px' }}
                                    >
                                        <AddwithWhiteCircle /> Document
                                    </button>

                                    <br />
                                </div>
                            </div>
                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>
                        </div>

                        <div className="form-flex-wrap">
                            <table className="table-css">
                                <thead>
                                    <tr className="custom-table-head-tr">
                                        <th className="align-left">S. No.</th>
                                        <th className="align-center">Name</th>
                                        <th className="align-center">File</th>

                                        <th className="align-right width-5vw">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData?.documents?.map((i, index) => (
                                        <React.Fragment key={index}>

                                            <tr className="custom-table-head-td">
                                                <td className="align-left">{index + 1}</td>
                                                <td className="align-center">{i.document_name}</td>

                                                <td className="align-center">
                                                    {i.document_file ? (

                                                        <a href={i.document_file} target="blank">
                                                            <DocumentIcon />
                                                        </a>
                                                    ) : (
                                                        "Document Not Attached"
                                                    )}
                                                </td>

                                                <td className="align-right width-5vw ">
                                                    <button
                                                        className="model-delete-button"
                                                        onClick={(e) =>
                                                            handlePicDelete(e, i, getProjects)
                                                        }
                                                    >
                                                        <DeleteDustbin />
                                                    </button>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <hr className="line" />
                        {!letterData &&
                            <>
                                <div title="Documents" className="">
                                    {/* <label className="form-labels font-weight500 font-size-subheading">Documents</label> */}
                                    {formDataDoc?.documents?.map((doc, index) => (
                                        <div key={index} className="expense-req">
                                            <div className="flex-column field-cont-div">
                                                <label
                                                    htmlFor={`document_name_${index}`}
                                                    className="form-labels announce-date font-weight500 font-size-heading"
                                                >
                                                    File Name
                                                </label>
                                                <input
                                                    type="text"
                                                    id={`document_name_${index}`}
                                                    name={`document_name`}
                                                    placeholder="Document Name"
                                                    value={doc.document_name}
                                                    onChange={(e) => handleDocInputChange(index, e)}
                                                    className={`form-modal-input ${errors[`document_name_${index}`]
                                                        ? "error"
                                                        : inputState[`document_name`]
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                />
                                                {errors[`document_name_${index}`] && (
                                                    <span className="error-message font-size-text">
                                                        {errors[`document_name_${index}`]}
                                                    </span>
                                                )}
                                            </div>

                                            <div className="flex-column field-cont-div">
                                                <label
                                                    htmlFor=""
                                                    className="form-labels announce-date font-weight500 font-size-heading"
                                                >
                                                    Upload File
                                                </label>
                                                <label
                                                    htmlFor={`document_file_${index}`}
                                                    className={`form-inputss custom-file-upload ${errors[`document_file_${index}`]
                                                        ? "error"
                                                        : inputState[`document_file`]
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                >
                                                    <div className={`align-center pdf-input  ${errors[`document_file_${index}`] ? 'error' : ''}`}>
                                                        <Attachment />
                                                    </div>
                                                </label>
                                                <input
                                                    id={`document_file_${index}`}
                                                    name={`document_file`}
                                                    type="file"
                                                    onChange={(e) => handleDocInputChange(index, e)}
                                                    style={{ display: "none", position: "relative" }}
                                                />
                                                {fileNames[index] && (
                                                    <p className="file-name align-center">
                                                        {fileNames[index]}
                                                    </p>
                                                )}

                                                {errors[`document_file_${index}`] && (
                                                    <span className="error-message font-size-text">
                                                        {errors[`document_file_${index}`]}
                                                    </span>
                                                )}
                                            </div>

                                            {index === 0 ? null : (
                                                <button
                                                    type="button"
                                                    className="model-button-cancel"
                                                    onClick={() => handleRemoveDocument(index)}
                                                >
                                                    Remove
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                </div>

                                <div className="button-models">
                                    <button
                                        onClick={handleFormSubmit}
                                        className="model-button   font-weight500    model-button-submit"
                                        disabled={loading}
                                        type="submit"

                                    >
                                        {/* //loading logic */}
                                        Update
                                    </button>
                                </div>
                            </>
                        }
                    </>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>


            </Modal>
        </>
    );
};

const DeleteTrackAndLetterDetails = ({ i, getLetterDetail }) => {
    const [show, setshow] = useState(false);
    const handleClose = () => {
        setshow(false);
    };
    const handleShow = () => {
        setshow(true);
    };

    const handleDelete = async (e) => {
        e.preventDefault();
        try {
            const ress = await axios.delete(
                `${BASE_URL}/correspondence/letterrecord/${i.id}/`
            );
            if (ress.status === 200) {
                await getLetterDetail();
                setshow(false);
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Letter Records {i.letter_num}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Letter Records {i.letter_num}
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500    model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DocumentModel = ({ officerent, vehicle, employee, getDocument, siteVehicle, employeeData, rentData, p_id, title, letter_tracking, letterData, letterrecord, usedFor }) => {
    const [show, setShow] = useState(false);
    const [toggleState, setToggleState] = useState(1);
    const [formData, setFormData] = useState([
        {
            document_name: "",
            document_file: null,
            vehicledocs: vehicle ? vehicle : "",
            employeedocs: employee ? employee : "",
            miscellaneous_docs: p_id ? p_id : "",
            document_type: "",
            officerent: officerent ? officerent : "",
            letter_tracking: letter_tracking ? letter_tracking : "",
            letterrecord: letterrecord ? letterrecord : "",
        },
    ]);


    console.log("letterData");
    console.log(letterData);


    useEffect(() => {
        if (title === "Documents" || title === "Letters") {
            setToggleState(2);
        }
    }, [title]);


    const [uploadProgress, setUploadProgress] = useState(0);
    const [loading, setLoading] = useState(false);
    const fileInputRefs = useRef([]);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        setFormData([
            {
                document_name: "",
                document_file: null,
                vehicledocs: vehicle || "",
                employeedocs: employee || "",
                miscellaneous_docs: p_id || "",
                document_type: "",
                officerent: officerent || "",
                letter_tracking: letter_tracking || "",
                letterrecord: letterrecord || "",

            },
        ]);
    }, [vehicle, employee, p_id, officerent, letter_tracking, letterrecord]);

    const refresh = () => {
        setFormData(
            [{
                document_name: "",
                document_file: "",
                vehicledocs: vehicle ? vehicle : "",
                employeedocs: employee ? employee : "",
                miscellaneous_docs: p_id ? p_id : "",
                document_type: "",
                officerent: officerent ? officerent : "",
                letter_tracking: letter_tracking ? letter_tracking : "",
                letterrecord: letterrecord ? letterrecord : "",


            },]
        )
    }
    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false);
        if (title === "Letters" || title === "Documents") {
            setToggleState(2);

        }
        else {

            setToggleState(1);
        }
        refresh();
    };

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => {
            const newDocuments = [...prevFormData];
            newDocuments[index] = {
                ...newDocuments[index],
                [name]: value,
            };
            return newDocuments;
        });

        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (value.trim() !== "") {
                delete newErrors[`${index}-${name}`];
            }
            return newErrors;
        });
    };

    // const handleFileChange = (e, index) => {
    //   const file = e.target.files[0];
    //   setFormData((prevFormData) => {
    //     const newDocuments = [...prevFormData];
    //     newDocuments[index] = {
    //       ...newDocuments[index],
    //       document_file: file,
    //     };
    //     return newDocuments;
    //   });

    //   // Clear the file error when a file is selected
    //   setErrors((prevErrors) => {
    //     const newErrors = { ...prevErrors };
    //     if (file) {
    //       delete newErrors[`${index}-document_file`];
    //     }
    //     return newErrors;
    //   });
    // };

    const handleFileChange = (e, index) => {
        const file = e.target.files[0];

        if (file) {
            // Allowed file types
            const allowedTypes = [
                "application/pdf",  // PDF
                "application/zip", "application/x-zip-compressed",  // ZIP
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
                "application/vnd.ms-excel"  // XLS
            ];

            if (!allowedTypes.includes(file.type) && !file.name.match(/\.(zip|pdf|xls|xlsx)$/)) {
                toast.error("Only ZIP, PDF, and Excel files are allowed!");
                return;
            }

            setFormData((prevFormData) => {
                const newDocuments = [...prevFormData];
                newDocuments[index] = {
                    ...newDocuments[index],
                    document_file: file,
                };
                return newDocuments;
            });

            setErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors[`${index}-document_file`];
                return newErrors;
            });
        }
    };




    const addNewDocument = () => {
        setFormData((prevFormData) => [
            ...prevFormData,
            {
                document_name: "",
                document_file: null,
                vehicledocs: vehicle || "",
                employeedocs: employee || "",
                miscellaneous_docs: p_id || "",
                document_type: "",
                officerent: officerent || "",
                letter_tracking: letter_tracking || "",

            },
        ]);
        fileInputRefs.current.push(null);
    };


    const handleRemoveDocument = (index) => {
        setFormData((prevFormData) => prevFormData.filter((_, i) => i !== index));
        fileInputRefs.current.splice(index, 1);
    };

    const handleClear = (index) => {
        setFormData((prevFormData) => {
            const newDocuments = [...prevFormData];
            newDocuments[index] = {
                ...newDocuments[index],
                document_file: null,
            };
            return newDocuments;
        });

        if (fileInputRefs.current[index]) {
            fileInputRefs.current[index].value = "";
        }
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors[`${index}-document_file`];
            return newErrors;
        });
    };

    const validateForm = () => {
        const newErrors = {};

        formData.forEach((doc, index) => {
            if (!doc.document_name.trim()) {
                newErrors[`${index}-document_name`] = "Document Name is required!";
            }

            if (title !== "Miscellaneous Document" && title !== "Document" && !doc.document_type.trim()) {
                newErrors[`${index}-document_type`] = "Document Type is required ";
            }

            if (!doc.document_name.trim()) {
                newErrors[`${index}-document_name`] = "Document Name is required!";
            }
            if (!doc.document_file) {
                newErrors[`${index}-document_file`] = "Document file is required!";
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    useEffect(() => {
        console.log("FormData updated:", formData);
    }, [formData]);

    useEffect(() => {
        console.log("p_id updated:", p_id);
    }, [p_id]);


    console.log(errors)


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true); //loading logic

            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            const formDataToSend = new FormData();

            // formData.forEach((doc, index) => {

            // });

            for (let [index, doc] of formData.entries()) {
                formDataToSend.append(`documents[${index}].document_name`, doc.document_name);

                if (doc.employeedocs) {
                    formDataToSend.append(`documents[${index}].employeedocs`, doc.employeedocs);
                }
                if (doc.vehicledocs) {
                    formDataToSend.append(`documents[${index}].vehicledocs`, doc.vehicledocs);
                }
                // if (doc.miscellaneous_docs) {
                let fileIndex = 0;

                if (doc.document_file) {
                    const fileId = await uploadFileInChunks(doc.document_file, doc.document_name, setUploadProgress);
                    if (!fileId) {
                        console.error(`❌ Failed to upload file: ${doc.document_name}`);
                        continue; // Skip this file instead of returning
                    }
                    console.log(doc, "documents")
                    formDataToSend.append("file_ids", fileId);
                    formDataToSend.append(`documents[${fileIndex}][document_name]`, doc.document_name);
                    // const fileNameWithoutExt = doc.document_file.name.substring(0, doc.document_file.name.lastIndexOf('.')) || doc.document_file.name;
                    // formDataToSend.append(`documents[${fileIndex}][original_filename]`, doc.document_file.file);
                    formDataToSend.append(`documents[${fileIndex}][original_filename]`, doc.document_file.name);

                    fileIndex++; // Ensure indices remain correct


                }


                if (!formDataToSend.has("file_ids")) {
                    console.error("❌ No valid files were uploaded.");
                    setLoading(false);
                    return;
                }

                // formDataToSend.append(`documents[${index}].miscellaneous_docs`, doc.miscellaneous_docs);
                // }
                if (doc.officerent) {
                    formDataToSend.append(`documents[${index}].officerent`, doc.officerent);
                }
                if (doc.miscellaneous_docs) {
                    formDataToSend.append(`documents[${index}].miscellaneous_docs`, doc.miscellaneous_docs);
                }
                if (doc.letter_tracking) {
                    formDataToSend.append(`documents[${index}].letter_tracking`, doc.letter_tracking);
                }
                if (doc.document_file) {
                    formDataToSend.append(`documents[${index}].document_file`, doc.document_file);
                }
                if (doc.document_type) {
                    formDataToSend.append(`documents[${index}].document_type`, doc.document_type);
                }
            }


            try {
                const response = await axiosInstance.post(
                    `/correspondence/documentbulk/`,
                    formDataToSend,
                    {
                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            setUploadProgress(percentCompleted);
                        },
                    },
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                if (response.status === 200) {
                    getDocument();


                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Document added successfully!");
                    // refresh();
                }

            } catch (error) {
                // handleErrorToast(error);

            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);

                setUploadProgress(0);
            }
        }
    };

    const [DocumentData, setDocumentData] = useState([]);
    const getDocuments = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/correspondence/documentwithletterget/${letterrecord}/`)
            setDocumentData(res.data)
        } catch (error) {
            console.error(error);

        }
    }

    console.log("letterrecord");
    console.log(letterrecord);

    useEffect(() => {
        if (show === true) {
            getDocuments();
        }
    }, [letterrecord, show])

    console.log("uploadProgress");
    console.log(uploadProgress);




    return (
        <>
            {vehicle || officerent || title === "Document" ?
                <>
                    <button title="Add/View Document" className="document-download-button  width-5vw  width-5vw" onClick={handleShow}>
                        Add/View
                    </button>
                </>
                :
                (title === "Documents") ?
                    <button
                        onClick={handleShow}
                        className=""
                        style={{
                            // marginBottom: "10px",
                            height: usedFor === "table" ? "20px" : usedFor === "nestedTable" ? "0px" : "30px",
                            width: usedFor === "table" ? "3vw" : usedFor === "nestedTable" ? "0vw" : "5vw",
                            borderRadius: usedFor === "table" ? "6px" : "10px",
                            fontSize: usedFor === "nestedTable" ? "12px" : "14px"

                        }}
                    >
                        <span className="view-text">View</span>
                    </button>

                    :
                    (title === "Letters") ?
                        <button title="View Document" className="upload-svg" onClick={handleShow}>
                            View Letters
                        </button>
                        :

                        <button title="Add Document" className="upload-svg" onClick={handleShow}>
                            <AddwithWhiteCircle />{""} {title}
                        </button>
            }
            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title>

                        {toggleState === 1 ? `Add ${title}` : `View ${title}`}



                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* {title !== "Miscellaneous Document" &&
            <div className="bloc-tabss wfm-marginn">
              <button
                className={
                  toggleState === 1
                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                }
                onClick={() => setToggleState(1)}
              >
                Add {title}
              </button>

              <button
                className={
                  toggleState === 2
                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                }
                onClick={() => setToggleState(2)}
              >
                View {title}
              </button>



            </div>
          } */}
                    {/* {title !== "Miscellaneous Document" &&&
            <div className="bloc-tabss wfm-marginn">
              <button
                className={
                  toggleState === 1
                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                }
                onClick={() => setToggleState(1)}
              >
                Add {title}
              </button>

              <button
                className={
                  toggleState === 2
                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                }
                onClick={() => setToggleState(2)}
              >
                View {title}
              </button>



            </div>
          } */}
                    {(title !== "Miscellaneous Document" && title !== "Documents" && title !== "Letters") && (
                        <div className="bloc-tabss wfm-marginn">
                            <button
                                className={
                                    toggleState === 1
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                                }
                                onClick={() => setToggleState(1)}
                            >
                                Add {title}
                            </button>

                            <button
                                className={
                                    toggleState === 2
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                                }
                                onClick={() => setToggleState(2)}
                            >
                                View {title}
                            </button>



                        </div>
                    )}
                    {toggleState === 1 &&
                        <div className="flex-row justify-end">
                            <button onClick={addNewDocument} className="upload-svg ">
                                <AddwithWhiteCircle />
                                {" "} Another Document
                            </button>
                        </div>

                    }
                    <div className="content-tabs">
                        {
                            toggleState === 1 ?
                                <>
                                    {formData.map((data, index) => (
                                        <div className="flex-row justify-between" key={index}>
                                            <div className="flex-column">
                                                <label htmlFor="document_name" className="form-labels font-weight500 font-size-subheading">
                                                    Document Name<span className="required">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="document_name"
                                                    value={data.document_name}
                                                    onChange={(e) => handleInputChange(e, index)}
                                                    placeholder="Document Name"
                                                    className="form-input width-15vw"
                                                />
                                                {errors[`${index}-document_name`] && (
                                                    <span className="error-message font-size-text">
                                                        {errors[`${index}-document_name`]}
                                                    </span>
                                                )}
                                            </div>
                                            {(title !== "Miscellaneous Document" && title !== "Document") &&
                                                <div title="Document Type" className="flex-column">
                                                    <label htmlFor="document_type" className="form-labels  font-weight500    font-size-subheading">
                                                        Document Type <span className="required">*</span>
                                                    </label>
                                                    <select
                                                        id="document_type"
                                                        name="document_type"
                                                        value={formData.document_type}
                                                        onChange={(e) => handleInputChange(e, index)}
                                                        className="form-input width-15vw"

                                                    >
                                                        <option value="null">Select Document Type </option>
                                                        <option value="actual">Actual Document</option>
                                                        <option value="boq">Boq Document</option>
                                                    </select>

                                                    {errors[`${index}-document_type`] && (
                                                        <span className="error-message font-size-text">
                                                            {errors[`${index}-document_type`]}
                                                        </span>
                                                    )}

                                                </div>

                                            }
                                            <div className="upload-button-field">
                                                <div title="Upload Document" className="flex-column">
                                                    <label htmlFor={`document_file_${index}`} className="form-labels font-weight500 font-size-subheading">
                                                        Upload Document<span className="required">*</span>
                                                    </label>
                                                    <div className="flex-row justify-between">
                                                        <div >
                                                            <label htmlFor={`document_file_${index}`} className="svg-icon">
                                                                <div className="svg-field form-input align-center">
                                                                    <Attachment />
                                                                </div>

                                                            </label>
                                                            <input
                                                                type="file"
                                                                id={`document_file_${index}`}
                                                                name="document_file"
                                                                accept=".zip, .pdf, .xls, .xlsx"
                                                                style={{ display: "none" }}
                                                                onChange={(e) => handleFileChange(e, index)}
                                                                ref={(el) => (fileInputRefs.current[index] = el)}
                                                            />
                                                        </div>
                                                        <div style={{ width: "6vw" }}>
                                                            {data.document_file && (
                                                                <span className="file-name">
                                                                    {data.document_file.name}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="flex-row justify-between" style={{ width: "12vw" }}>
                                                            <button title="Clear File" onClick={() => handleClear(index)} className="file-clear clear-button">
                                                                Clear
                                                            </button>
                                                            {formData.length > 1 && (
                                                                <button title="Remove Document" onClick={() => handleRemoveDocument(index)} className="file-clear clear-button">
                                                                    Remove
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {errors[`${index}-document_file`] && (
                                                        <span className="error-message font-size-text">
                                                            {errors[`${index}-document_file`]}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    {uploadProgress > 0 && (
                                        <div className="progress-bar">
                                            <h6 className="uploading-percentage">Uploading {uploadProgress}%</h6>
                                            <div className="progress-bar-fill" style={{ width: `${uploadProgress}%` }}></div>

                                        </div>
                                    )}

                                    <div className="button-models">
                                        <button
                                            onClick={handleSubmit}
                                            className="model-button font-weight500 model-button-submit"
                                            disabled={loading}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </> :
                                <>

                                    <div className='table-overflow'>

                                        <table className="table-css">
                                            <thead>
                                                <tr className="custom-table-head-tr ">
                                                    <th className="table-heading-text">S.No.</th>
                                                    <th className="table-heading-text">Document Name</th>
                                                    {(title !== "Miscellaneous Document" && title !== "LetterTracking" && title !== "Documents" && title !== "Letters" && title !== "Document") &&
                                                        <th className="table-heading-text">Document Type</th>
                                                    }
                                                    <th className="table-heading-text text-center">Document</th>
                                                    {(title !== "Miscellaneous Document" && title !== "LetterTracking" && title !== "Documents" && title !== "Letters") &&
                                                        <th className="table-heading-text text-right">Action</th>
                                                    }
                                                </tr>
                                            </thead>

                                            <tbody
                                            >
                                                {vehicle && (

                                                    siteVehicle
                                                        .filter((v) => v.id === vehicle) // Find the vehicle that matches the passed vehicle ID
                                                        .flatMap((v) => v.documents) // Get the documents for the matched vehicle
                                                        .filter((doc) => doc.vehicledocs === vehicle) // Ensure the document belongs to the vehicle
                                                        .map((doc, docIndex) => (
                                                            <React.Fragment key={docIndex}>
                                                                <tr className="custom-table-head-td">
                                                                    <td className="table-body">{docIndex + 1}.</td>
                                                                    <td className="table-body">{doc.document_name}</td>
                                                                    <td className="table-body">{doc.document_type}</td>
                                                                    <td className="table-body">
                                                                        {doc.document_file ? (
                                                                            // <a href={i.document_file} target="blank">
                                                                            //   View
                                                                            // </a>
                                                                            <a href={doc.document_file} target="blank">
                                                                                <div className="flex-row justify-center">
                                                                                    <DocumentIcon />
                                                                                </div>
                                                                            </a>
                                                                        ) : (
                                                                            "Document Not Attached"
                                                                        )}
                                                                    </td>
                                                                    <td className="table-body">

                                                                        <div className="flex-row justify-end">
                                                                            <DeleteDocuments i={doc} getDocument={getDocument} />
                                                                        </div>
                                                                    </td>

                                                                </tr>
                                                            </React.Fragment>

                                                        ))
                                                )}
                                                {employee && (
                                                    employeeData.document
                                                        .map((doc, docIndex) => (
                                                            <React.Fragment key={docIndex}>
                                                                <tr className="custom-table-head-td">
                                                                    <td className="align-left">{docIndex + 1}</td>
                                                                    <td className="align-center">{doc.document_name}</td>
                                                                    <td className="align-center">{doc.document_type}</td>
                                                                    <td className="align-center">
                                                                        {doc.document_file ? (
                                                                            <a href={doc.document_file} target="_blank" rel="noopener noreferrer">
                                                                                <DocumentIcon />
                                                                            </a>
                                                                        ) : (
                                                                            "Document Not Attached"
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <div className="flex-row justify-end">
                                                                            <DeleteDocuments i={doc} getDocument={getDocument} />
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </React.Fragment>
                                                        ))
                                                )}
                                                {officerent && (
                                                    rentData?.filter((v) => v.id === officerent)
                                                        .flatMap((v) => v?.documents)
                                                        .filter((doc) => doc.officerent === officerent) // Ensure the document belongs to the vehicle
                                                        .map((doc, docIndex) => (
                                                            <React.Fragment key={docIndex}>
                                                                <tr className="custom-table-head-td">
                                                                    <td className="table-body">{docIndex + 1}.</td>
                                                                    <td className="table-body">{doc.document_name}</td>
                                                                    <td className="table-body">{doc.document_type}</td>
                                                                    <td className="table-body">
                                                                        {doc.document_file ? (
                                                                            // <a href={i.document_file} target="blank">
                                                                            //   View
                                                                            // </a>
                                                                            <a href={doc.document_file} target="blank">
                                                                                <div className="flex-row justify-center">
                                                                                    <DocumentIcon />
                                                                                </div>
                                                                            </a>
                                                                        ) : (
                                                                            "Document Not Attached"
                                                                        )}
                                                                    </td>

                                                                    <td className="table-body">
                                                                        <div className="flex-row justify-end">
                                                                            <DeleteDocuments i={doc} getDocument={getDocument} />
                                                                        </div>
                                                                    </td>

                                                                </tr>
                                                            </React.Fragment>

                                                        ))
                                                )}
                                                {letter_tracking && (
                                                    letterData?.filter((v) => v.id === letter_tracking) // Find the vehicle that matches the passed vehicle ID
                                                        .flatMap((v) => v?.documents) // Get the documents for the matched vehicle
                                                        .filter((doc) => doc.letter_tracking === letter_tracking) // Ensure the document belongs to the vehicle
                                                        .map((doc, docIndex) => (
                                                            <React.Fragment key={docIndex}>
                                                                <tr className="custom-table-head-td">
                                                                    <td className="table-body">{docIndex + 1}.</td>
                                                                    <td className="table-body">{doc.document_name}</td>
                                                                    <td className="table-body">
                                                                        {doc.document_file ? (
                                                                            // <a href={i.document_file} target="blank">
                                                                            //   View
                                                                            // </a>
                                                                            <a href={doc.document_file} target="blank">
                                                                                <div className="flex-row justify-center">
                                                                                    <DocumentIcon />
                                                                                </div>
                                                                            </a>
                                                                        ) : (
                                                                            "Document Not Attached"
                                                                        )}
                                                                    </td>
                                                                    {title === "Document" &&
                                                                        <td className="table-body">
                                                                            <div className="flex-row justify-end">
                                                                                <DeleteDocuments i={doc} getDocument={getDocument} />
                                                                            </div>
                                                                        </td>
                                                                    }

                                                                </tr>
                                                            </React.Fragment>

                                                        ))
                                                )}
                                                {letterrecord && (
                                                    DocumentData
                                                        .map((doc, docIndex) => (
                                                            <React.Fragment key={docIndex}>
                                                                <tr className="custom-table-head-td">
                                                                    <td className="table-body">{docIndex + 1}.</td>
                                                                    <td className="table-body">{doc.document_name}</td>
                                                                    <td className="table-body">
                                                                        {doc.document_file ? (
                                                                            // <a href={i.document_file} target="blank">
                                                                            //   View
                                                                            // </a>
                                                                            <a href={doc.document_file} target="blank">
                                                                                <div className="flex-row justify-center">
                                                                                    <DocumentIcon />
                                                                                </div>
                                                                            </a>
                                                                        ) : (
                                                                            "Document Not Attached"
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            </React.Fragment>

                                                        ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                        }
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal >

        </>
    );
};
const DeleteDocuments = ({ i, getDocument }) => {
    const [show, setshow] = useState(false);
    const handleClose = () => {
        setshow(false);
    };
    const [loading, setLoading] = useState(false);

    const handleShow = () => {
        setshow(true);
    };

    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true); //loading logic
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            const ress = await axios.delete(
                `${BASE_URL}/correspondence/documents/${i.id}/`
            );
            if (ress.status === 200) {
                await getDocument();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Document deleted successfully!");
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false); //loading logic
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Document {i.document_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Document {i.document_name}
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500    model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};




const AddAssignTO = ({ siteprcode, projectname, letterno, subject, letterdate, letterId, assignemail, getData }) => {

    const [show, setShow] = useState(false);
    const name = sessionStorage.getItem("name");
    const email = sessionStorage.getItem("email");
    const [empList, setEmpList] = useState([]);
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const FRONTEND_URL = urlParts[0] + `//` + urlParts[2];



    const handleClose = () => {
        setShow(false);
        setFormData({
            concern_personname: "",
            subject: subject,
            letter_no: letterno,
            assignedbyname: name,
            due_date: "",
            project_code: siteprcode,
            project_name: projectname,
            assigned_to: "",
            link: "",
            concern_person_email: "",
            assiginee_remarks: "",
            remarks: "",
            assignedbyemail: email,
            assigned_by: email,
            letter_id: letterId,
            documents: [],
        })
        setErrors({});
    };
    const handleShow = () => {
        setShow(true);
        getEmployee();
    }
    const [formData, setFormData] = useState({
        concern_personname: "",
        subject: subject,
        letter_no: letterno,
        due_date: "",
        assignedbyname: name,
        project_code: siteprcode,
        project_name: projectname,
        link: "",
        concern_person_email: "",
        assigned_to: "",
        assiginee_remarks: "",
        remarks: "",
        assignedbyemail: email ? email : assignemail,
        assigned_by: email ? email : assignemail,
        letter_id: letterId,
        documents: [],
    });


    const linkk = `${FRONTEND_URL}/LetterExchange/${letterId}/${formData.assigned_to}/`
    const getEmployee = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/manpower/getemprole/`);
            setEmpList(res.data);
        } catch (error) {
            console.error(error);
        }
    };

    console.log("formData");
    console.log(formData)

    // const handleEmployeeChange = (e) => {
    //   const selectedValue = e.target.value;
    //   const selectedEmployee = empList.find(emp => emp.employee === selectedValue);

    //   if (selectedEmployee) {

    //     setFormData({
    //       ...formData,
    //       concern_personname: selectedEmployee.name,
    //       assigned_to: selectedEmployee.employee,
    //       concern_person_email: selectedEmployee.employee,
    //     });

    //     setErrors(prevErrors => {
    //       const updatedErrors = { ...prevErrors };
    //       delete updatedErrors.concern_personname;
    //       delete updatedErrors.concern_person_email;
    //       return updatedErrors;
    //     });
    //   }
    // };

    // const handleEmployeeChange = (selectedOption) => {
    //   if (selectedOption) {
    //     setFormData({
    //       ...formData,
    //       concern_personname: selectedOption.name,
    //       assigned_to: selectedOption.employee,
    //       concern_person_email: selectedOption.employee,
    //     });



    //     setErrors((prevErrors) => {
    //       const updatedErrors = { ...prevErrors };
    //       delete updatedErrors.concern_personname;
    //       delete updatedErrors.concern_person_email;
    //       return updatedErrors;
    //     });


    //   }

    // };

    const handleEmployeeChange = (selectedOption) => {
        if (!selectedOption) {
            // Reset to null when cleared
            setFormData({
                ...formData,
                concern_personname: "",
                assigned_to: "",
                concern_person_email: "",
            });
        } else {
            setFormData({
                ...formData,
                concern_personname: selectedOption.name,
                assigned_to: selectedOption.employee,
                concern_person_email: selectedOption.employee,
            });
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.concern_personname;
            delete updatedErrors.concern_person_email;
            return updatedErrors;
        });
    };

    const employeeOptions = [
        { value: "null", label: "Select Employee" },
        ...empList.map((emp) => ({
            value: emp.employee,
            label: `${emp.emp_code} - ${emp.name}`,
            name: emp.name,
            employee: emp.employee,
        })),
    ];


    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            link: linkk,
            project_code: siteprcode,
            project_name: projectname,
            subject: subject,
            letter_no: letterno,
            letter_id: letterId,
            assigned_by: email ? email : assignemail
        }))
    }, [linkk, siteprcode, projectname, subject, letterno, letterId, email, assignemail])


    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const validateForm = () => {
        const newErrors = {};

        if (!formData.assigned_to) {
            newErrors.assigned_to = "Employee is required!";
        }

        if (!formData.assiginee_remarks) {
            newErrors.assiginee_remarks = "Assigned work is required!";
        }
        if (assignemail && !formData.remarks) {
            newErrors.remarks = "Your Work is required!";
        }


        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };


    console.log("formData.createdAt")
    console.log(formData.createdAt)

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (value) {
                delete updatedErrors[name];
            }
            return updatedErrors;
        });
    };



    // ?  ************** Validation End **************  ! //

    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);

            try {
                const today = new Date();
                today.setDate(today.getDate() + 5); // Add 5 days
                const dueDate = today.toISOString().split("T")[0]; // Format YYYY-MM-DD

                let res = await axios.post(`${BASE_URL}/correspondence/letter-assign-mail-post/`, {
                    ...formData,
                    due_date: dueDate, // Set due_date dynamically
                });

                if (res.status === 200) {
                    await getData();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Work Assigned Successfully");


                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err);
                console.error(err);

            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };



    return (
        <>

            <button title="Assign To" className="upload-svg" onClick={handleShow}>
                <AddwithWhiteCircle />
                {" "} Assign Work
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw" >
                <Modal.Header closeButton className=" task-Tab-heading font-weight500    font-size-heading ">
                    <Modal.Title>Assign Work</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">

                            <div className="flex-column">
                                <div className="form-group">
                                    <div className="flex-column form-group-selectt">
                                        <label
                                            htmlFor="assigned_to"
                                            className="form-labels  font-weight500    font-size-subheading"
                                        >
                                            Employee <span className="required">*</span>
                                        </label>
                                        <br />
                                        {/* <select id="assigned_to"
                        name="assigned_to"
                        placeholder="assigned_to"
                        value={formData.assigned_to}
  
                        onChange={handleEmployeeChange}
                        className={`form-input form-group-selection ${errors.assigned_to ? "error" : inputState.assigned_to ? "success" : ""
                          }`}
                      >
                        <option value="">Select an Employee</option>
                        {empList?.sort((a, b) => a.emp_code.localeCompare(b.emp_code, 'en', { ignorePunctuation: true }))
                          .map((i) => (
                            <option key={i.employee} value={i.employee}>
                              {i.emp_code} - {i.name}
                            </option>
                          ))}
                      </select> */}

                                        <Select
                                            options={employeeOptions}
                                            onChange={handleEmployeeChange}
                                            value={employeeOptions.find(option => option.value === formData.assigned_to)}
                                            placeholder="Select or Search Employee"
                                            // className={`form-input ${errors.assigned_to ? "error" : inputState.assigned_to ? "success" : ""}`}
                                            isSearchable
                                            isClearable
                                            noOptionsMessage={() => "No other options"}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: '33vw',
                                                    height: '50px',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e3e3e3',
                                                    margin: '10px 0px 20px 0px',
                                                    color: '#4a4a4a',
                                                    backgroundColor: '#f7f8fa',
                                                    padding: '0px 10px',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    width: '33vw',
                                                    borderRadius: '10px',
                                                    marginTop: '0',
                                                    zIndex: 5,
                                                }),
                                                menuPortal: (provided) => ({
                                                    ...provided,
                                                    zIndex: 5,
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                            }}

                                        />




                                        {/* <DropdownArrow /> */}

                                    </div>
                                    {errors.assigned_to && (
                                        <div className="error-message font-size-text">{errors.assigned_to}</div>
                                    )}
                                </div>
                                {assignemail &&
                                    <div className="flex-column">
                                        <label htmlFor="remarks" className="form-labels  font-weight500    font-size-subheading">
                                            Your Work<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            maxLength={50}
                                            id="remarks"
                                            name="remarks"
                                            placeholder="Your Work"
                                            onChange={handleInputChange}
                                            value={formData.remarks}
                                            className={`form-input ${errors.remarks ? "error" : inputState.tile ? "success" : ""
                                                }`}
                                        />
                                        {errors.remarks && (
                                            <span className="error-message font-size-text ">{errors.remarks}</span>
                                        )}
                                    </div>
                                }
                                <div className="flex-column">
                                    <label htmlFor="assiginee_remarks" className="form-labels  font-weight500    font-size-subheading">
                                        Assigned Work<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={50}
                                        id="assiginee_remarks"
                                        name="assiginee_remarks"
                                        placeholder="Assigned Work"
                                        onChange={handleInputChange}
                                        value={formData.assiginee_remarks}
                                        className={`form-input ${errors.assiginee_remarks ? "error" : inputState.tile ? "success" : ""
                                            }`}
                                    />
                                    {errors.assiginee_remarks && (
                                        <span className="error-message font-size-text ">{errors.assiginee_remarks}</span>
                                    )}
                                </div>



                                <div className="button-models">
                                    <button className="model-button   font-weight500   model-button-cancel" type="button" onClick={handleClose}>
                                        Cancel
                                    </button>
                                    <button
                                        //   type="submit"
                                        className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                        onClick={handleFormSubmit}
                                        disabled={loading}
                                    >
                                        Submit
                                    </button>
                                </div>

                            </div>

                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

                </Modal.Body>
            </Modal>
        </>
    );
};

const AssociatedLetters = ({ id, workperformedby_contractor, letterType, associated_letters, LetterData, usedFor }) => {
    const [show, setShow] = useState(false);
    const [letterList, setLetterList] = useState([]); // Main letter data

    const handleShow = () => {
        setShow(true);
    }
    const handleClose = () => setShow(false);

    const getLetters = async () => {
        console.log('called')
        try {
            const res = await axios.get(
                `${BASE_URL}/correspondence/letter-associated/${id}/`
            );
            setLetterList(res.data);
            console.log({ res: res.data })
        } catch (error) {
            console.error("Error fetching initial letters:", error);
        }
    };


    useEffect(() => {
        if (show === true) {
            getLetters();

        }
    }, [show]);

    const fetchLetterDetails = async (id) => {
        try {
            const res = await axios.get(
                `${BASE_URL}/correspondence/letter-associated/${id}/`
            );
            return res.data;
        } catch (error) {
            console.error(`Error fetching details for Letter ID ${id}:`, error);
            return null;
        }
    };

    const RenderLetter = ({ letter, level = 0 }) => {
        const { letter_num, associated_letters = [] } = letter;

        const [showNestedLetters, setShowNestedLetters] = useState(false);
        const [nestedLettersData, setNestedLettersData] = useState([]); // Temporarily store nested letter data

        const toggleNestedLetters = async () => {
            if (showNestedLetters) {
                setShowNestedLetters(false); // Collapse
                setNestedLettersData([]); // Remove data when collapsing
            } else {
                setShowNestedLetters(true); // Expand
                const data = await Promise.all(
                    associated_letters.map((id) => fetchLetterDetails(id))
                );
                setNestedLettersData(data.filter((item) => item !== null)); // Set nested letter data
            }
        };

        return (
            <div style={{ marginLeft: `${level * 20}px` }}>
                <div style={{ display: "flex" }}>
                    <div className="arrow-set">
                        <ArrowBullet />
                    </div>

                    <div className="letter-card">
                        <div className="letter-card-header">
                            <span style={{ margin: "6px" }}>
                                Letter Number: {letter_num}
                            </span>
                            <div>
                                {associated_letters.length > 0 && (
                                    <button onClick={toggleNestedLetters}>
                                        <span className="view-text">{showNestedLetters ? "Close" : "View"}</span>
                                    </button>
                                )}
                            </div>
                        </div>

                        <div style={{ margin: "20px 20px 20px 10px" }}>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="padding-bottom-5px">Reply of </td>
                                        <td className="padding-bottom-5px" style={{ padding: "0px 4px" }}>:</td>
                                        <td className="padding-bottom-5px">
                                            {associated_letters.length > 0 ?
                                                <>{letter.associated_letters_get.map(i => i.letter_num).join(",")}</> :
                                                "No Associated Letter"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="padding-bottom-5px">Letter Date </td>
                                        <td className="padding-bottom-5px" style={{ padding: "0px 4px" }}>:</td>
                                        <td className="padding-bottom-5px">{letter.letter_date}</td>
                                    </tr>
                                    <tr>
                                        <td className="padding-bottom-5px">View Letter </td>
                                        <td className="padding-bottom-5px" style={{ padding: "0px 4px" }}>:</td>

                                        <td className="padding-bottom-5px">
                                            {
                                                LetterData ?
                                                    <UpdateTrackRecordDetailwithIDonly
                                                        i={letter}
                                                        projectId={letter.project}
                                                        workperformedby_contractor={letter.workperformedby_contractor}
                                                        letterType={letter.lettertype}
                                                        getProjects={getLetters}
                                                        letterData={LetterData}
                                                    />
                                                    :
                                                    <UpdateTrackRecordDetailwithIDonly
                                                        i={letter}
                                                        projectId={letter.project}
                                                        workperformedby_contractor={letter.workperformedby_contractor}
                                                        letterType={letter.lettertype}
                                                        getProjects={getLetters}
                                                    />
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Render child letters only if expanded */}
                {showNestedLetters &&
                    nestedLettersData.map((childLetter, index) => (
                        <div className="nested-letters" key={index}>
                            <RenderLetter letter={childLetter} level={level + 1} />
                        </div>
                    ))}
            </div>
        );
    };

    useEffect(() => {
        if (show === true) {
            getLetters();
        }
    }, [id, show]);

    return (
        <>
            <button
                onClick={handleShow}
                className=""
                style={{
                    // marginBottom: "10px",
                    height: usedFor === "table" ? "20px" : usedFor === "nestedTable" ? "0px" : "30px",
                    width: usedFor === "table" ? "3vw" : usedFor === "nestedTable" ? "0vw" : "5vw",
                    borderRadius: usedFor === "table" ? "6px" : "10px",
                    fontSize: usedFor === "nestedTable" ? "12px" : "14px"

                }}
            >
                <span className="view-text" >View</span>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title>View Letters</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Letter data={letterList} />
                    {/* <div className="letter-list-container scroll-container" style={{ border: "none" }}>
            <div className="scrollbar" style={{ border: "none" }} >
              {letterList?.letter_num ? (
                <RenderLetter letter={letterList} />
              ) : (
                <p className="no-letters-text">No letters found</p>
              )}

            </div>
          </div> */}
                </Modal.Body>
            </Modal >
        </>
    );
};


const ViewLetterModal = ({ i, usedFor, projectID }) => {
    const tableRef = useRef(null);

    const [show, setShow] = useState(false);
    const [letterData, setLetterData] = useState({});

    const handleClose = () => {
        setShow(false);
    }

    const handleShow = () => {
        setShow(true);
    };

    const [buffer, setBuffering] = useState(false);

    const getLetterData = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/correspondence/letterrecordbyID/${i}/`);
            setLetterData(res.data);
        } catch (error) {
            console.error(error);

        }
    };

    useEffect(() => {
        getLetterData();
    }, [i]);

    function calculateDaysBetweenDates(targetDate) {
        if (!targetDate) return '-';

        const today = new Date();
        const givenDate = new Date(targetDate);

        // Remove time portion for accurate difference
        today.setHours(0, 0, 0, 0);
        givenDate.setHours(0, 0, 0, 0);

        const diffTime = Math.abs(givenDate.getTime() - today.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays;
    }


    return (
        <>
            <button
                onClick={handleShow}
                className=""
                style={{
                    // marginBottom: "10px",
                    height: usedFor === "table" ? "20px" : usedFor === "nestedTable" ? "0px" : "30px",
                    width: usedFor === "table" ? "3vw" : usedFor === "nestedTable" ? "0vw" : "5vw",
                    borderRadius: usedFor === "table" ? "6px" : "10px",
                    fontSize: usedFor === "nestedTable" ? "12px" : "14px"

                }}
            >
                <span className="view-text" >View</span>
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton>
                    <Modal.Title>
                        View Letter Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='table-box scroll-container-table'>
                        <div >

                            <table ref={tableRef} className="table-css">
                                <thead className='table-heading'>
                                    <tr className='custom-table-head-tr'>
                                        <th className='table-heading-text text-left-sr'>S.no.</th>
                                        <th className='table-heading-text'>Letter No.</th>
                                        <th className='table-heading-text'>Subject</th>

                                        <th className='table-heading-text text-center'>Letter Details</th>
                                        <th className='table-heading-text text-center'>Dates</th>
                                        <th className='table-heading-text text-center'>From/To</th>

                                    </tr>
                                </thead>
                                {buffer ? (
                                    <></>
                                ) :
                                    <tbody>
                                        <React.Fragment>
                                            <tr className="custom-table-head-td ">
                                                <td className='table-body text-left-sr'>1.</td>
                                                <td className="table-body form-text-transformation-uppercase">
                                                    <div
                                                        style={{
                                                            width: "120px",
                                                            wordBreak: "break-word",
                                                            whiteSpace: "normal",
                                                        }}
                                                    >
                                                        {letterData.letter_num}
                                                    </div>
                                                </td>
                                                <td className='table-body'><div style={{ width: "100px", whiteSpace: "normal" }}>{letterData.subject ? letterData.subject : <p className=''>-</p>}</div></td>

                                                <td className="table-body width-20vw">
                                                    <div className="flex-column align-items-center">

                                                        <table>
                                                            <tbody className="table-body">
                                                                <tr>
                                                                    <td className="padding-bottom-5px text-start">Exchange Type</td>
                                                                    <td style={{ padding: "0px 10px" }}>:</td>
                                                                    <td className="text-start">
                                                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                            {letterData?.letterExchange
                                                                                ? letterData?.letterExchange
                                                                                : "-"}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="padding-bottom-5px text-start">Letter Type</td>
                                                                    <td style={{ padding: "0px 10px" }}>:</td>
                                                                    <td className="text-start">
                                                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                            {letterData?.lettertype
                                                                                ? letterData?.lettertype
                                                                                : "-"}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="padding-bottom-5px text-start">Status</td>
                                                                    <td style={{ padding: "0px 10px" }}>:</td>
                                                                    <td className="text-start">
                                                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                            {letterData?.status
                                                                                ? letterData?.status
                                                                                : "-"}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="padding-bottom-5px text-start">TAT Duration</td>
                                                                    <td style={{ padding: "0px 10px" }}>:</td>
                                                                    <td className="text-start">
                                                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                            {letterData?.tat_duration
                                                                                ? letterData?.tat_duration
                                                                                : "-"}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="padding-bottom-5px text-start">Due Days</td>
                                                                    <td style={{ padding: "0px 10px" }}>:</td>
                                                                    <td className="text-start">
                                                                        <div style={{ width: "100px", whiteSpace: "normal" }}>

                                                                            {letterData?.end_date ? calculateDaysBetweenDates(letterData?.end_date) : "-"}

                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="padding-bottom-5px text-start">Remarks</td>
                                                                    <td style={{ padding: "0px 10px" }}>:</td>
                                                                    <td className="text-start">
                                                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                            {letterData?.remarks
                                                                                ? <CustomModel i={letterData?.remarks} usedFor="nestedTable" title="Remarks" />
                                                                                : "-"}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>

                                                                    <td className="padding-bottom-5px text-start">Associated Letters</td>
                                                                    <td style={{ padding: "0px 10px" }}>:</td>
                                                                    <td className="text-start">
                                                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                            {letterData?.associated_letters?.length > 0
                                                                                ?
                                                                                <AssociatedLetters usedFor="nestedTable" id={letterData?.id} />
                                                                                : <p className=''>-</p>}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="padding-bottom-5px text-start">View Letter</td>
                                                                    <td style={{ padding: "0px 10px" }}>:</td>
                                                                    <td className="text-start">
                                                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                            <DocumentModel letterrecord={letterData?.id} letterData={letterData?.letter_tracking} title={"Documents"} getDocument={getLetterData} usedFor="nestedTable" />
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td className="table-body width-15vw">
                                                    <div className="flex-column align-items-center">
                                                        <table>
                                                            <tbody className="table-body">
                                                                <tr>
                                                                    <td className="padding-bottom-5px text-start">Letter Date</td>
                                                                    <td style={{ padding: "0px 10px" }}>:</td>
                                                                    <td className="text-start">{letterData.letter_date !== null ? formattedDateLong(letterData.letter_date) : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="padding-bottom-5px text-start">Letter Add</td>
                                                                    <td style={{ padding: "0px 10px" }}>:</td>
                                                                    <td className="text-start">{letterData.created_at !== null ? formattedDateLong(letterData.created_at) : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="padding-bottom-5px text-start">Deadline</td>
                                                                    <td style={{ padding: "0px 10px" }}>:</td>
                                                                    <td className="text-start">{letterData.end_date !== null ? formattedDateLong(letterData.end_date) : "-"}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td className="table-body width-15vw">
                                                    <div className="flex-column align-items-center">

                                                        <table>
                                                            <tbody className="table-body">
                                                                <tr>
                                                                    <td className="padding-bottom-5px text-start">Letter From</td>
                                                                    <td style={{ padding: "0px 10px" }}>:</td>
                                                                    <td className="text-start">
                                                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                            {letterData.letter_from
                                                                                ? letterData.letter_from
                                                                                : "-"}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="padding-bottom-5px text-start">Letter To</td>
                                                                    <td style={{ padding: "0px 10px" }}>:</td>
                                                                    <td className="text-start">
                                                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                            {letterData.letter_to
                                                                                ? letterData.letter_to
                                                                                : "-"}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    </tbody>
                                }
                            </table>


                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )



}



const CustomModel = ({ i, usedFor, title }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    }
    const handleShow = () => {
        setShow(true);
    }
    return (
        <>
            <button
                onClick={handleShow}
                className=""
                style={{
                    // marginBottom: "10px",
                    height: usedFor === "table" ? "20px" : usedFor === "nestedTable" ? "0px" : "30px",
                    width: usedFor === "table" ? "3vw" : usedFor === "nestedTable" ? "0vw" : "5vw",
                    borderRadius: usedFor === "table" ? "6px" : "10px",
                    fontSize: usedFor === "nestedTable" ? "12px" : "14px"

                }}
            >
                <span className="view-text" >View</span>
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="custom-modal">
                <Modal.Header closeButton>
                    <Modal.Title>
                        View {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{i}</p>
                </Modal.Body>
            </Modal>
        </>
    )
}

const CalculateDaysBetweenDates = ({ targetDate }) => {
    if (!targetDate) return '-';

    const today = new Date();
    const givenDate = new Date(targetDate);

    // Remove time portion for accurate difference
    today.setHours(0, 0, 0, 0);
    givenDate.setHours(0, 0, 0, 0);

    const diffTime = Math.abs(givenDate.getTime() - today.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
}

const Card = ({
    letter,
    letterNum,
    replyBy,
    letterDate,
    status,
    onToggle,
    isExpanded,
    showToggleAll,
    toggleAllLabel,
    onToggleAll,
    isHighlighted
}) => {
    const [showDetails, setShowDetails] = useState(false);
    return (
        <div style={{ width: 'fit-content', display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
            <div style={{ rotate: isExpanded ? '90deg' : '0deg' }}><ArrowBullet /></div>
            <div style={{ flex: 1, boxSizing: 'border-box', padding: '12px' }}>
                <div
                    style={{
                        display: 'flex',
                        backgroundColor: isHighlighted ? (status === 'pending' ? '#e3f2fd' : '#CFF1CF') : '#f9f9f9',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        boxShadow: isHighlighted ? (status === 'pending' ? '0 0 0 2px #1976d2' : '0 0 0 2px green') : 'none',
                        transition: 'all 0.2s ease'
                    }}
                >
                    <div style={{ width: '5px', backgroundColor: status === 'pending' ? '#2576bc' : 'green' }} />
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '12px', gap: '10px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <label style={{ fontWeight: 500 }}>Letter Number: {letterNum}</label>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                {onToggle && (
                                    <div
                                        style={{
                                            fontSize: '16px',
                                            fontWeight: 600,
                                            color: '#2576bc',
                                            cursor: 'pointer',
                                            marginLeft: '15px'
                                        }}
                                        onClick={onToggle}
                                    >
                                        {isExpanded ? 'Hide' : 'View'}
                                    </div>
                                )}
                                {showToggleAll && (
                                    <div
                                        style={{
                                            fontSize: '16px',
                                            fontWeight: 600,
                                            color: '#2576bc',
                                            cursor: 'pointer'
                                        }}
                                        onClick={onToggleAll}
                                    >
                                        {toggleAllLabel}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '25px', fontSize: '14px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label>Reply by:</label>
                                <label>Letter Date:</label>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label>{replyBy || '-'}</label>
                                <label>{letterDate || '-'}</label>
                            </div>
                        </div>
                        <div onClick={() => setShowDetails(true)} style={{ boxSizing: 'border-box', cursor: 'pointer', padding: '8px', paddingLeft: '0px' }}>Letter Details</div>
                        <UpdateTrackRecordDetailwithIDonly show={showDetails} setShow={setShowDetails} i={letter} projectId={letter.id} workperformedby_contractor={letter.workperformedby_contractor} letterType={letter.letterType} />
                    </div>
                </div>
            </div>
        </div>
    )
};

const LetterNode = ({
    letter,
    node,
    expandedNodes,
    toggleNode,
    showToggleAll,
    toggleAllLabel,
    onToggleAll,
    isRoot = false,
    highlightStatus,
    highlightLetterId,
    isReversed
}) => {
    const isExpanded = expandedNodes.has(node.letter_num);
    const nodeRef = useRef();

    useEffect(() => {
        if (highlightLetterId === node.letter_num && nodeRef.current) {
            nodeRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [highlightLetterId]);

    const handleToggle = () => toggleNode(node.letter_num);

    const children = node.associated_letters_hierarchy || [];

    return (
        <div style={{ marginLeft: '20px' }} ref={nodeRef}>
            {!isReversed && (
                <>
                    <Card
                        letter={node}
                        letterNum={node.letter_num}
                        replyBy={node.reply_by}
                        letterDate={node.letter_date}
                        status={node.status}
                        onToggle={children.length ? handleToggle : null}
                        isExpanded={isExpanded}
                        showToggleAll={isRoot && showToggleAll}
                        toggleAllLabel={toggleAllLabel}
                        onToggleAll={onToggleAll}
                        isHighlighted={highlightStatus === node.status || highlightLetterId === node.letter_num}
                    />
                    {isExpanded && children.map((child) => (
                        <LetterNode
                            letter={child}
                            key={child.letter_num}
                            node={child}
                            expandedNodes={expandedNodes}
                            toggleNode={toggleNode}
                            showToggleAll={false}
                            toggleAllLabel={toggleAllLabel}
                            onToggleAll={onToggleAll}
                            highlightStatus={highlightStatus}
                            highlightLetterId={highlightLetterId}
                            isReversed={isReversed}
                        />
                    ))}
                </>
            )}

            {isReversed && (
                <>
                    {isExpanded && children.map((child) => (
                        <LetterNode
                            letter={child}
                            key={child.letter_num}
                            node={child}
                            expandedNodes={expandedNodes}
                            toggleNode={toggleNode}
                            showToggleAll={false}
                            toggleAllLabel={toggleAllLabel}
                            onToggleAll={onToggleAll}
                            highlightStatus={highlightStatus}
                            highlightLetterId={highlightLetterId}
                            isReversed={isReversed}
                        />
                    ))}
                    <Card
                        letter={node}
                        letterNum={node.letter_num}
                        replyBy={node.reply_by}
                        letterDate={node.letter_date}
                        status={node.status}
                        onToggle={children.length ? handleToggle : null}
                        isExpanded={isExpanded}
                        showToggleAll={isRoot && showToggleAll}
                        toggleAllLabel={toggleAllLabel}
                        onToggleAll={onToggleAll}
                        isHighlighted={highlightStatus === node.status || highlightLetterId === node.letter_num}
                    />
                </>
            )}
        </div>
    );
};

const Letter = ({ data }) => {
    const [expandedNodes, setExpandedNodes] = useState(new Set());
    const [allNodeIds, setAllNodeIds] = useState(new Set());
    const [highlightStatus, setHighlightStatus] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [highlightLetterId, setHighlightLetterId] = useState(null);
    const [isReversed, setIsReversed] = useState(false);

    useEffect(() => {
        const ids = new Set();
        const collectIds = (node) => {
            ids.add(node.letter_num);
            node.associated_letters_hierarchy?.forEach(collectIds);
        };
        collectIds(data);
        setAllNodeIds(ids);
    }, [data]);

    useEffect(() => {
        if (!searchQuery) {
            setHighlightLetterId(null);
            return;
        }

        const lowerQuery = searchQuery.toLowerCase();
        const expanded = new Set();

        const traverse = (node, parentIds = []) => {
            if (node.letter_num.toLowerCase().includes(lowerQuery)) {
                parentIds.forEach((id) => expanded.add(id));
                setHighlightLetterId(node.letter_num);
            }
            node.associated_letters_hierarchy?.forEach((child) =>
                traverse(child, [...parentIds, node.letter_num])
            );
        };

        traverse(data);
        setExpandedNodes(expanded);
    }, [searchQuery, data]);

    const toggleNode = (id) => {
        setHighlightStatus(null);
        setHighlightLetterId(null);
        setExpandedNodes((prev) => {
            const newSet = new Set(prev);
            newSet.has(id) ? newSet.delete(id) : newSet.add(id);
            return newSet;
        });
    };

    const allExpanded = allNodeIds.size > 0 && allNodeIds.size === expandedNodes.size;

    const toggleAll = () => {
        setHighlightStatus(null);
        setHighlightLetterId(null);
        setExpandedNodes(allExpanded ? new Set() : new Set(allNodeIds));
    };

    const countStatuses = (node) => {
        let pending = 0;
        let close = 0;

        const traverse = (n) => {
            if (n.status === 'pending') pending++;
            if (n.status === 'close') close++;
            n.associated_letters_hierarchy?.forEach(traverse);
        };

        node.associated_letters_hierarchy?.forEach(traverse);
        return { pending, close };
    };

    const { pending, close } = countStatuses(data);

    return (
        <div>
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    boxSizing: 'border-box',
                    padding: 8,
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    gap: '30px'
                }}
            >
                <div style={{ borderRadius: '8px', marginLeft: '50px', boxSizing: 'border-box', padding: '4px', backgroundColor: '#f9f9f9', marginRight: 'auto' }}>
                    <input
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Search by Letter Number"
                        style={{
                            height: '30px',
                            fontSize: '14px',
                            padding: '0px 5px',
                            borderRadius: '4px',
                            width: '300px',
                            border: 'none',
                            outline: 'none',
                            backgroundColor: '#fff'
                        }}
                    />
                </div>
                <div style={{ marginBottom: '10px', textAlign: 'center' }}>
                    <button
                        onClick={() => {
                            const next = !isReversed;
                            setIsReversed(next);
                            if (next) setExpandedNodes(new Set(allNodeIds)); // expand all on reverse
                        }}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#2576bc',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        {isReversed ? 'Show Parent to Child' : 'Show Child to Parent'}
                    </button>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }} onClick={toggleAll}>
                    <div style={{ height: 15, width: 15, borderRadius: '50%', backgroundColor: '#343a40' }} />
                    <label style={{ color: 'black', cursor: 'pointer' }}>Total ({pending + close})</label>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }} onClick={() => setHighlightStatus(highlightStatus === 'pending' ? null : 'pending')}>
                    <div style={{ height: 15, width: 15, borderRadius: '50%', backgroundColor: '#2576bc' }} />
                    <label style={{ color: 'black', cursor: 'pointer' }}>Pending ({pending})</label>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }} onClick={() => setHighlightStatus(highlightStatus === 'close' ? null : 'close')}>
                    <div style={{ height: 15, width: 15, borderRadius: '50%', backgroundColor: 'green' }} />
                    <label style={{ color: 'black', cursor: 'pointer' }}>Closed ({close})</label>
                </div>
            </div>

            {data.associated_letters_hierarchy?.[0] && (
                <LetterNode
                    letter={data}
                    node={data.associated_letters_hierarchy[0]}
                    expandedNodes={expandedNodes}
                    toggleNode={toggleNode}
                    showToggleAll={true}
                    toggleAllLabel={allExpanded ? 'Hide All' : 'View All'}
                    onToggleAll={toggleAll}
                    isRoot
                    highlightStatus={highlightStatus}
                    highlightLetterId={highlightLetterId}
                    isReversed={isReversed}
                />
            )}
        </div>
    );
};




export {
    AddLetterLinked,
    UpdateTrackRecordDetailwithIDonly,
    AssociatedLetters,
    DocumentModel,
    DeleteDocuments,
    UpdateTrackRecordDetails,
    AddAssignTO,
    DeleteTrackAndLetterDetails,
    CustomModel,
    CalculateDaysBetweenDates,
    ViewLetterModal,
    Letter

}